'use strict';

// ============================================================================
// DashboardMainController - Merged from DashboardController and MainController
// This controller combines both dashboard and main controller functionality
// to enable sharing a single instance across dashboard and dashboard.main states
// ============================================================================

import urlParse from 'url-parse';

import get from 'lodash/get';

import filter from 'lodash/filter';

import includes from 'lodash/includes';

import assign from 'lodash/assign';

import replace from 'lodash/replace';

import mean from 'lodash/mean';

import last from 'lodash/last';

import forEach from 'lodash/forEach';

import some from 'lodash/some';

import find from 'lodash/find';

import isEmpty from 'lodash/isEmpty';

import {MATOMO_ANALYTICS} from '@techsee/techsee-common/lib/analytic-scripts/matomo-analytics';

import {bulkEmailSharingModeEnum} from '@techsee/techsee-common/lib/constants/account.constants.js';

import {countryCodes} from '@techsee/techsee-country-codes/lib/index';

import {BLACKLIST_FEATURES} from '@techsee/techsee-common/lib/constants/blacklist-features.constants';

import {InteractionSummaryHelperService} from '../../_react_/services/InteractionSummaryHelperService';
import TsUtils from '@techsee/techsee-common/lib/utils';

import {
    UserType,
    ReasonForClosing,
    AddressTypesEnum,
    MeetingMode,
    FailureTriggerAction,
    UserInteractionTriggerAction,
    PhotoStreamReasonKeys,
    RECORDING_STATUS,
    AppLauncherTypesEnum,
    SESSION_SOURCE
} from '@techsee/techsee-common/lib/constants/room.constants';

import {WifiScanStatusType, VisualScanStatusType} from '@techsee/techsee-common/lib/constants/utils.constant';
import {VersionStatus, PlatformType} from '@techsee/techsee-common/lib/constants/utils.constant';
import utils from '@techsee/techsee-common/lib/utils';

import {senderTypes} from '@techsee/techsee-common/lib/constants/resource.constants';

import {ConnectionStatesEnum} from '../../_react_/services/Session/SessionContracts';

// Dialog controller and view
import {TimeoutDialogController} from '../../_react_/components/timeout-dialog/TimeoutDialog.controller';

import {ClientTimeoutDialogController} from '../../_react_/modals/client-timeout-dialog/ClientTimeoutDialog.controller';

import {EndMeetingModalController} from '../../_react_/modals/end-meeting-modal/EndMeetingModal.controller';

import {
    AGENT_QOS_LOG_INTERVAL,
    API_TO_HINTER_MAP,
    OBSERVATION_LOG_INTERVAL,
    SENDING_TIMEOUT_INTERVAL,
    ENDING_TIMEOUT,
    LOCATION_ADDRESS_STATUS,
    LOCATION_ICONS,
    VIDEO_DURATION_LOG_INTERVAL,
    VIDEO_TRAFFIC_LOG_INTERVAL,
    MEDIA_SERVICE,
    RECORDING_FAILED_TIMEOUT,
    RECORDING_ERROR_COLOR,
    RECORDING_MESSAGE_ALERT_TIMEOUT,
    OBSERVER_JOIN_ALERT_TIMEOUT,
    OBSERVER_ALERT_COLOR,
    USER_REDIRECTED_TIMEOUT,
    POINTER_UNAVAILABLE_MESSAGE_ALERT_TIMEOUT,
    POINTER_UNAVAILABLE_MESSAGE_ALERT_COLOR,
    DS_CONTROL_REQUEST_APPROVED_COLOR,
    DS_CONTROL_REQUEST_APPROVED_TIMEOUT,
    DS_CONTROL_STOPPED_COLOR,
    DS_CONTROL_STOPPED_TIMEOUT,
    CG_INFORMATIVE_COLOR
} from './dashboard.settings';

import {getRootStore} from '../../_react_/app.bootstrap';

import {RedirectToStoreController} from '../../_react_/states/dashboard/store/redirectToStore.controller';

import {FallbackModeController} from '../../_react_/components/fallback-mode/controller';

import {updateFallbackModesNotification} from '../../_react_/components/fallback-mode/helper';

import {ModeSwitchModalController} from '../../_react_/components/mode-switch-confirmation-modal/controller';

import {
    ConnectivityIssuePopupController,
    ConnectivityIssueEvents
} from '../../_react_/components/connectivity-issue-popup/controller';

import {DashboardGuidanceController} from '../../_react_/states/dashboard/dashboard-guidance/controller';

import {DashboardTopBarController} from '../../_react_/states/dashboard/dashboard-top-bar/controller';

import {DashboardFooterController} from '../../_react_/states/dashboard/footer/controller';

import {DashboardLeftBarController} from '../../_react_/states/dashboard/left-bar/controller';

import {
    SpinnerBackgroundColors,
    SpinnerColors,
    SpinnerSizes,
    SpinnerTypeOptions
} from '@techsee/techsee-ui-common/lib/spinner';

import {runInAction, action, computed, reaction} from 'mobx';

import {NetworkInfo} from '../../_react_/models/LiveSessionState';

import {SessionClientType, SessionClientRole} from '@techsee/techsee-media-service/lib/MediaConstants';

import {getAppTracer} from '../../app.tracer';

import {EventEmitter} from 'events';

import {MediaStatsDataCollector} from '../../_react_/services/media-service-api/MediaStatsDataCollector';

import {stateByMode} from '@techsee/techsee-common/lib/constants/meeting.states.definition';

import {onSocketVersionHandler} from '../../_react_/services/Session/SessionEventHandler';

import {SimpleModalController} from '../../_react_/components/simple-modal/controller';

import {MessageType} from '../../_react_/services/JsApiService';

import {NotificationController} from '../../_react_/components/notification-modal/controller';

import {
    BandwidthLevel,
    BANDWIDTH_LAST_SAMPLE
} from '../../_react_/services/ts-bandwidth-measurement/ts-bandwidth-measurement.service';

import {openLinkInNewTab} from '../../_react_/states/helper/general.helper.ts';

import {CopilotService} from '../../_react_/services/CopilotService';

import {TsImageEditorController} from '../../_react_/components/ts-image-editor/ts-image-editor.controller';

import {getDashboardStores} from '../../_react_/states/dashboard/dashboard.stores';

import {CONNECTION_STATUS} from '../../_react_/services/ts-locale-helper/ts-locale-helper.settings';

import AnnotationBarController from '../../_react_/components/ts-annotation-bar/ts-annotation-bar.controller';

import {TsEndMeetingController} from '../../_react_/components/ts-end-meeting/ts-end-meeting.controller';

import {SharingState} from '../../_react_/states/dashboard/sharing-state/sharing.state';

import {CountrySelectController} from '../../_react_/components/ts-country-select/ts-country-select.controller';

import findIndex from 'lodash/findIndex';

import HistoryResourcesController from '../../_react_/states/dashboard/right-bar/history-resources.controller';

import {ActionTypes} from '../../_react_/services/ts-sharing-service/contracts';

import {ToastColors} from '../../_react_/components/ts-toast/component';

import {SessionSummaryController} from '../../_react_/components/session-summary';

import {RestApiService} from '@techsee/techsee-client-infra/lib/services/RestApiService';

import {ErrorDialogController} from '../../_react_/components/error-dialog';

import {SurveyModalEvents, SurveyModalController} from '../../_react_/modals/survey-modal/SurveyModal.controller';

import {ThankYouModalController} from '../../_react_/modals/thank-you-modal/ThankYouModal.controller';

import reduce from 'lodash/reduce';

import isUndefined from 'lodash/isUndefined';

import cloneDeep from 'lodash/cloneDeep';

import debounce from 'lodash/debounce';

import map from 'lodash/map';
import tsDate from '@techsee/techsee-date';

import concat from 'lodash/concat';

import {CustomerHistoryModalController} from '../../_react_/modals/customer-history-modal/CustomerHistoryModal.controller';

import {SearchResultsDialogController} from '../../_react_/modals/search-result-dialog/SearchResultDialog.controller';

import {ScanResultModalController} from '../../_react_/modals/scan-result-modal/ScanResultModal.controller';

import {SCANNERS} from '../../_react_/services/ts-scan/ts-scan.settings';

import {SCAN_TYPE} from '@techsee/techsee-common/lib/constants/scan.constants';

import {ConnectionTypesEnum} from '../../_react_/services/Session/SessionContracts';

import {KnownMediaStream, NO_REQUESTED_STREAM} from '@techsee/techsee-media-service/lib/MediaConstants';

import InteractionSummaryEventService, {
    InteractionSummaryEvents
} from '@techsee/techsee-ui-components/lib/interaction-summary/eventService';

import {resolveLogoUrl} from '../../_react_/utils/logo-url.utils';

import {
    ANNOTATION_COLORS,
    CLIENT_IN_PHOTO_MODE_STATES,
    IMAGE_MODES,
    IOS_DEVICES,
    PHOTO_SELECTION_STATE,
    RESOURCE_TYPES,
    STORAGE_TYPES,
    VIDEO_MODES,
    MIN_INTERVAL_TO_DRAW_MAGIC_MARKER,
    MIN_ALLOWED_STROKE_LENGTH
} from './main/main.settings.js';

import {TriggeredDataCollectionSource} from '@techsee/techsee-common/lib/constants/account.constants';

import {SpeedtestController} from '../../_react_/components/speedtest-modal/SpeedtestModal.controller';

import {
    CG_WIFI_SCAN_TIMEOUT,
    DS_CONTROL_REQUEST_SENT_TO_CUSTOMER_COLOR,
    DS_CONTROL_REQUEST_SENT_TO_CUSTOMER_TIMEOUT
} from './dashboard.settings';

import {SCANNER_SRC_TYPES} from '@techsee/techsee-common/lib/constants/scan.constants';

import {ReliabilityStrategy} from '@techsee/techsee-client-infra/lib/infra/RoomChannelContracts';

import {WifiAnalyzerController} from '../../_react_/components/wifi-analyzer/controller';

import {WifiAnalyzerScanController} from '../../_react_/components/connectivity-guru/wifi-analyzer-scan/controller';

import {WifiAnalyzerMode} from '../../_react_/components/wifi-analyzer/component';

import {VIDEO_MINIMIZED_MODES} from './main/main.helper';

import {TsLoaderController} from '../../_react_/components/ts-loader/ts-loader.controller';

import {TsSnapshotReminderController} from '../../_react_/components/ts-snapshot-reminder';

import {RightBarController, RightBarEvents, SearchTagsEvents} from '../../_react_/components/right-bar';

import {TsImageEditToolsController} from '../../_react_/components/ts-image-edit-tools';

import VideoModeController from '../../_react_/states/dashboard/controllers/video-mode.controller';

import {isAudioAvailableInMode} from '@techsee/techsee-common/lib/utils';

import {
    TsVideoSubscriberController,
    VideoSubscriberEventType
} from '../../_react_/components/ts-video-subscriber/TsVideoSubscriberController';

import {TsWidgetsController} from '../../_react_/components/ts-widgets/ts-widgets.controller';

import {ToolbarEventType} from '../../_react_/components/ts-floating-toolbar/ts-toolbar-options.controller';

import {TsFloatingToolbarController} from '../../_react_/components/ts-floating-toolbar/ts-floating-toolbar.controller';

const trace = getAppTracer('DashboardMainController');

import {RolesConstant as ROLES} from '@techsee/techsee-common/lib/constants/account.constants';
import STATUS_MESSAGES from '@techsee/techsee-common/lib/constants/status-messages.constant';
import {EventLogConstant as LogEvents} from '../../_react_/constants/events/event-log.constant';
import PatternsConstant from '@techsee/techsee-common/lib/constants/utils.patterns';

const __CLASSIFY_EVENT_SOURCES = {
    VIDEO_CLICKED: 'VIDEO_CLICKED',
    MANUAL_ANALYZE: 'MANUAL_ANALYZE',
    IMAGE_UPLOADED_BY_CUSTOMER: 'IMAGE_UPLOADED_BY_CUSTOMER',
    IMAGE_UPLOADED_BY_AGENT: 'IMAGE_UPLOADED_BY_AGENT',
    SCAN: 'SCAN'
};

export class DashboardMainController {
    constructor(
        dashboardState,
        tsStateHelper,
        currentUser,
        accountData,
        roomData,
        tsUrlUtils,
        wizardState,
        preloadedVideo,
        allowScreenShare,
        mediaServiceType,
        dashboardMediaService,
        scanners
    ) {
        trace.info('Constructing dashboard controller');

        this.sendObserverEmail = this.sendObserverEmail.bind(this);
        this.sendResourcesByEmail = this.sendResourcesByEmail.bind(this);
        this.areAllResourcesSelected = this.areAllResourcesSelected.bind(this);
        this.resourcesReadyToBeShared = this.resourcesReadyToBeShared.bind(this);
        this.selectUnselectAllResources = this.selectUnselectAllResources.bind(this);
        this.enableCopyToClipboard = this.enableCopyToClipboard.bind(this);
        this.downloadResources = this.downloadResources.bind(this);
        this.enableLocalImageSaving = this.enableLocalImageSaving.bind(this);
        this.sendObserverSMS = this.sendObserverSMS.bind(this);
        this.copyResourcesToClipboard = this.copyResourcesToClipboard.bind(this);
        this.openModeSwitchConfirmationModal = this.openModeSwitchConfirmationModal.bind(this);
        this.modeSwitchHandleModalResponse = this.modeSwitchHandleModalResponse.bind(this);
        this.openSelfServiceWarmTransferSummary = this.openSelfServiceWarmTransferSummary.bind(this);
        this.endMeeting = this.endMeeting.bind(this);
        this.displayEndMeetingDialog = this.displayEndMeetingDialog.bind(this);
        this.onAbort = this.onAbort.bind(this);
        this.sendImage = this.sendImage.bind(this);
        this.sendResourcesToClient = this.sendResourcesToClient.bind(this);
        this.saveResource = this.saveResource.bind(this);
        this.saveImageLibrary = this.saveImageLibrary.bind(this);
        this.newTopbarHeaderCopyToClipboard = this.newTopbarHeaderCopyToClipboard.bind(this);
        this.newTopbarHeaderEmail = this.newTopbarHeaderEmail.bind(this);
        this.newTopbarHeaderDownload = this.newTopbarHeaderDownload.bind(this);
        this.saveImageCloud = this.saveImageCloud.bind(this);
        this.leaveOfflineRoom = this.leaveOfflineRoom.bind(this);
        this.exitOfflineMode = this.exitOfflineMode.bind(this);
        this.onIdleClient = this.onIdleClient.bind(this);
        this.summaryEndSession = this.summaryEndSession.bind(this);
        this.onSubmitObserver = this.onSubmitObserver.bind(this);
        this.onSubmitAppLauncher = this.onSubmitAppLauncher.bind(this);
        this.getInteractionSummaryData = this.getInteractionSummaryData.bind(this);
        this.getDateFormattedByAcc = this.getDateFormattedByAcc.bind(this);
        this.enableEmailImageSharing = this.enableEmailImageSharing.bind(this);
        this.downloadResourcesAndOpenEmail = this.downloadResourcesAndOpenEmail.bind(this);
        this.clearLastEvent = this.clearLastEvent.bind(this);

        this._disposeMobxReactions = [];

        /* eslint max-params: 0*/
        this.sharingState = new SharingState();
        this.sharingService = getDashboardStores().sharingService;
        this.historyResourcesController = new HistoryResourcesController(this.sharingState, this.sharingService);
        this.smsService = getDashboardStores().smsService;

        this.dashboardState = dashboardState;
        this.messageAlertEmitter = new EventEmitter();

        // Bridge MobX state changes to AngularJS digest cycle
        // Watch for changes to imagesWidgets array

        this.setActionMode();
        this.autoDataCollectionServices = getDashboardStores().autoDataCollectionServices;

        this.sessionSummaryController = null;

        this.dashboardMediaService = dashboardMediaService;

        const wifiAnalyzerService = getRootStore().wifiAnalyzerService;

        if (wifiAnalyzerService) {
            wifiAnalyzerService.setMediaService(dashboardMediaService);
        }

        this.urlUtils = tsUrlUtils;

        this.returnQuery = this.urlUtils.getParamValue('returnQuery');
        this.roomCode = this.urlUtils.getParamValue('roomCode');
        this.scanId = this.urlUtils.getParamValue('scanId');

        this.browserUtilsService = getRootStore().browserUtilsService;
        this.miniDashboard = this.browserUtilsService.getFromSessionStorage('miniDashboard');
        this.embeddedDashboard = this.browserUtilsService.getFromSessionStorage('embeddedDashboard');
        this.stateHelper = tsStateHelper;

        this.chatApi = getRootStore().chatApi;

        this.visibilityChange = getRootStore().visibilityChangeService;
        this.eventLog = getRootStore().eventLogService;
        this.eventLog.userId = currentUser._id;

        this.sophieContext = this.urlUtils.getParamValue('sophie-ctx');
        this.currentUser = currentUser;
        this.accountData = accountData;
        this.roomData = roomData;

        runInAction(() => {
            this.dashboardState.currentUserId = this.currentUser._id.toString();
        });

        this.annotateService = getRootStore().tsCanvasAnnotate;
        this.videoControlService = getRootStore().tsVideoControl;
        this.annotationBarController = new AnnotationBarController(
            this.annotateService,
            getRootStore().localizationService.translate
        );

        const imageEditorDependencies = {
            annotateService: this.annotateService,
            tsScanArea: getDashboardStores().tsScanArea,
            environmentDetect: getRootStore().environmentService,
            tsInterfaceHelper: getRootStore().tsInterfaceHelperService,
            localizationService: getRootStore().localizationService,
            window: getRootStore().globals.window,
            dashboardState: this.dashboardState,
            videoModeState: getDashboardStores().dashboardState.videoModeState,
            displayTabletAsDesktop: getRootStore().displayTabletAsDesktop,
            mainController: this, // Now that main and dashboard are merged, pass this directly
            accountData: this.accountData,
            dashboardController: this
        };

        // Mini dashboard needs to disable padding for proper canvas sizing
        if (this.miniDashboard) {
            this.dashboardState.imageEditorState.disablePadding = true;
        }

        this.imageEditorController = new TsImageEditorController(imageEditorDependencies);
        this.endMeetingController = new TsEndMeetingController(
            dashboardState,
            {
                onEndMeeting: this.endMeeting.bind(this),
                onLeaveMeeting: this.leaveMeeting.bind(this),
                onLeaveOfflineRoom: this.leaveOfflineRoom.bind(this),
                onExitOfflineMode: this.exitOfflineMode.bind(this)
            },
            getRootStore().localizationService.translate,
            getRootStore().environmentService
        );
        this.customerNumber = roomData.customerNumber !== 'none' ? roomData.customerNumber : '';
        this.customerId = roomData.customerId !== 'none' ? roomData.customerId : '';
        this.qos = getRootStore().agentQosService;
        this.LogEvents = LogEvents;
        this.localeHelper = getRootStore().tsLocaleHelper;
        this.LOCATION_ICONS = LOCATION_ICONS;
        this.bulkEmailSharingModeEnum = bulkEmailSharingModeEnum;
        this.busy = getRootStore().tsBusyService;
        this.timedOperation = getRootStore().timedOperationService;
        this.dir = this.localeHelper.isRTL() ? 'rtl' : 'ltr';
        this.environmentDetect = getRootStore().environmentService;
        this.wizardState = wizardState;
        this.wizardHelper = getDashboardStores().wizardHelperService;
        this.preloadedVideo = preloadedVideo;
        this.auth = getRootStore().authService;
        this.urlConfig = getRootStore().urlConfigService;
        this.errorDialogController = new ErrorDialogController(
            this.environmentDetect.isMobile(getRootStore().displayTabletAsDesktop),
            Boolean(this.miniDashboard)
        );
        this._trafficLogger = null;
        this._videoDurationLogger = null;
        this.offlineRoom = roomData.offline && !this.dashboardState.offlineMode;
        this.clientDisconnected = false;
        this.isLivePointerRunning = false;
        this.tsInterfaceHelper = getRootStore().tsInterfaceHelperService;
        this.isFF = this.environmentDetect.isFF();
        this.isIE = this.environmentDetect.isIE11();
        this.isMobile = this.environmentDetect.isMobile(getRootStore().displayTabletAsDesktop);
        this.isTablet = this.environmentDetect.isTablet(false);
        this.isDesktopView = this.environmentDetect.isDesktop();
        this.allowScreenShare = allowScreenShare;
        const {SmsService: SmsServiceInfra} = require('@techsee/techsee-client-infra/lib/services/smsService');
        const {RoomService} = require('@techsee/techsee-client-infra/lib/services/RoomService');
        const smsServiceInfra = new SmsServiceInfra(
            () => getRootStore().authService.getAuthToken() || '',
            getRootStore().urlConfigService.get('API_URL')
        );
        const dashboardRoomService = new RoomService(
            getRootStore().urlConfigService.get('API_URL'),
            () => getRootStore().authService.getAuthToken() || ''
        );
        this.smsService.init(
            smsServiceInfra,
            dashboardRoomService,
            get(accountData, 'protectedSettings.smsSettings'),
            getRootStore().eventsLogService,
            accountData._id,
            currentUser._id,
            get(accountData, 'protectedSettings.keepCustomerMobile'),
            getRootStore().browserUtilsService
        );
        this.enableMobileGeolocation = get(this.accountData, 'protectedSettings.enableMobileGeolocation');
        this.fallbackModeNotification = get(this.accountData, 'protectedSettings.fallbackModeNotification');
        // enableIdleModeUsability is a getter, don't assign
        this.enableReloginOnSessionExpired = get(this.accountData, 'protectedSettings.enableReloginOnSessionExpired');
        this.addCountryCodeToSms = get(this.accountData, 'protectedSettings.smsSettings.addCountryCodeToSms');
        this.enableVideoTimeoutHackForSdk = get(this.accountData, 'protectedSettings.enableVideoTimeoutHackForSdk');
        this.translate = getRootStore().localizationService.translate;
        this.toastColor = ToastColors;

        if (this.isCopilotEnabled) {
            this._copilotService = new CopilotService(
                get(this.accountData, 'protectedSettings.copilot'),
                this.accountData._id,
                this.currentUser._id,
                this.stateHelper,
                this.sophieContext
            );
            this.initCopilot = this.initCopilot.bind(this);

            if (this.miniDashboard) {
                this._copilotService.loadSdkAndPlugin(true);
            }
        }
        this.timeoutDialogController = new TimeoutDialogController(this.chatApi);

        runInAction(() => {
            this.dashboardState.mobilePopoverLocation = '';
        });
        this._sendingTimeout = null;
        this.roomService = getRootStore().roomService;
        this.authExpiry = getRootStore().authExpiryService;
        this.domUtilsService = getRootStore().domUtilsService;
        this.jsApiService = getRootStore().jsApiService;
        this.dashboardState.enableSharingImagesContainer = false;
        this.observe = this.urlUtils.getParamValue('observe');
        this.saveOnLocalStorage = utils.isInIframe(window) || (this.miniDashboard && !this.isDesktopView);

        this.audioService = getDashboardStores().audioService;
        this.videoModeState = getDashboardStores().dashboardState.videoModeState;

        if (!this.fallbackModeController && this.fallbackModeNotification) {
            this.fallbackModeController = new FallbackModeController(this.translate, this.domUtilsService);
        }

        if (!this.connectivityIssuePopupController) {
            this.connectivityIssuePopupController = new ConnectivityIssuePopupController();
        }

        this.authExpiry.init(
            {
                isNotificationEnabled: this.enableReloginOnSessionExpired,
                roomId: this.roomData._id,
                userId: currentUser._id,
                roomUserId: roomData.userId,
                accountId: accountData._id
            },
            () => {
                this.loginModalController = this.authExpiry.loginModalController;
            }
        );

        const exposePostMessageApi = get(accountData, 'protectedSettings.exposePostMessageApi');
        const accountSettingsJsApi = {
            timezone: get(accountData, 'settings.timezone'),
            language: get(accountData, 'settings.language')
        };

        if (exposePostMessageApi && exposePostMessageApi.enabled) {
            this.jsApiService.init(this.endMeeting.bind(this), assign(exposePostMessageApi, accountSettingsJsApi));
        }

        const knowledgeExpertCanRunSessions =
            currentUser.role === ROLES.KNOWLEDGE_EXPERT &&
            get(this.accountData, 'protectedSettings') &&
            !this.accountData.protectedSettings.knowledgeExpertRunSessions;

        this.libraryTaggingMode = this.dashboardState.offlineMode && knowledgeExpertCanRunSessions;
        runInAction(() => {
            this.dashboardState.isLibraryTaggingMode = this.libraryTaggingMode;
            this.dashboardState.isObserve = !!this.observe;
            this.dashboardState.isOfflineMode = this.dashboardState.offlineMode;
            this.dashboardState.isOfflineRoom = this.offlineRoom;
        });

        this.libraryTaggingMode = this.dashboardState.isLibraryTaggingMode;

        if (!this.dashboardState.offlineMode && !this.libraryTaggingMode) {
            this.visibilityChange.visible(() => this.chatApi.visibilityChanged(true));
            this.visibilityChange.hidden(() => this.chatApi.visibilityChanged(false));

            // Report room as started to avoid having the room be reported as connected before it is started
            this.roomService.start(this.roomData._id);
        }

        this.dashboardState.mediaServiceType = mediaServiceType;

        this.dashboardState.isOpentok = this.dashboardState.mediaServiceType === MEDIA_SERVICE.OPENTOK;
        this.dashboardState.isMediaServer = this.dashboardState.mediaServiceType === MEDIA_SERVICE.MEDIASERVER;

        this.defaultCustomerName = this.translate('DASHBOARD.CONTROLLER.DEFAULT_CUSTOMER_NAME');

        // Init event log service
        this.eventLog.room = roomData._id;

        this.accountData.settings.logoUrl = resolveLogoUrl(this.accountData.settings.logoUrl);

        this.agentHasRemoteControl = false;
        this.interactionSummaryService = getRootStore().interactionSummaryService;
        this.interactionSummaryHelperService = new InteractionSummaryHelperService(
            this.interactionSummaryService,
            this.accountData,
            this.roomData,
            this.translate,
            this.eventLog
        );
        this.interactionSummaryTranslated = getRootStore().interactionSummaryTranslated;
        this.enableShareMenu = get(this.accountData, 'protectedSettings.enableShareMenu');
        this.copyToClipboard = get(this.accountData, 'protectedSettings.enableCopyToClipboard');
        this.localImageSaving = get(this.accountData, 'protectedSettings.localImageSaving');
        this.emailImageSharing = get(this.accountData, 'protectedSettings.emailImageSharing');
        this.quickSharingModesEnabled = get(this.accountData, 'protectedSettings.quickSharingModesEnabled');
        runInAction(() => {
            this.dashboardState.allowSessionSummary =
                !this.isIE &&
                !this.dashboardState.offlineMode &&
                !this.isMobile &&
                get(this.accountData, 'protectedSettings.enableSessionSummary') &&
                get(this.accountData, 'protectedSettings.enableHistory') &&
                (get(this.accountData, 'protectedSettings.saveSnapshots') ||
                    get(this.accountData, 'protectedSettings.autosaveSharedImages'));
        });
        this.allowNewSessionSummary =
            this.dashboardState.allowSessionSummary &&
            get(this.accountData, 'protectedSettings.newSessionSummary.enable') &&
            get(this.accountData, 'protectedSettings.newSessionSummary.allowAddingDescriptionAndNewTags');
        this.descriptionMaxLength = get(this.accountData, 'protectedSettings.newSessionSummary.descriptionMaxLength');
        this.multipleImagesSharingEnabled = this.dashboardState.multipleImagesSharingEnabled;
        this.dashboardState.enableLocalImageSaving = get(this.accountData, 'protectedSettings.localImageSaving', false);
        this.dashboardState.enableCopyToClipboard = get(
            this.accountData,
            'protectedSettings.enableCopyToClipboard',
            false
        );
        this.dashboardState.enableEmailImageSharing = get(
            this.accountData,
            'protectedSettings.emailImageSharing',
            false
        );
        this.multipleImagesSharingQuota =
            this.multipleImagesSharingEnabled && get(this.accountData, 'protectedSettings.multipleImagesSharingQuota');
        this.downloadAndEmailSharing =
            this.enableShareMenu &&
            this.multipleImagesSharingQuota &&
            get(accountData, 'protectedSettings.enabledBulkSharingModes') ===
                this.bulkEmailSharingModeEnum.DOWNLOAD_AND_EMAIL;
        this.enableSelfServiceInLeftBar =
            get(this.accountData, 'protectedSettings.enableSelfServiceInLeftBar') &&
            get(this.accountData, 'protectedSettings.allowSelfServiceOfflineSessions');

        this.enableObservation =
            get(this.accountData, 'protectedSettings.enableSilentObserve') &&
            get(this.accountData, 'protectedSettings.observation.enable') &&
            !this.observe &&
            (!isEmpty(this.currentUser.groups) ||
                get(this.accountData, 'protectedSettings.observation.allowGuestObserver'));
        this.allowSendByEmail = get(this.accountData, 'settings.allowSendByEmail');
        this.allowInviteBySms = get(this.accountData, 'settings.allowInviteBySms');
        this.invisibleModeObservation = get(this.accountData, 'protectedSettings.observation.dashboardInvisibleMode');
        this._updateMailTrigger();
        this.clientTimeoutDialogCtrl = new ClientTimeoutDialogController();

        if (this.dashboardState.allowSessionSummary && !this.embeddedDashboard) {
            const rootStore = getRootStore();
            const dashboardStores = getDashboardStores();
            const historyService = dashboardStores.historyService;
            const httpService = new RestApiService(
                rootStore.urlConfigService.get('API_URL'),
                rootStore.authService.getAuthToken() || ''
            );
            const eventLogger = dashboardStores.createSessionSummaryLoggingService(this.roomData._id);
            this.sessionSummaryController = new SessionSummaryController(
                historyService,
                eventLogger,
                this.roomData._id,
                rootStore.localizationService.translate,
                accountData,
                httpService,
                rootStore.environmentService,
                rootStore.displayTabletAsDesktop
            );
            this.sessionSummaryController.setOnSummaryCompleted(() => this.summaryEndSession());
        }

        // hide copy to clipboard when resource security is enabled
        this.copySecureLink = get(this.accountData, 'protectedSettings.resourceSecurity');

        this.isLowImageSharingQuality = get(this.accountData, 'protectedSettings.imageSharingQuality') < 1;
        this.dashboardState.isHighImageSharingQuality =
            get(this.accountData, 'protectedSettings.imageSharingQuality') === 1;
        this.isHighImageSharingQuality = this.dashboardState.isHighImageSharingQuality;

        const mobileClientUrl = this.urlConfig.get('MOBILE_CLIENT_URL');
        const normalizedUrl = TsUtils.replaceUrlDomain(mobileClientUrl, window.location.hostname);

        this.link = normalizedUrl.replace('{room}', roomData._id);
        if (!this.accountData.protectedSettings || !this.accountData.protectedSettings.chromeDetection) {
            this.link += '&intent=no';
        }

        this.clientStartURL = TsUtils.replaceUrlDomain(CLIENT_START_URL, window.location.hostname);

        if (this.accountData.settings && this.accountData.settings.cameraModeOnly) {
            this.link += '&camera-only=yes';
        }

        if (this.dashboardState.mediaServiceType) {
            this.link += '&media-service=' + this.dashboardState.mediaServiceType;

            if (this.accountData.protectedSettings.opentokVersion) {
                this.link += '&opentok-version=' + this.accountData.protectedSettings.opentokVersion;
            }
        }

        if (roomData.sentURL) {
            this.link = roomData.sentURL;
        }

        if (this.miniDashboard) {
            this.miniDashboardImageUploadFailed = this.translate('ERROR_DIALOG.VIEW.IMAGE_UPLOAD_FAILED');
        }

        const apiPrefix = this.urlConfig.get('API_URL').match(/https?:\/\/([^.]+)\./);
        const hinter = apiPrefix ? API_TO_HINTER_MAP[apiPrefix[1].toLowerCase()] : null;

        this.sessionIdWithHint = roomData && roomData.guids ? roomData.guids[0] + (hinter ? hinter : '') : '';
        this.isGuestRole = currentUser.role === ROLES.GUEST_OBSERVER;

        if (this.isGuestRole && !this.observe) {
            this.stateHelper.navigateTo('sessionEnded');

            return;
        }

        this.leftBarClosed = this.dashboardState.isLeftBarClosed;
        this.CONNECTION_STATUS = CONNECTION_STATUS;
        this.setConnectionStatus(CONNECTION_STATUS.WAITING);

        this.events = [];
        this.eventParams = {
            device: '',
            address: 'waiting...'
        };
        this.addressLocation = {
            translation: 'DASHBOARD.VIEW.WAITING_FOR_LOCATION',
            status: LOCATION_ADDRESS_STATUS.WAITING,
            icon: this.LOCATION_ICONS.UNAVAILABLE,
            popoverEnabled: false
        };
        this.miniPopoverLocation = this.translate('DASHBOARD.VIEW.LOCATION_UNAVAILABLE');

        this.mediaDevices = {};

        this.localeHelper.clear();

        this._initUiSettings();

        const tempAccSettings = {
            generalSettings: {
                emailImageSharing: this.emailImageSharing,
                localImageSaving: this.localImageSaving,
                logoUrl: this.accountData.settings.logoUrl,
                enableMobileGeolocation: this.accountData.protectedSettings.enableMobileGeolocation
            },
            inviteMethodSettings: {
                multiLanguage: this.accountData.settings.multiLanguage
            }
        };
        this.dashboardState.isScanIdExist = !!this.scanId;

        this.topBarController = new DashboardTopBarController(
            tempAccSettings,
            this.dashboardState,
            this.translate,
            this.onAbort,
            this.sendImage,
            this.saveResource,
            this.newTopbarHeaderCopyToClipboard,
            this.newTopbarHeaderEmail,
            this.newTopbarHeaderDownload,
            this.saveImageCloud,
            this.leaveOfflineRoom
        );

        // Update topBarController callbacks if libraryTaggingMode is true
        if (this.libraryTaggingMode) {
            this.topBarController.onSaveResource = this.saveImageLibrary;
            this.topBarController.onLeaveOfflineRoom = this.exitOfflineMode;
        }

        this.surveyModalController = new SurveyModalController(
            getDashboardStores().agentSurveyService,
            this.accountData,
            this.roomData,
            this.localeHelper,
            getDashboardStores().roomService
        );
        this.thankYouModalController = new ThankYouModalController({dir: this.dir});

        this.surveyModalController.on(SurveyModalEvents.SURVEY_COMPLETED, (message) => {
            this.surveySubmitted = true;

            if (this._surveyPreventRedirection) {
                this._redirectOrCloseWindow({message});
            } else {
                this.thankYouModalController.open();
            }
        });

        this.thankYouModalController.on('CLOSED', () => {
            if (!this._surveyPreventRedirection) {
                this._redirectOrCloseWindow();
            }
        });

        this.surveyModalController.on(SurveyModalEvents.SURVEY_SKIPPED, () => {
            this.surveySubmitted = true;

            if (!this._surveyPreventRedirection) {
                this._redirectOrCloseWindow();
            }
        });

        this.endMeetingModalController = new EndMeetingModalController();

        if (!this.libraryTaggingMode) {
            this.footerController = new DashboardFooterController(get(this.roomData, 'guids')[0], this.translate);
            const leftBarOptions = {
                desktopShareEnabled: get(this.accountData, 'protectedSettings.desktopSharing.enabled'),
                enableObservation: this.enableObservation,
                allowSendByEmail: this.allowSendByEmail,
                allowInviteBySms: this.allowInviteBySms,
                phoneCountryCodes: get(this.accountData, 'protectedSettings.selectedCountries'),
                defaultCountryCode: get(this.accountData, 'settings.countryCode'),
                keepCustomerMobile: get(this.accountData, 'protectedSettings.keepCustomerMobile'),
                addCountryCodeToSms: get(this.accountData, 'protectedSettings.smsSettings.addCountryCodeToSms'),
                selectedCountries: get(this.accountData, 'protectedSettings.selectedCountries'),
                countryCode: this.accountData.settings.countryCode,
                appLauncher: get(this.accountData, 'protectedSettings.appLauncher'),
                liveSdk: get(this.accountData, 'protectedSettings.liveSdk'),
                enableAgentWifiScan: get(this.accountData, 'protectedSettings.connectivityGuru.enableAgentWifiScan')
            };

            this.leftBarController = new DashboardLeftBarController(
                this.translate,
                this.environmentDetect,
                leftBarOptions,
                this.openSelfServiceWarmTransferSummary,
                this.openModeSwitchConfirmationModal,
                this.onSubmitObserver,
                this.onSubmitAppLauncher
            );
        }

        getRootStore().authService.on('newToken', () => {
            if (this._copilotElement) {
                this._copilotService?.reloadSession();
            }
        });
        this._disposeMobxReactions.push(
            reaction(
                () => getDashboardStores().roomStorageService.clientState.mode,
                (mode) => {
                    runInAction(() => {
                        this.dashboardState.meetingMode = mode;
                    });
                    if (mode && this.leftBarController) {
                        this.leftBarController.setCurrentMeetingMode(mode);
                    }
                },
                {fireImmediately: true}
            )
        );

        this._disposeMobxReactions.push(
            reaction(
                () => this.dashboardState.clientRoomStorage.availableModes.slice(),
                () => {
                    const clientMode = this.dashboardState.clientRoomStorage.mode;
                    const availableModes = this.dashboardState.clientRoomStorage.availableModes;

                    if (clientMode && this.leftBarController && availableModes?.length) {
                        let meetingModes = this.leftBarController.startWithModes;

                        meetingModes = filter(meetingModes, (mode) => includes(availableModes, mode.mode));
                        this.leftBarController.setAvailableMeetingModes(meetingModes);
                        this.leftBarController.setCurrentMeetingMode(clientMode);
                    }
                }
            )
        );

        if (this.embeddedDashboard) {
            this.audioService.on('audioEvent', (data) => {
                const reportedFieldType = data.type;

                if (this.miniDashboard && data.text) {
                    const text = data.text;
                    const timestamp = new Date().getTime();

                    runInAction(() => {
                        this.dashboardState.lastEvent = {text: this.translate(text), timestamp};
                    });
                }

                this.roomService.setReportedField(this.roomData._id, {
                    key: 'audioStatus',
                    value: {
                        type: reportedFieldType
                    },
                    type: 'push'
                });
            });
        }

        this._disposeMobxReactions.push(
            reaction(
                () => [
                    this.displayImagesManagementButtons(),
                    this.displaySendButton,
                    this.dashboardState.floatingToolbarState.displaySaveButton,
                    this.displaySharingButton(),
                    this.disabledSendButton(),
                    this.dashboardState.floatingToolbarState.disabledSaveButton,
                    this.disabledSharingButton(),
                    this.displaySaveInHistoryButton()
                ],
                () => {
                    if (this.topBarController) {
                        runInAction(() => {
                            this.topBarController.showImagesManagement = this.displayImagesManagementButtons();
                            this.topBarController.showSharingButton = this.displaySharingButton();
                            this.topBarController.showSaveButton =
                                this.dashboardState.floatingToolbarState.displaySaveButton;
                            this.topBarController.showSendButton = this.displaySendButton;
                            this.topBarController.showSaveInHistoryButton = this.displaySaveInHistoryButton();
                            this.topBarController.disabledSaveButton =
                                this.dashboardState.floatingToolbarState.disabledSaveButton;
                            this.topBarController.disabledSendButton = this.disabledSendButton();
                            this.topBarController.disabledSharingButton = this.disabledSharingButton();
                            this.topBarController.libraryTaggingMode = this.libraryTaggingMode;
                        });
                    }
                }
            )
        );

        this._initVideoTimeoutHackForSdk();
        this.roomCode = this.urlUtils.getParamValue('roomCode');

        // Set wifiAnalyzerMode before early return so component can access it
        this.wifiAnalyzerMode = WifiAnalyzerMode;

        // Initialize controllers that MainView needs before early return
        // These will be properly initialized later if not in offline mode
        this.wifiAnalyzerController = null;
        this.searchResultsDialogController = null;
        this.scanResultModalController = null;
        this.switchModeModalController = null;
        this.customerHistoryModalController = null;
        this.tsFloatingToolbarController = null;
        this.rightBarController = null;

        // if (this.dashboardState.offlineMode) {
        //     runInAction(() => {
        //         this.dashboardState.dashboardControllerLoaded = true;
        //     });
        //     return;
        // }

        if (!this.observe) {
            const apiPrefix = this.urlConfig.get('API_URL').match(/https?:\/\/([^.]+)\./);
            const hinter = apiPrefix ? API_TO_HINTER_MAP[apiPrefix[1].toLowerCase()] : null;

            this.sessionIdWithHint =
                roomData.guids && roomData.guids[0] ? roomData.guids[0] + (hinter ? hinter : '') : '';

            this.isFSSession = this.roomCode;
        }

        if (this.offlineRoom) {
            this.localeHelper.dashboardConnectedOffline();
        }

        this.enableNetworkBandwidthMeasurement =
            this.accountData.protectedSettings.enableNetworkBandwidthMeasurement &&
            (!this.isIE || !this.dashboardState.isOpentok);

        this.cameraModeOnly = get(this.accountData, 'settings.cameraModeOnly');
        this.idleMode = get(this.accountData, 'settings.idleMode');
        this.spinnerOptions = {
            type: SpinnerTypeOptions.CIRCULAR,
            backgroundColor: SpinnerBackgroundColors.Transparent,
            size: SpinnerSizes.Large,
            color: SpinnerColors.LightBlue
        };

        if (!this.isIE || !this.dashboardState.isOpentok) {
            this.videoBandwidthSamplingInterval =
                this.accountData.protectedSettings.videoBandwidthSamplingInterval * 1000;
            this.minimalBandwidthKbps = this.accountData.protectedSettings.minimalVideoBandwidth;
            this.timeToWaitToStartBandwidthMeasurement =
                this.accountData.protectedSettings.timeToWaitToStartBandwidthMeasurement * 1000;
        }

        this.eventLog.userAgent({
            side: PlatformType.dashboard,
            userAgent: window.navigator.userAgent,
            clientVersion: CLIENT_VERSION
        });

        this._logIfPluginUnavailable();

        if (this.dashboardState.allowSessionSummary && !this.embeddedDashboard) {
            window.onbeforeunload = (event) => {
                if (!this.isScreenModes || this.dashboardState.isDesktopSharingSession) {
                    event.returnValue = '';
                }
            };
        }

        runInAction(() => {
            this.dashboardState.showLoader = true;
        });

        this.idleClient = {};
        this.idleClient.inviteMethod = this.browserUtilsService.getFromSessionStorage('InviteMethod');

        const notificationText =
            this.idleClient.inviteMethod === AddressTypesEnum.SMS
                ? 'MAIN.VIEW.MOBILE_NOT_CONNECTED_NOTIFICATION'
                : 'MAIN.VIEW.MOBILE_NOT_CONNECTED_NOTIFICATION_NO_SMS_CONNECTION';

        this.idleClient.mobileNotConnectedNotification = this.idleClient.idleNotification =
            this.translate(notificationText);

        this.idleClient.waitForClientNotification = this.translate('MAIN.VIEW.WAITING_FOR_CLIENT');
        this.idleClient.sendSMSButtonText = this.translate('MAIN.VIEW.SEND_SMS');
        this.idleClient.connectingText = this.translate('MAIN.VIEW.RECOVERING_VIDEO');

        const enableMatomoAnalytics = get(this.accountData, 'protectedSettings.enableMatomoAnalytics');

        if (enableMatomoAnalytics) {
            getRootStore().domUtilsService.loadScript(MATOMO_ANALYTICS.TRACKING);
            getRootStore().domUtilsService.loadScript(MATOMO_ANALYTICS.SESSION_RECORDING);
        }

        if (roomData.clientRedirectedToStore || roomData.clientVersionStatus === VersionStatus.INVALID) {
            this._displayRedirectToStoreGuidance(roomData.clientVersionStatus);
        }

        this.meetingSyncEnabled = false;
        this.mediaStatsLogger = new MediaStatsDataCollector(this.dashboardMediaService);
        this.modeSwitchModalController = new ModeSwitchModalController(
            this.translate,
            this.modeSwitchHandleModalResponse
        );
        this.dashboardGuidanceController = new DashboardGuidanceController(
            this.translate,
            this.dashboardState,
            this.displayEndMeetingDialog
        );
        this.tooltipPlacement = this.dir === 'rtl' ? 'left' : 'right';
        this.mobilePhonePattern = PatternsConstant.mobilePhone;
        this.emailPattern = PatternsConstant.email;
        runInAction(() => {
            this.dashboardState.displayObserverSendingForm = false;
            this.dashboardState.observationCurrentTab = this.allowInviteBySms
                ? AddressTypesEnum.SMS
                : AddressTypesEnum.EMAIL;
            this.dashboardState.phoneToInviteObserver = '';
            this.dashboardState.emailToInviteObserver = '';
        });
        this.inviteMethodTypes = AddressTypesEnum;

        this.onRecordButton = this.onRecordButton.bind(this);

        this.bandwidthMeasurementService = getDashboardStores().bandwidthMeasurementService;

        this._initHandlers();

        if (!this.dashboardState.offlineMode) {
            this.connectToMeeting();
        }
        // Initialize country selector properties
        this.selectedCountries = get(this.accountData, 'protectedSettings.selectedCountries') || [];
        this.accountCountryCode = get(this.accountData, 'settings.countryCode') || '';
        this.sms = false; // or appropriate default value
        this.countryCodeText = '';

        // Add this after the existing initialization code
        if (this.addCountryCodeToSms) {
            this.countrySelector = new CountrySelectController(
                this.translate,
                this.browserUtilsService.getFromLocalStorage.bind(this.browserUtilsService),
                this.tsInterfaceHelper.useNewInterface,
                this.addCountryCodeToSms,
                this.accountCountryCode,
                this.selectedCountries,
                this.sms,
                this.countryCodeText,
                (countryCode) => {
                    this.countryCodeText = countryCode;
                }
            );

            // Pass the data to the controller to handle internally
            this.countrySelector.initWithData({
                accountData: this.accountData
            });
        }

        this.timeoutDialogController.on('close', () => {
            this.endMeeting(false, LogEvents.closedByTypes.dashboard, ReasonForClosing.timeout);
        });

        this.clientTimeoutDialogCtrl = new ClientTimeoutDialogController();

        // ========== Main Controller Initialization ==========
        // Main controller initialization
        this.videoSubscriber = null;

        this.syncMeetingState = this.syncMeetingState.bind(this);
        this.uploadLocalImage = this.uploadLocalImage.bind(this);
        this.failedLocalLoad = this.failedLocalLoad.bind(this);
        this._snapshotToImg = this._snapshotToImg.bind(this);
        this.onVideoSubscriberChanged = this.onVideoSubscriberChanged.bind(this);
        this.openWifiScanHistoryPage = this.openWifiScanHistoryPage.bind(this);
        this._isDragging = false;
        runInAction(() => {
            this.dashboardState.floatingToolbarState._isRunWifiButtonDisabled = false;
        });
        this.UserType = UserType;
        this.MeetingMode = MeetingMode;
        this.PHOTO_SELECTION_STATE = PHOTO_SELECTION_STATE;
        this.setupColors();
        this.connectionTypes = ConnectionTypesEnum;
        this.resourceService = getDashboardStores().resourcesService;
        this.tsSharingService = getDashboardStores().sharingService;
        this.messagesService = getDashboardStores().messagesService;
        this.tsSnapshotReminderService = getDashboardStores().snapshotReminderService;
        this.showWizardSetting = this.wizardState.showWizard && !this.wizardState.finished;
        this.isTablet = this.environmentDetect.isTablet(this.displayTabletAsDesktop);
        this.isLivePointerOnMobileDashboardEnabled = get(
            this.accountData,
            'protectedSettings.enableLivePointerOnMobileDashboard'
        );
        this.isPostImageEnabledOnAccount =
            get(this.accountData, 'protectedSettings.exposePostMessageApi.enabled') &&
            get(this.accountData, 'protectedSettings.exposePostMessageApi.image');

        this.responsiveUtils = getRootStore().tsResponsiveUtilsService;
        this.tsScsan = getDashboardStores().scanService;
        this.loadedFromHistory = this.urlUtils.getParamValue('history') === 'true';
        runInAction(() => {
            this.dashboardState.scanId = this.urlUtils.getParamValue('scanId');
        });

        // Initialize RightBarState values directly
        const libraryTaggingMode = this.dashboardState.offlineMode && this.currentUser.role === ROLES.KNOWLEDGE_EXPERT;

        this.rightBarController = new RightBarController(
            this.chatApi,
            this.currentUser,
            this.accountData,
            this.resourceService,
            getRootStore().eventLogService,
            getAppTracer(),
            this.dashboardState,
            this.dashboardState.offlineMode,
            this.dashboardState.scanId,
            this.roomData,
            this.dashboardState.enableAgentWifiScanHistory,
            getRootStore().tsLocaleHelper,
            this.tsInterfaceHelper,
            getRootStore().localizationService.translate
        );

        // Initialize RightBarState values via controller
        this.rightBarController.setLibraryTaggingMode(libraryTaggingMode);
        if (this.dateFormat) {
            this.rightBarController.setDateFormat(this.dateFormat);
        }
        runInAction(() => {
            this.dashboardState.allowUploadImageFileFromDashboard = get(
                this.accountData,
                'protectedSettings.allowUploadImageFileFromDashboard'
            );
            this.dashboardState.interactionSummaryPreviews = [];
        });

        this.rightBarController.setAllowUploadImageFileFromDashboard(
            this.dashboardState.allowUploadImageFileFromDashboard || false
        );

        // Set up watcher to sync other dashboard values when dashboard controller is available
        if (this.rightBarController) {
            this.rightBarController.on(RightBarEvents.SELECT_UNSELECT_ALL_RESOURCES, ({resourceType, data, select}) => {
                this.selectUnselectAllResources?.(resourceType, data, select);
            });
            this.rightBarController.on(RightBarEvents.DOWNLOAD_RESOURCES, ({resourceType, data}) => {
                this.downloadResources?.(resourceType, data);
            });
            this.rightBarController.on(RightBarEvents.COPY_RESOURCES_TO_CLIPBOARD, (resourceType) => {
                this.copyResourcesToClipboard?.(resourceType);
            });
            this.rightBarController.on(RightBarEvents.SEND_RESOURCES_TO_CLIENT, (resourceType) => {
                this.sendResourcesToClient?.(resourceType);
            });
            this.rightBarController.on(RightBarEvents.SEND_RESOURCES_BY_EMAIL, (resourceType) => {
                this.sendResourcesByEmail?.(resourceType);
            });
            this.rightBarController.on(RightBarEvents.DOWNLOAD_RESOURCES_AND_OPEN_EMAIL, ({resourceType, data}) => {
                this.downloadResourcesAndOpenEmail?.(resourceType, data);
            });
            this.rightBarController.on(RightBarEvents.TOGGLE_RESOURCE_SELECTION, ({resourceType, resource}) => {
                this.toggleResourceSelection?.(resourceType, resource);
            });
            this.rightBarController.on(RightBarEvents.HISTORY_RESOURCE_ACTION_CLICK, ({e, type, data}) => {
                this.historyResourceActionClick?.(e, type, data);
            });
            this.rightBarController.on(RightBarEvents.HISTORY_RESOURCES_ON_SHARE_CLICK, ({e, data}) => {
                this.historyResourcesController?.onShareClick?.(e, data);
            });

            this.rightBarController.setSharingState(this.sharingState);
        }

        runInAction(() => {
            if (this.sharingState) {
                this.rightBarController.setResourcesReadyToBeShared(
                    this.sharingState.isResourcesReadyToBeShared || false
                );
            }
            if (this.historyResourcesController?.sharingModeActions) {
                this.rightBarController.setSharingModeActions(this.historyResourcesController.sharingModeActions);
            }

            this.dashboardState.downloadAndEmailSharing = this.downloadAndEmailSharing || false;
            this.dashboardState.isQuickShareEnabled = this.isQuickShareEnabled?.() || false;
        });

        // Watch sharingState.isResourcesReadyToBeShared
        if (this.sharingState) {
            this._disposeMobxReactions.push(
                reaction(
                    () => this.sharingState.isResourcesReadyToBeShared,
                    (newVal) => {
                        this.rightBarController.setResourcesReadyToBeShared(newVal || false);
                    }
                )
            );
        }

        // Watch historyResourcesController sharingModeActions
        if (this.historyResourcesController) {
            this._disposeMobxReactions.push(
                reaction(
                    () => this.historyResourcesController.sharingModeActions?.slice(),
                    (newVal) => {
                        this.rightBarController.setSharingModeActions(newVal || []);
                    }
                )
            );
        }

        this._disposeMobxReactions.push(
            reaction(
                () => this.dashboardState.allowUploadImageFileFromDashboard,
                (newVal) => {
                    if (this.rightBarController) {
                        this.rightBarController.setAllowUploadImageFileFromDashboard(newVal || false);
                    } else {
                        runInAction(() => {
                            this.dashboardState.rightBarState.allowUploadImageFileFromDashboard = newVal || false;
                        });
                    }
                }
            )
        );
        // Watch interactionSummaryPreviews (updated via event listeners)
        this._disposeMobxReactions.push(
            reaction(
                () => this.dashboardState.interactionSummaryPreviews.slice(),
                (newVal) => {
                    if (this.rightBarController) {
                        this.rightBarController.setInteractionSummaryPreviews(newVal || []);
                    } else {
                        runInAction(() => {
                            this.dashboardState.rightBarState.interactionSummaryPreviews = Array.from(newVal || []);
                        });
                    }
                }
            )
        );

        this.searchResultsDialogController = new SearchResultsDialogController();

        this.scanResultModalController = new ScanResultModalController(getRootStore().localizationService.translate);

        this.switchModeModalController = getDashboardStores().switchModeModalController;

        // Expose computed properties for backward compatibility
        this.allowPredefined = this.rightBarController.allowPredefined;

        // Set up event listeners
        this._setupLibraryTreeEventListeners();
        if (this.allowPredefined) {
            this._setupPredefinedLibraryTreeEventListeners();
        }

        // Set up right bar event listeners
        this.rightBarController.on(RightBarEvents.OPEN_RIGHT_BAR, (isInputTextFocus) =>
            this.openRightBar(isInputTextFocus)
        );
        this.rightBarController.on(RightBarEvents.CLOSE_RIGHT_BAR, (isInputTextFocus) =>
            this.closeRightBar(isInputTextFocus)
        );

        // Main controller action events
        this.rightBarController.on(RightBarEvents.SELECT_CLICKED_RESOURCE, ({resource, roomId}) =>
            this.selectClickedResource(resource, roomId)
        );
        this.rightBarController.on(RightBarEvents.IMAGE_LOADED, (event) => this.imageLoaded(event));
        this.rightBarController.on(RightBarEvents.UPLOAD_LOCAL_IMAGE, (file) => {
            if (this.uploadLocalImage) {
                this.uploadLocalImage(file);
            }
        });
        this.rightBarController.on(RightBarEvents.FAILED_LOCAL_LOAD, (error) => {
            if (this.failedLocalLoad) {
                this.failedLocalLoad(error);
            }
        });
        this.rightBarController.on(RightBarEvents.OPEN_CUSTOMER_HISTORY_DIALOG, () => this.openCustomerHistoryDialog());
        this.rightBarController.on(RightBarEvents.TOGGLE_INTERACTION_SUMMARY_WIDGET, (data) => {
            if (this.toggleInteractionSummaryWidget) {
                this.toggleInteractionSummaryWidget(data);
            }
        });
        this.rightBarController.on(RightBarEvents.LOAD_CUSTOMER_HISTORY, ({refresh}) => {
            this._loadCustomerHistory(refresh).then((history) => {
                const rightBarState = this.dashboardState.rightBarState;
                const currentHistory = rightBarState.customerHistory;

                if (isEmpty(currentHistory) || (history && history.records && history.records.length > 0)) {
                    if (this.rightBarController) {
                        runInAction(() => {
                            this.rightBarController.setCustomerHistory(history);
                        });
                    } else {
                        runInAction(() => {
                            rightBarState.customerHistory = history ? {...history} : null;
                        });
                    }
                }

                runInAction(() => {
                    const histSectionOpen =
                        !rightBarState.imageSectionOpen &&
                        !rightBarState.historyEmpty &&
                        this.dashboardState.screenshots.length === 0;

                    rightBarState.histSectionOpen = histSectionOpen;

                    const libSectionOpen = rightBarState.libSectionOpen && !histSectionOpen;
                    rightBarState.libSectionOpen = libSectionOpen;
                });
            });
        });

        this.videoModeController = new VideoModeController(
            this.dashboardState.videoModeState,
            this.audioService,
            this.tsInterfaceHelper
        );

        const getEffectiveAudioMuted = () =>
            this.dashboardState.isObserve
                ? this.dashboardState.observerAudioMuted
                : this.dashboardState.dashboardRoomStorage.audioMuted;

        this._disposeMobxReactions.push(
            reaction(
                () => getEffectiveAudioMuted(),
                (audioMuted) => {
                    runInAction(() => {
                        this.dashboardState.videoModeState.isMicrophoneMuted = audioMuted;
                    });
                },
                {fireImmediately: true}
            )
        );

        this._disposeMobxReactions.push(
            reaction(
                () => ({
                    audioMuted: getEffectiveAudioMuted(),
                    isSessionActive: this.dashboardState.videoModeState.isAudioStreamConnected
                }),
                ({audioMuted, isSessionActive}) => {
                    if (isSessionActive && this.dashboardMediaService?.isSessionActive) {
                        this.dashboardMediaService.pauseAudioStream(audioMuted);
                    }
                },
                {fireImmediately: true}
            )
        );

        // Set up library dialog event listeners
        this.rightBarController.on(RightBarEvents.LIBRARY_ITEM_SELECTED, (item) => {
            if (item.data.type === 'img') {
                this.selectTool('arrow', true);
                this.setResource(item.data.resource ? {...item.data.resource, _fromLibrary: true} : item.data);
                runInAction(() => {
                    this.dashboardState.hideWidgets = false;
                    this.dashboardState.hideWifiScan = true;
                    this.dashboardState.isSquareFloatingVideo = false;
                });
                this?.wifiAnalyzerScanController.hide();

                if (this.libraryTaggingMode && item.data.resource) {
                    this._setPreloadedResource(item.data.resource);
                }

                // Update tree selection
                this.selectedLibraryNode = item.data;
                this.expandedLibraryNodes = this._expandParents(
                    this.rightBarController.getLibraryTreeData(),
                    item.parents || []
                );
            } else if (item.data.type === 'video') {
                this.selectTool('arrow', true);
                this.setResource(item.data.resource ? {...item.data.resource, _fromLibrary: true} : item.data);

                if (this.libraryTaggingMode && item.data.resource) {
                    this._setPreloadedResource(item.data.resource);
                }

                this.selectedLibraryNode = item.data;
                this.expandedLibraryNodes = this._expandParents(
                    this.rightBarController.getLibraryTreeData(),
                    item.parents || []
                );
            } else {
                this.selectedLibraryNode = this.prevSelectedLibraryImg;
                this.chatApi.sendText(item.data.url, {file: true});
            }
        });

        this.rightBarController.on(RightBarEvents.LIBRARY_ITEM_SEND, (item) => {
            if (item.data.type === 'img') {
                this.eventLog.dashboardSendingImage({
                    library: true,
                    mediaFileName: item.data.url
                });

                this.chatApi.sendImage(item.data.url, {
                    tags: [],
                    sharedBy: senderTypes.DASHBOARD,
                    mediaFileName: this.urlUtils.extractFileName(item.data.url)
                });
            }
        });

        this.customerHistoryModalController = new CustomerHistoryModalController();

        this.rightBarController.setUserType(this.UserType);

        // Set up search tags event listener
        this.rightBarController.searchTagsController.on(SearchTagsEvents.SEARCH_COMPLETE, (data) => {
            // Handle both formats: string (from form submit) or array (from search results)
            if (typeof data === 'string') {
                // Form submitted with search term - trigger the search
                this.searchForTags({searchTerm: data});
            } else {
                // Search results received
                this._handleSearchResults(data);
            }
        });

        // Set up WiFi scan history event listeners
        this.rightBarController.setupWifiScanListeners(
            (results, shouldShow) => {
                this._applyWifiScanResults(results, shouldShow);
            },
            () => {
                this.updateWifiScanScreen();
            }
        );

        this.rightBarController.setupVisualScanListeners(
            (results, shouldShow) => {
                this._applyWifiScanResults(results, shouldShow);
            },
            () => {
                this.updateWifiScanScreen();
            }
        );

        // errorDialogController already initialized in constructor
        this.resourceTypes = reduce(
            RESOURCE_TYPES,
            (resourceTypes, value) => {
                resourceTypes[value.type.toLowerCase()] = value.type;

                return resourceTypes;
            },
            {}
        );
        // We keep track of the last selected image, to reset selection when the
        // library  window is closed without a selection (or a non-image file selection)
        // this.translate already initialized in constructor

        this.libraryDialogRoot = this.translate('LIBRARY.VIEW.ROOT');
        // roomData already set by DashboardController
        this.offlineRoom = this.roomData.offline && !this.dashboardState.offlineMode;
        // accountData already set by DashboardController
        this.allowPredefined = this.accountData.settings ? this.accountData.settings.predefinedResources : false;
        this.allowPauseByAgent = this.accountData.settings ? this.accountData.settings.allowPauseByAgent : true;
        this.allowScreenPause = get(this.accountData, 'protectedSettings.liveSdk.allowScreenSharingPaused');
        this.enableVideoUploads = this.accountData.protectedSettings
            ? this.accountData.protectedSettings.allowUploadVideoClips
            : false;
        // Initialize enableHistory in RightBarState
        const enableHistoryValue = this.accountData.protectedSettings
            ? this.accountData.protectedSettings.enableHistory
            : false;
        runInAction(() => {
            this.dashboardState.clientRoomStorage.enableHistory = enableHistoryValue;
            this.dashboardState.rightBarState.enableHistory = enableHistoryValue;
        });

        this.rightBarController.displayHistory();
        // Keep local reference for backward compatibility during transition
        this.enableHistory = enableHistoryValue;
        this.saveSnapshots = enableHistoryValue && this.accountData.protectedSettings.saveSnapshots;
        this.imageTagging = this.accountData.protectedSettings
            ? this.accountData.protectedSettings.imageTagging
            : false;
        this.snappedImageAppearOnCanvas = get(this.accountData, 'protectedSettings.snappedImageAppearOnCanvas');
        this.cameraModeOnly = get(this.accountData, 'settings.cameraModeOnly');
        this.allowCoBrowsing = get(this.accountData, 'protectedSettings.coBrowsing.enabled');
        this.allowSwitchModeDuringInitiation =
            get(this.accountData, 'settings.allowSwitchModeDuringInitiation') && !this.cameraModeOnly;
        this.dashboardState.isHighImageSharingQuality =
            get(this.accountData, 'protectedSettings.imageSharingQuality') === 1;
        this.isHighImageSharingQuality = this.dashboardState.isHighImageSharingQuality;
        this.enableMobileSpeedtest = get(this.accountData, 'protectedSettings.mobileSpeedtest.enabled');
        this.displaySpeedtestGuidance = false;
        this.domUtilsService = getRootStore().domUtilsService;
        this.speedtestService = getRootStore().speedtestService;
        this.interactionSummary = null;
        this.interactionSummaryPreviews = [];
        this.onCloseGuidanceSpeedtest = this.onCloseGuidanceSpeedtest.bind(this);
        this.initCanvasClick = this.initCanvasClick.bind(this);

        this.dateFormat = get(this.accountData, 'protectedSettings.reportsDateFormat');
        // this.videoModeState already initialized in constructor

        if (this.enableMobileSpeedtest && this.isToggleEnabled_SessionToolbar()) {
            this.speedtestController = new SpeedtestController(this.translate, this.domUtilsService);
        }

        InteractionSummaryEventService.on(InteractionSummaryEvents.INTERACTION_SUMMARY, (data) => {
            // prettier-ignore
            if (find(this.dashboardState.interactionSummaryPreviews, (preview) => preview.creationTimestamp === data.creationTimestamp)) {
                return;
            }

            runInAction(() => {
                this.dashboardState.interactionSummaryPreviews = [
                    data,
                    ...this.dashboardState.interactionSummaryPreviews
                ];
            });
        });

        InteractionSummaryEventService.on(InteractionSummaryEvents.INTERACTION_SUMMARY_LOG, (log) => {
            if (get(log, 'isError')) {
                this.eventLog.getInteractionSummaryFailed(log.data);
            } else {
                this.eventLog.getInteractionSummarySuccess();
            }
        });

        InteractionSummaryEventService.on(InteractionSummaryEvents.SEND_SELECTED_IMAGE, (image) => {
            this.selectClickedResource({url: image});
        });

        // expandRightBar is managed in RightBarState only
        this.isInputTextFocus = false;
        // this.dir already initialized in constructor
        this.videos = [];
        this.isPaused = false;
        // preloadedVideo already set by DashboardController

        runInAction(() => {
            this.dashboardState.currentResource = {};
        });

        this.clientDisconnected = false;
        this.tsScanArea = getDashboardStores().tsScanArea;

        // Initialize TsLoaderController
        this.tsLoaderController = new TsLoaderController(
            this.chatApi,
            this.environmentDetect,
            getRootStore().tsLocaleHelper
        );

        this.clickCanvasTime = null;
        this.videoClickPosition = {};
        this.activeTool = 'arrow';
        runInAction(() => {
            this.dashboardState.miniDashboardActiveTool = 'arrow';
            this.dashboardState.miniDashboardActiveColor =
                this.annotateService?.toolkit?.color || this.colors?.[6]?.hexCode || '#ff0000';
        });
        runInAction(() => {
            this.dashboardState.showLocationPopover = false;
        });
        this.isMobileDashboard = this.environmentDetect.isMobile();
        this.isDesktopView = this.environmentDetect.isDesktop();
        this.magicMarkerSettings = get(this.accountData, 'protectedSettings.magicMarker');
        this.allowMagicMarker =
            get(this.magicMarkerSettings, 'dashboard.enable') &&
            (!this.isMobileDashboard || get(this.magicMarkerSettings, 'dashboard.enableMobile'));
        this.allowCustomerMagicMarker = this.allowMagicMarker && get(this.magicMarkerSettings, 'client.enable');
        this.triggeredDataCollectionOnAgentMagicMarkerEnabled = get(
            this.accountData,
            'protectedSettings.triggeredDataCollection.enableOnAgentMagicMarker'
        );
        this.triggeredDataCollectionOnCustomerMagicMarkerEnabled = get(
            this.accountData,
            'protectedSettings.triggeredDataCollection.enableOnCustomerMagicMarker'
        );
        this.triggeredDataCollectionOnAgentImageSnappedEnabled = get(
            this.accountData,
            'protectedSettings.triggeredDataCollection.enableOnAgentImageSnapped'
        );
        this.connectivityGuruThreshold = get(this.accountData, 'protectedSettings.connectivityGuru');
        this.IMAGE_MODES = IMAGE_MODES;

        this.streamAction = debounce(this._streamActionOnce, 300, {
            leading: true,
            trailing: false
        });

        this.loaderText = this.translate('MAIN.VIEW.IDLE_CONNECTING');
        this.zoomFactor = 1;
        this.showWizard = !this.offlineRoom && !this.dashboardState.offlineMode;
        runInAction(() => {
            this.dashboardState.showWizard = this.showWizard;
        });
        // Initialize hideHistory in RightBarState
        const hideHistoryValue =
            !get(this.accountData, 'protectedSettings.showHistoryInSession') && !this.dashboardState.offlineMode;
        runInAction(() => {
            this.dashboardState.rightBarState.hideHistory = hideHistoryValue;
        });
        // Keep local reference for backward compatibility during transition
        this.hideHistory = hideHistoryValue;

        this.saveScreenshotsOnLocalStorage = utils.isInIframe(window) || (this.miniDashboard && !this.isDesktopView);
        this.initScreenshots();

        const rootStore = getRootStore();
        this.wifiAnalyzerController = new WifiAnalyzerController(
            rootStore.environmentService,
            rootStore.eventsLogService,
            rootStore.wifiAnalyzerService,
            rootStore.getDateFormattedByAccLocal.bind(rootStore),
            rootStore.displayTabletAsDesktop
        );
        this.wifiAnalyzerScanController = new WifiAnalyzerScanController(
            this.connectivityGuruThreshold,
            false, // isVisible
            0, // currentTab
            this.translate,
            this.chatApi,
            this.roomData,
            rootStore.wifiAnalyzerService,
            this.rightBarController.enableAgentWifiScanHistory,
            this.resetWifiScanStatus,
            this.setWifiScanDataForWifiAnalyzer,
            this.selectClickedResource.bind(this),
            this.displayToastMessage.bind(this),
            () => this.annotateService.clearObjects(),
            rootStore.environmentService,
            rootStore.eventsLogService,
            rootStore.getDateFormattedByAccLocal.bind(rootStore),
            rootStore.displayTabletAsDesktop
        );

        // Set up event listeners for wifi analyzer scan controller
        this._setupWifiAnalyzerScanListeners();

        // wifiAnalyzerMode already set before early return
        this.updateWifiScanHistory().then();

        if (
            !this.hideHistory &&
            !this.offlineRoom &&
            !this.showWizardSetting &&
            !this.dashboardState.offlineMode &&
            !isEmpty(this.chatApi.dashboard) &&
            !(this.chatApi.dashboard.roomStarted && this.chatApi.client.connected)
        ) {
            // If the customer has a history, we show that to the dashboard user,
            // instead of waiting in the entry screen
            this.openCustomerHistoryDialog();
        }

        const startDateValue = this.startDate ? new Date(this.startDate) : undefined;
        const endDateValue = this.endDate ? new Date(this.endDate) : new Date();

        startDateValue?.setHours(0, 0, 0, 0);
        endDateValue.setHours(23, 59, 59, 999);

        // Right bar section states - initialize in RightBarState only
        const rightBarStateSections = this.dashboardState.rightBarState;
        const imageSectionOpen =
            this.dashboardState.offlineMode &&
            !rightBarStateSections.videoSectionOpen &&
            !rightBarStateSections.libraryTaggingMode;
        const videoSectionOpen =
            this.dashboardState.offlineMode && !imageSectionOpen && !rightBarStateSections.libraryTaggingMode;
        runInAction(() => {
            rightBarStateSections.imageSectionOpen = imageSectionOpen;
            rightBarStateSections.videoSectionOpen = videoSectionOpen;
        });
        this.isAsianLanguage = this.accountData.settings.language === 'jp_JP';

        if ((this.dashboardState.offlineMode && !this.dashboardState.libraryTaggingMode) || this.observe) {
            this._restoreOfflineHistory();
        }

        this.searchTags = this.accountData.protectedSettings
            ? this.accountData.protectedSettings.imageTagging && this.accountData.protectedSettings.searchTags
            : false;
        this.searchHistoryTags =
            (this.accountData.protectedSettings ? this.accountData.protectedSettings.searchHistoryTags : false) &&
            !this.libraryTaggingMode &&
            !this.hideHistory;
        this.searchLibraryTags = this.accountData.protectedSettings
            ? this.accountData.protectedSettings.searchLibraryTags
            : false;

        if (this.dashboardState.videoModeState.preloadedImage.resource) {
            this.setResource(this.dashboardState.videoModeState.preloadedImage.resource);
            this.rightBarController.ensureImageSectionOpenForResource(
                this.dashboardState.videoModeState.preloadedImage.resource
            );
        } else if (this.preloadedVideo.resource) {
            this.setResource(this.preloadedVideo.resource);
        }

        this.scanners = scanners;
        this.textScanner = find(this.scanners, (scan) => get(scan, 'settings.reportName') === SCANNERS.TEXT.reportName);
        this.searchScannedTags =
            this.dashboardState.showScanners &&
            this.accountData.protectedSettings.searchScannedTags &&
            this.libraryTaggingMode;

        this.getSnapshotReminderLocation = this.getSnapshotReminderLocation.bind(this);
        this.agentSnapshotReminder =
            // eslint-disable-next-line no-constant-binary-expression
            {
                ...get(this.accountData, 'settings.agentSnapshotReminder'),
                roomId: this.roomData._id
            } || {};

        this.snapshotReminderController = new TsSnapshotReminderController(
            this.agentSnapshotReminder.autoCloseTimeout,
            this.getSnapshotReminderLocation,
            'center',
            this.dir
        );

        // Bind dashboard title handlers used by React component
        this.handleDashboardTitleAction = this.handleDashboardTitleAction.bind(this);

        this._disposeMobxReactions.push(
            reaction(
                () => get(this.video, 'focus'),
                (newValue, oldValue) => {
                    if ((oldValue && !newValue) || (!oldValue && newValue)) {
                        this.tsSnapshotReminderService.videoFocusChanged(newValue);
                    }
                }
            )
        );

        this.autoDataCollection = this.observe
            ? {enabled: false}
            : this.accountData.protectedSettings && this.accountData.protectedSettings.autoDataCollection;
        this.tsSharingService.uploadAutoCollectedImage = this.tsSharingService.uploadAutoCollectedImage.bind(
            this.tsSharingService
        );

        this.autoDataCollectionServices.initAutoDataCollection(
            this.autoDataCollection,
            this._isCaptureAvailable.bind(this),
            this._getSnapshotFromKnownStream.bind(this),
            this._snapshotToImg,
            this.tsSharingService.uploadAutoCollectedImage
        );

        runInAction(() => {
            this.videoModeState.videoState.roomId = this.roomData._id;
            this.videoModeState.videoState.accountId = this.accountData._id;
        });

        this.imageEditToolsController = new TsImageEditToolsController(this.annotateService, {
            showScanners: this.dashboardState.showScanners,
            imageMode: this.dashboardState.imageMode,
            useNewInterface: this.tsInterfaceHelper.useNewInterface,
            scanCaptureDesignEnabled: this.dashboardState.isToggleEnabled_ScanCaptureDesign
        });

        this.imageEditToolsController.on('cancel', () => this.cancel());
        this.imageEditToolsController.on('selectedScanMode', () => this.selectedScanMode());
        this.imageEditToolsController.on('scan', () => {
            this.scan();
        });

        // Initialize tsWidgetsController here since imageEditorController is already available
        this.tsWidgetsController = new TsWidgetsController(
            this.dashboardState,
            this.handleDashboardTitleAction,
            this.videoModeController,
            this.imageEditorController,
            this.imageEditToolsController
        );

        this.CLIENT_IN_PHOTO_MODE_STATES = CLIENT_IN_PHOTO_MODE_STATES;

        this.CLASSIFY_EVENT_SOURCES = __CLASSIFY_EVENT_SOURCES;

        this.tsSnapshotReminderService.init(this.agentSnapshotReminder);

        if (this.miniDashboard) {
            this.miniDashboardScanError = this.translate('DASHBOARD_MINI.SCAN_ERROR');
        }

        // Handle snapshots that existed before state load, probably page refreshed
        if (!isEmpty(this.dashboardState.screenshots) && !this.dashboardState?.currentResource?.url) {
            this.setResource(last(this.dashboardState.screenshots), true);
            this.scrollToImagesTop();

            // Update RightBarState
            runInAction(() => {
                this.dashboardState.rightBarState.imageSectionOpen = true;
            });

            if (this.isIE11) {
                this._ieRedrawRightSidebar();
            }
        }

        this._disposeMobxReactions.push(
            reaction(
                () => this.dashboardState.screenshots.length,
                () => {
                    if (!isEmpty(this.dashboardState.screenshots)) {
                        this.hasScreenshots = true;
                    }
                    // Update histSectionOpen based on screenshots: hide history when screenshots exist
                    const rightBarState = this.dashboardState.rightBarState;
                    if (
                        rightBarState.enableHistory &&
                        !rightBarState.hideHistory &&
                        !rightBarState.libraryTaggingMode
                    ) {
                        const shouldBeOpen =
                            !rightBarState.historyEmpty && this.dashboardState.screenshots.length === 0;
                        if (rightBarState.histSectionOpen !== shouldBeOpen) {
                            runInAction(() => {
                                rightBarState.histSectionOpen = shouldBeOpen;
                            });
                        }
                    }
                }
            )
        );

        this._disposeMobxReactions.push(
            reaction(
                () => get(this.dashboardState?.currentResource, 'url'),
                () => {
                    const cr = this.dashboardState?.currentResource;
                    if (get(cr, 'url')) {
                        this.setCurrentResource({
                            ...cr,
                            type: 'url',
                            url: get(cr, 'url'),
                            useOriginalImage: this.isHighImageSharingQuality
                        });
                    }
                }
            )
        );

        this.requestMode = this.requestMode.bind(this);

        this._disposeMobxReactions.push(
            reaction(
                () => this.dashboardState.modesEnabled,
                () => {
                    if (!this.observe) {
                        const leftBarController = this.leftBarController;

                        if (leftBarController) {
                            leftBarController.disableEnableModes(this.dashboardState.modesEnabled);

                            if (this.dashboardState.modesEnabled) {
                                leftBarController.setSwitchModes(this.requestMode);
                                runInAction(() => {
                                    this.dashboardState.hideWifiScan = true;
                                });
                            }
                        }
                    }
                },
                {fireImmediately: true}
            )
        );

        this._disposeMobxReactions.push(
            reaction(
                () => this.dashboardState.isDesktopSharingSession,
                () => {
                    runInAction(() => {
                        this.dashboardState.sessionInfo.isDesktopSharing = this.dashboardState.isDesktopSharingSession;
                    });
                }
            )
        );

        this._disposeMobxReactions.push(
            reaction(
                () => this.dashboardState.isScreenMirroring,
                () => {
                    this.rightBarController.setIsScreenMirroring();
                }
            )
        );

        this._disposeMobxReactions.push(
            reaction(
                () => this.dashboardState.isVideoApplicationMode,
                () => {
                    this.rightBarController.setIsVideoApplicationMode();
                }
            )
        );

        // Synchronize accordion sections - only one can be open at a time
        const rightBarState = this.dashboardState.rightBarState;
        this._disposeMobxReactions.push(
            reaction(
                () => rightBarState.imageSectionOpen,
                (newValue) => {
                    if (newValue) {
                        runInAction(() => {
                            rightBarState.histSectionOpen = false;
                        });
                        this.rightBarController.setLibSectionOpen(false);
                        this.rightBarController.setMsgSectionOpen(false);
                        this.rightBarController.wifiScanHistoryController.sectionOpen = false;
                        this.rightBarController.visualScanHistoryController.sectionOpen = false;
                    }
                }
            )
        );

        this._disposeMobxReactions.push(
            reaction(
                () => rightBarState.histSectionOpen,
                (newValue) => {
                    if (newValue) {
                        runInAction(() => {
                            rightBarState.imageSectionOpen = false;
                        });
                        this.rightBarController.setLibSectionOpen(false);
                        this.rightBarController.setMsgSectionOpen(false);
                        this.rightBarController.wifiScanHistoryController.sectionOpen = false;
                        this.rightBarController.visualScanHistoryController.sectionOpen = false;
                    }
                }
            )
        );

        this._disposeMobxReactions.push(
            reaction(
                () => this.rightBarController.libSectionOpen,
                (newValue) => {
                    if (newValue) {
                        runInAction(() => {
                            rightBarState.imageSectionOpen = false;
                            rightBarState.histSectionOpen = false;
                        });
                        this.rightBarController.wifiScanHistoryController.sectionOpen = false;
                        this.rightBarController.visualScanHistoryController.sectionOpen = false;
                    }
                }
            )
        );

        this._disposeMobxReactions.push(
            reaction(
                () => this.rightBarController.msgSectionOpen,
                (newValue) => {
                    if (newValue) {
                        runInAction(() => {
                            rightBarState.imageSectionOpen = false;
                            rightBarState.histSectionOpen = false;
                        });
                        this.rightBarController.wifiScanHistoryController.sectionOpen = false;
                        this.rightBarController.visualScanHistoryController.sectionOpen = false;
                    }
                }
            )
        );

        this._disposeMobxReactions.push(
            reaction(
                () => this.rightBarController.wifiScanHistoryController.sectionOpen,
                (newValue) => {
                    if (newValue) {
                        runInAction(() => {
                            rightBarState.imageSectionOpen = false;
                            rightBarState.histSectionOpen = false;
                        });
                        this.rightBarController.setLibSectionOpen(false);
                        this.rightBarController.setMsgSectionOpen(false);
                        this.rightBarController.visualScanHistoryController.sectionOpen = false;
                    }
                }
            )
        );

        this._disposeMobxReactions.push(
            reaction(
                () => this.rightBarController.visualScanHistoryController.sectionOpen,
                (newValue) => {
                    if (newValue) {
                        runInAction(() => {
                            rightBarState.imageSectionOpen = false;
                            rightBarState.histSectionOpen = false;
                        });
                        this.rightBarController.setLibSectionOpen(false);
                        this.rightBarController.setMsgSectionOpen(false);
                        this.rightBarController.wifiScanHistoryController.sectionOpen = false;
                    }
                }
            )
        );

        if (this.miniDashboard) {
            this.liveVideoText = this.translate('DASHBOARD_MINI.VIEW.CAMERA_LIVE');
        }

        const onClickStep = (step) => {
            if (get(step, 'image.url')) {
                this.setResource({url: step.image.url});
            }
        };

        this._disposeMobxReactions.push(
            reaction(
                () => get(this.dashboardMediaService, 'isVoipEnabled'),
                () => {
                    this.audioService.checkIfVoipIsNotEnable();
                }
            )
        );

        this._disposeMobxReactions.push(
            reaction(
                () =>
                    this.dashboardState.videoModeState.isAudioStreamConnected &&
                    this.dashboardState.clientRoomStorage.audioHandshakeSuccess !== false,
                () => {
                    this.audioService.establishAudioStream();
                }
            )
        );

        this.dashboardState.floatingToolbarState.isFlashlightAvailableOnClient = this.isToggleEnabled_flashLight();

        this.resourcesListener();

        // mainController is now set directly in imageEditorDependencies, no need to call setMainController

        if (this.meetingSyncEnabled) {
            this.syncMeeting();
        }

        const tsVideoSubscriberControllerDeps = {
            chatApi: this.chatApi,
            environmentDetect: this.environmentDetect,
            displayTabletAsDesktop: this.displayTabletAsDesktop,
            tsScanArea: this.tsScanArea,
            tsScan: this.tsScsan,
            dashboardState: this.dashboardState,
            tsInterfaceHelper: this.tsInterfaceHelper,
            tsSnapshotReminder: this.tsSnapshotReminderService,
            responsiveUtils: this.responsiveUtils,
            eventLog: this.eventLog,
            mediaService: this.dashboardMediaService,
            isMiniDashboard: this.miniDashboard,
            isLivePointerEnabled: this.isLivePointerOnMobileDashboardEnabled,
            isMinimizedToBottomRight: false
        };

        this.tsVideoSubscriberController = new TsVideoSubscriberController(tsVideoSubscriberControllerDeps);
        this.TsVideoSubscriberControllerEvents();

        const floatingToolbarServices = {
            tsCanvasAnnotate: getRootStore().tsCanvasAnnotate,
            environmentService: getRootStore().environmentService,
            displayTabletAsDesktop: getRootStore().displayTabletAsDesktop,
            domUtilsService: getRootStore().domUtilsService,
            localizationService: getRootStore().localizationService,
            speedtestService: getRootStore().speedtestService,
            roomService: getRootStore().roomService,
            eventsLogService: getRootStore().eventsLogService
        };

        const tsFloatingToolbarController = new TsFloatingToolbarController(
            this.dashboardState,
            this.accountData,
            floatingToolbarServices
        );

        Object.defineProperty(this, 'tsFloatingToolbarController', {
            value: tsFloatingToolbarController,
            writable: false,
            enumerable: false,
            configurable: false
        });

        this.setupToolbarEventListeners();

        // ========== Main Handlers (from _initMainHandlers) ==========
        this._imageSavedListener = (message) => this.saveImage(message);
        this._toolDeselectListener = () => {
            this.activeTool = 'hand';
            runInAction(() => {
                this.dashboardState.miniDashboardActiveTool = 'hand';
            });
        };
        this._zoomChangeListener = (zoom) => (this.zoomFactor = zoom);
        this._busyListener = () => runInAction(() => (this.dashboardState.modesEnabled = false));
        this._freeListener = () => this._checkModesAvailability();
        this._clientConnectionListener = () => {
            this._checkModesAvailability();
            if (get(this.chatApi, 'client.connected')) {
                this.syncMeeting();
            }
        };
        this._clientPhotoSelectionDialogStateListener = (event, param) => {
            if (
                this.mode === MeetingMode.images &&
                !this.dashboardState.clientInPhotoModeState &&
                param === 'IN_PHOTO_CHAT'
            ) {
                runInAction(() => {
                    this.dashboardState.clientInPhotoModeState = this.CLIENT_IN_PHOTO_MODE_STATES.FIRST_TIME;
                });
            } else if (
                this.dashboardState.clientInPhotoModeState === this.CLIENT_IN_PHOTO_MODE_STATES.FIRST_TIME &&
                get(this.dashboardState?.currentResource, 'url')
            ) {
                runInAction(() => {
                    this.dashboardState.clientInPhotoModeState = this.CLIENT_IN_PHOTO_MODE_STATES.RECCURING;
                });
            }
        };
        this._clientLogListener = (log) => {
            if (this.showWizard) {
                if (log.name === 'CUSTOMER_OPENED_THE_CAMERA') {
                    this.goToWizardStep(1);
                } else if (log.name === 'CUSTOMER_UPLOADING_AN_IMAGE') {
                    this.finishWizard();
                }
            }
        };
        this._failedImageFromUrlListener = () => this.handleImageDownloadFail();
        this._failedVideoFromUrlListener = () =>
            this.errorDialogController.show('ERROR_DIALOG.VIEW.VIDEO_FAILED_TO_LOAD');
        this._resourceUpdateListener = (message) => this._updateResources(message.data);
        this._messageReceivedListener = (message) => this.checkIfTextMessage(message);
        this._clientVisibleListener = (param, state) => {
            runInAction(() => {
                this.videoModeState.videoState.isClientVisible = state;
            });

            if (state) {
                this._freeListener();
            } else {
                this._busyListener();
            }
        };
        this._isTorchOnListener = (state) => {
            this.isTorchActive = state;

            if (this.floatingToolbarFlashlightHandlers) {
                this.isTorchActive
                    ? this.floatingToolbarFlashlightHandlers.activate()
                    : this.floatingToolbarFlashlightHandlers.deactivate();
            }
        };
        this._isTorchAvailableListener = (isAvailable) => {
            runInAction(() => {
                this.dashboardState.floatingToolbarState.isFlashlightAvailableOnClient = isAvailable;
            });
        };
        this._speedtestResultsListener = (param, data) => {
            this.speedtestService.resultsHandler(data);
        };
        this._postResourceListener = (data) => {
            const {resourceUrl} = data;

            this.setResource({url: resourceUrl});
            this.eventLog.postResourceToSession({url: resourceUrl});
            this._addToScreenShots({url: resourceUrl});
        };
        this._onCanvasFreshChange = (value) =>
            runInAction(() => {
                this.dashboardState.canvasIsFresh = value;
            });
        this._onCanvasAnnotatedChange = (value) =>
            runInAction(() => {
                this.dashboardState.isAnnotated = value;
            });
        this._onCanvasImageReady = () =>
            runInAction(() => {
                this.dashboardState.canvasReady = true;
            });
        this._onVideoIsActive = (isActive) => {
            if (!this.dashboardState?.videoControlState) {
                console.error('onVideoIsActive: videoControlState not available');
                return;
            }
            runInAction(() => {
                this.dashboardState.videoControlState.isActive = isActive;
            });
        };
        this._onVideoReady = (videoReady) => {
            if (!this.dashboardState?.videoControlState) {
                console.error('onVideoReady: videoControlState not available');
                return;
            }
            runInAction(() => {
                this.dashboardState.videoControlState.videoReady = videoReady;
            });
        };

        this.chatApi.on('clientAudioHandshakeSuccess', () => {
            this.audioService.checkClientAudioHandshake();
        });
        this.chatApi.on('log', this._clientLogListener);
        this.chatApi.on('imageSave', this._imageSavedListener);
        this.chatApi.on('clientConnected', this._clientConnectionListener);
        this.chatApi.on('clientPhotoSelectionDialogState', this._clientPhotoSelectionDialogStateListener);
        this.chatApi.on('clientVisible', this._clientVisibleListener);
        this.chatApi.on('isTorchOnAction', this._isTorchOnListener);
        this.chatApi.on('isTorchAvailableAction', this._isTorchAvailableListener);
        this.chatApi.on('clientSpeedtestResults', this._speedtestResultsListener);
        this.chatApi.on('resourcesUpdated', this._resourceUpdateListener);
        this.chatApi.on('message', this._messageReceivedListener);
        this.annotateService.on('tool:deselect', this._toolDeselectListener);
        this.annotateService.on('zoom:change', this._zoomChangeListener);
        this.annotateService.on('canvas:failedtoloadurl', this._failedImageFromUrlListener);
        this.annotateService.on('canvas:fresh:change', this._onCanvasFreshChange);
        this.annotateService.on('canvas:annotated:change', this._onCanvasAnnotatedChange);
        this.annotateService.on('canvas:imageReady', this._onCanvasImageReady);
        this.annotateService.on('canvas:false', () =>
            runInAction(() => {
                this.dashboardState.canvasReady = false;
            })
        );

        try {
            this.videoControlService.on('video:isActive', this._onVideoIsActive);
            this.videoControlService.on('video:ready', this._onVideoReady);
            this.videoControlService.on('video:failedtoloadurl', this._failedVideoFromUrlListener);
        } catch (error) {
            console.error('Error setting up videoControlService listeners:', error);
            console.error('videoControlService:', this.videoControlService);
            throw error;
        }

        try {
            runInAction(() => {
                this.dashboardState.dashboardControllerLoaded = true;
            });
        } catch (error) {
            console.error('Error setting dashboardControllerLoaded:', error);
            console.error('dashboardState:', this.dashboardState);
            throw error;
        }
        // Sync initial state from service
        this._syncVideoControlState();
        this.busy.on('busy', this._busyListener);
        this.busy.on('free', this._freeListener);
        // this.tsCobrowsing.on(this.tsCobrowsing.EVENTS.INIT_ERROR, coBrowsingInitErrorListener);
        // this.tsCobrowsing.on(this.tsCobrowsing.EVENTS.ERROR, coBrowsingErrorListener);
        this.jsApiService.on('postResource', this._postResourceListener);
    }

    get recordingStatus() {
        return get(this.chatApi, 'dashboard.recordingStatus');
    }

    get isRecording() {
        return this.recordingStatus === RECORDING_STATUS.started;
    }

    get isRecordingFailed() {
        return this.recordingStatus === RECORDING_STATUS.failed;
    }

    clearLastEvent() {
        runInAction(() => {
            this.dashboardState.lastEvent = null;
        });
    }

    @action
    setMessageAlert(label, color, timeout) {
        if (this.miniDashboard) {
            runInAction(() => {
                this.dashboardState.lastEvent = {text: label};
            });

            return;
        }

        clearTimeout(this.alertMessageTimeout);

        this.dashboardState.messageAlert = {label, color, display: true};
        this.alertMessageTimeout = setTimeout(() => {
            runInAction(() => {
                this.dashboardState.messageAlert = null;
            });
            this.alertMessageTimeout = null;
        }, timeout);
    }

    topBarSave() {
        return this.libraryTaggingMode ? this.saveImageLibrary : this.saveResource;
    }

    topBarLeaveRoom() {
        return this.libraryTaggingMode ? this.exitOfflineMode : this.leaveOfflineRoom;
    }

    async getInteractionSummaryData(callParams, page, perPage) {
        return await this.interactionSummaryHelperService.getSummaryData(callParams, page, perPage);
    }

    async getInteractionSummaryPreviews(enableAIInteractionSummary, enableVJInteractionSummary) {
        try {
            const res = await this.interactionSummaryHelperService.getSummaryPreviews(
                this.customerId,
                enableAIInteractionSummary,
                enableVJInteractionSummary,
                this.setInteractionSummarySessionSource.bind(this)
            );

            this.eventLog.getInteractionSummaryPreviewsSuccess();

            return res;
        } catch (err) {
            this.eventLog.getInteractionSummaryPreviewsFailed({err});

            return [];
        }
    }

    getDateFormattedByAcc(date) {
        return getRootStore().getDateFormattedByAcc(date, this.accountData.protectedSettings.reportsDateFormat);
    }

    startRecording() {
        this.recordStatusChanged(RECORDING_STATUS.starting);

        setTimeout(() => {
            if (this.recordingStatus === RECORDING_STATUS.starting) {
                this.recordStatusChanged(RECORDING_STATUS.failed);
                this.setMessageAlert(
                    this.translate('REACT.DASHBOARD.VIEW.RECORD.FAILED_TO_START'),
                    RECORDING_ERROR_COLOR,
                    RECORDING_MESSAGE_ALERT_TIMEOUT
                );
            }
        }, RECORDING_FAILED_TIMEOUT);

        this.roomService
            .startRecording(this.roomData._id, {
                accountId: this.accountData._id,
                hasAudio: this.audioService.hasAudioStream()
            })
            .catch((err) => {
                this.eventLog.failedToStartRecording({
                    err
                });

                this.recordStatusChanged(RECORDING_STATUS.failed);
                this.setMessageAlert(
                    this.translate('REACT.DASHBOARD.VIEW.RECORD.FAILED_TO_START'),
                    RECORDING_ERROR_COLOR,
                    RECORDING_MESSAGE_ALERT_TIMEOUT
                );
            });
    }

    stopRecording() {
        const accountId = this.accountData._id;

        this.recordStatusChanged(RECORDING_STATUS.stopping);

        setTimeout(() => {
            if (this.recordingStatus === RECORDING_STATUS.stopping) {
                this.recordStatusChanged(RECORDING_STATUS.failed);
                this.setMessageAlert(
                    this.translate('REACT.DASHBOARD.VIEW.RECORD.FAILED_TO_STOP'),
                    RECORDING_ERROR_COLOR,
                    RECORDING_MESSAGE_ALERT_TIMEOUT
                );
            }
        }, RECORDING_FAILED_TIMEOUT);

        this.roomService
            .stopRecording(this.roomData._id, {
                accountId: accountId
            })
            .catch((err) => {
                this.eventLog.failedToStopRecording({
                    err
                });

                this.recordStatusChanged(RECORDING_STATUS.failed);
                this.setRecordingFailedMessage(
                    this.translate('REACT.DASHBOARD.VIEW.RECORD.FAILED_TO_STOP'),
                    RECORDING_ERROR_COLOR,
                    RECORDING_MESSAGE_ALERT_TIMEOUT
                );
            });
    }

    onRecordButton() {
        if (this.recordingStatus === RECORDING_STATUS.started) {
            return this.stopRecording();
        } else if (this.recordingStatus === RECORDING_STATUS.ready) {
            return this.startRecording();
        }
    }

    recordStatusChanged(status) {
        if (get(this.accountData, 'protectedSettings.recording.onDemand.enabled')) {
            this.chatApi.setStatus('recordingStatus', status);
        }
    }

    /**
     * Closes each on-demand clip with sessionRecordingEnded — sessionRecordingStarted is
     * already emitted on every start — so the embedding component can toggle its own
     * controls and bookmark button.
     */
    _emitOnDemandRecordingState(status) {
        if (!this.dashboardState.floatingToolbarState.isOnDemandRecordingMode) {
            return;
        }

        if (status === RECORDING_STATUS.started) {
            this._onDemandClipStartedAt = Date.now();

            return;
        }

        const clipWasCapturing = !!this._onDemandClipStartedAt;
        const clipEnded = [RECORDING_STATUS.ready, RECORDING_STATUS.failed].includes(status);

        if (clipWasCapturing && clipEnded) {
            const clipDurationSec = Math.round((Date.now() - this._onDemandClipStartedAt) / 1000);

            this._onDemandClipStartedAt = null;

            this.jsApiService.sessionRecordingEnded({
                type: MessageType.sessionRecordingEnded,
                sessionId: this.roomData._id,
                clipDurationSec
            });
        }
    }

    observerClick() {
        runInAction(() => {
            this.dashboardState.displayObserverSendingForm = !this.dashboardState.displayObserverSendingForm;
        });
    }

    observerTabChange(value) {
        runInAction(() => {
            this.dashboardState.observationCurrentTab = value;
        });
    }

    setPhoneToInviteObserver(value) {
        runInAction(() => {
            this.dashboardState.phoneToInviteObserver = value;
        });
    }

    setEmailToInviteObserver(value) {
        runInAction(() => {
            this.dashboardState.emailToInviteObserver = value;
        });
    }

    connectToMeeting() {
        trace.info('Connecting to meeting');

        this._initMeetingHandlers();

        this._initialSyncHandler = () => {
            trace.info('Initial sync');

            Promise.resolve()
                .then(() => this.syncLanguage())
                .then(() => this.syncVideoSupport())
                .then(() => this.syncAudioSupport())
                .then(() => (this.meetingSyncEnabled = true))
                .then(() => this.syncMeeting())
                .catch((error) => {
                    this.meetingSyncEnabled = true;
                    trace.warn('Error during start meeting flow', error && error.toString());
                });
        };

        this.chatApi.once('sync', this._initialSyncHandler);

        if (this.observe) {
            this.chatApi.connect(this.roomData._id, UserType.supervisor, null, this.currentUser._id);
        } else {
            this.chatApi.connect(this.roomData._id, UserType.dashboard, this.roomCode);
        }
    }

    _logIfPluginUnavailable() {
        const {videoPlayback} = this.dashboardMediaService.deviceSupportInfo;

        if (!videoPlayback && this.dashboardState.mediaServiceType === MEDIA_SERVICE.TURNSERVER) {
            this.eventLog.turnError({
                side: PlatformType.dashboard,
                description: 'plugin is not installed or disabled',
                error: 'PluginUnavailable',
                mediaServiceType: MEDIA_SERVICE.TURNSERVER
            });
        }
    }

    syncLanguage() {
        this.chatApi.setStatus('language', this.localeHelper.getLocale());

        return Promise.resolve();
    }

    _syncVideoControlState() {
        if (!this.videoControlService) {
            console.error('_syncVideoControlState: videoControlService is not available');
            return;
        }

        if (!this.dashboardState?.videoControlState) {
            console.error('_syncVideoControlState: dashboardState.videoControlState is not available');
            return;
        }

        try {
            runInAction(() => {
                this.dashboardState.videoControlState.isActive = this.videoControlService.isActive;
                this.dashboardState.videoControlState.videoReady = this.videoControlService.videoReady;
                this.dashboardState.videoControlState.videoChangeLock = this.videoControlService.videoChangeLock;
            });
        } catch (error) {
            console.error('_syncVideoControlState: Error in runInAction:', error);
            throw error;
        }
    }

    syncVideoSupport() {
        if (this.cameraModeOnly && !this.allowScreenShare) {
            trace.info('Dashboard video playback support not needed, setting support false');

            this.chatApi.setStatus('videoSupport', false);
        } else {
            const {webRtcSupportInfo, videoPlayback} = this.dashboardMediaService.deviceSupportInfo;
            const isVideoSupported = videoPlayback && webRtcSupportInfo.isWebRTCSupported;

            trace.info('Dashboard video playback supported', isVideoSupported);

            this.chatApi.setStatus('videoSupport', isVideoSupported);
        }

        return Promise.resolve();
    }

    syncAudioSupport() {
        return Promise.resolve().then(() => {
            this.audioService.enableVoipDuringSession();
        });
    }

    get isScreenModes() {
        return utils.isModeSupportNativeVideoSharing(get(this.chatApi, 'client.mode'));
    }

    get isSupportAudio() {
        return this.chatApi.dashboard.audioSupport && utils.isAudioAvailableInMode(get(this.chatApi, 'client.mode'));
    }

    syncMeeting() {
        if (!this.meetingSyncEnabled) {
            trace.info('Sync arrived from BE, but not ready to sync yet');

            return Promise.resolve();
        }

        runInAction(() => {
            this.dashboardState.areBothSidesConnected = this.chatApi.areBothSidesConnected();
            this.dashboardState.dashboardRoomStorage.audioSupport = this.chatApi.dashboard.audioSupport;
            this.dashboardState.dashboardRoomStorage.audioHandshakeSuccess =
                this.chatApi.dashboard.audioHandshakeSuccess;
            this.dashboardState.dashboardRoomStorage.audioMuted = !!this.chatApi.dashboard.audioMuted;
        });

        trace.info('Start syncMeeting flow');

        return Promise.resolve()
            .then(() => this.syncRoom())
            .then(() => this.syncMediaSession())
            .then(() => this.syncRoute())
            .then(() => this.syncAgentGuidance())
            .then(() => this.syncDeviceDetails())
            .then(() => this.syncCountries())
            .then(() => this.syncLeftBar())
            .then(() => this.syncTopBar())
            .then(() => this.syncFeatures())
            .then(() => this.syncMeetingState())
            .catch((error) => {
                trace.info('Sync meeting flow error', error);
            });
    }

    syncRoom() {
        // Initial connectivity, in case user already connected during invite
        if (this.dashboardState.connectionStatus === CONNECTION_STATUS.WAITING && this.chatApi.client.connected) {
            this.setConnectionStatus(CONNECTION_STATUS.CONNECTED);
        }

        this.clientDisconnected = !this.chatApi.client.connected && this.chatApi.client.connected !== undefined;
        const isOffline =
            this.clientDisconnected ||
            (!this.dashboardState.isDesktopSharingSession &&
                this.dashboardState.connectionStatus === this.CONNECTION_STATUS.IDLE);

        this.cameraApproval = this.isHandshakeSuccessForCurrentMode;

        runInAction(() => {
            this.dashboardState.connectionState = isOffline ? ConnectionStatesEnum.OFFLINE : ConnectionStatesEnum.HIGH;
        });

        if (this.chatApi.dashboard.roomStarted || this.clientDisconnected) {
            return Promise.resolve(this.roomData);
        }

        return this.roomService.start(this.roomData._id).then((roomData) => {
            this.roomData = roomData;

            this.chatApi.setStatus('roomStarted', true);

            return roomData;
        });
    }

    syncMediaSession() {
        trace.info('syncMediaSession');
        const clientMode = get(this.chatApi, 'client.mode');

        if (!clientMode) {
            //No need to connect to media session while mode is unknown
            return Promise.resolve();
        }

        const mediaSessionModes = [
            MeetingMode.video,
            MeetingMode.screen,
            MeetingMode.appSharing,
            MeetingMode.videoApplication
        ];
        const isMediaSessionMode = includes(mediaSessionModes, this.chatApi.client.mode);
        const sessionIsNeeded = this.dashboardMediaService.isVoipEnabled || isMediaSessionMode;

        this._stopRecordingWhenNotInVideoMode();

        const isHandshakeSuccess = this.isHandshakeSuccessForCurrentMode;

        const traceObj = {
            sessionIsNeeded,
            areBothSidesConnected: this.dashboardState.areBothSidesConnected,
            isHandshakeSuccess,
            isSessionActive: this.dashboardMediaService.isSessionActive
        };

        if (this.sessionInitializationInProgress) {
            return Promise.resolve();
        }

        if (
            sessionIsNeeded &&
            !this.dashboardMediaService.isSessionActive &&
            this.dashboardState.areBothSidesConnected
        ) {
            trace.info('dashboard sync media', traceObj);

            if (!isHandshakeSuccess) {
                trace.info('Session is needed, but handshake not complete yet.', traceObj);

                return Promise.resolve();
            }

            //TODO - Alex: Move the connection logic to dashboardMediaService itself
            trace.info('Session is needed, will try to connect');
            const mediaSessionParams = {
                sessionId: this.roomData._id,
                clientType: SessionClientType.GUEST,
                clientRole: this.observe ? SessionClientRole.OBSERVER : SessionClientRole.AGENT
            };

            let paramsReadyPromise = Promise.resolve();

            this.sessionInitializationInProgress = true;

            const syncOTCredentials = () => {
                let token = this.roomData.opentok.tokenAgent;

                if (this.observe) {
                    const tokenObserve = filter(
                        this.roomData.opentok.tokenObservers,
                        (observer) => observer.userId === this.currentUser._id.toString()
                    );

                    token = tokenObserve && tokenObserve[0] && tokenObserve[0].token;
                }

                this.roomData.opentok.token = token;

                mediaSessionParams.credentials = assign({}, this.roomData.opentok);
            };

            switch (this.dashboardState.mediaServiceType) {
                case MEDIA_SERVICE.MEDIASERVER:
                    this.dashboardMediaService.connectToMediaServer();
                    paramsReadyPromise = this.roomData
                        .initMediaServer(
                            this.observe ? UserType.supervisor : UserType.dashboard,
                            get(this.chatApi, 'dashboard.audioSupport') && get(this.chatApi, 'client.audioSupport')
                        )
                        .then((roomData) => {
                            this.roomData = roomData;
                            const sessionId = this.roomData.mediaServer.sessionId;
                            let token = this.roomData.mediaServer.tokenAgent;

                            if (this.observe) {
                                const tokenObserve = filter(
                                    this.roomData.mediaServer.tokenObservers,
                                    (observer) => observer.userId === this.currentUser._id.toString()
                                );

                                token = tokenObserve && tokenObserve[0] && tokenObserve[0].token;
                            }

                            mediaSessionParams.credentials = assign({}, {token, sessionId});

                            trace.info('setStatus --> mediaServer credentials');

                            this.chatApi.setStatus('mediaServer', {
                                session: {
                                    sessionId: mediaSessionParams.credentials.sessionId,
                                    token: this.roomData.mediaServer.tokenClient
                                }
                            });
                        });
                    break;
                case MEDIA_SERVICE.OPENTOK:
                    if (!this.roomData.opentok.init || this.observe) {
                        trace.info(
                            'session opentok created',
                            this.roomData.opentok,
                            this.observe,
                            this.roomData.opentok
                        );

                        paramsReadyPromise = this.roomService
                            .initOpentok(this.roomData._id, this.observe ? UserType.supervisor : UserType.dashboard)
                            .then((roomData) => {
                                this.roomData = roomData;
                                syncOTCredentials();
                            });
                    } else {
                        syncOTCredentials();
                    }
                    mediaSessionParams.ipWhitelist = get(
                        this.chatApi,
                        'accountSettings.useOnlyOpenTokAllowedIPS',
                        false
                    );
                    break;
                default:
                    mediaSessionParams.credentials = this.chatApi.accountSettings.turnServerConfig;
            }

            return paramsReadyPromise
                .then(() => {
                    if (this.dashboardState.isMediaServer) {
                        this.dashboardMediaService.stopWaitForMediaServer();
                    }

                    if (
                        !mediaSessionParams.credentials ||
                        Object.getOwnPropertyNames(mediaSessionParams.credentials).length < 2
                    ) {
                        trace.info(
                            'Credentials for media session not exists. Skipping connect to session',
                            mediaSessionParams.credentials
                        );

                        return Promise.resolve();
                    }

                    trace.info('try to connect to media session');

                    return this.dashboardMediaService
                        .connectToSession(mediaSessionParams, isMediaSessionMode)
                        .then(() => {
                            trace.info('connected to media session');

                            this._recordingEventsListener();

                            const currentMode = get(this.chatApi, 'client.mode');
                            const isLoggingEnabled = includes(mediaSessionModes, currentMode);

                            this.mediaStatsLogger.enableVideoLogging(isLoggingEnabled);
                            this.audioService.establishAudioStream();

                            if (this.dashboardState.isOpentok) {
                                trace.info('setStatus --> opentok credentials');

                                this.chatApi.setStatus('opentok', {
                                    session: {
                                        sessionId: mediaSessionParams.credentials.sessionId,
                                        token: mediaSessionParams.credentials.tokenClient,
                                        apiKey: mediaSessionParams.credentials.apiKey
                                    }
                                });
                            }
                        });
                })
                .catch((error) => {
                    trace.warn('error during connection to media session', error);
                })
                .finally(() => (this.sessionInitializationInProgress = false));
        } else if (
            !sessionIsNeeded ||
            (!this.dashboardState.isOpentok && !this.dashboardState.areBothSidesConnected) ||
            (!this.dashboardState.isOpentok && !isHandshakeSuccess)
        ) {
            if (this.dashboardMediaService.isSessionActive) {
                const isAutomaticRecording = get(this.accountData, 'protectedSettings.recording.automatic.enabled');
                const isPhotoMode = includes([MeetingMode.images, MeetingMode.oneClick], clientMode);
                const isAudioActive = this.dashboardMediaService.isVoipEnabled;

                if (this.dashboardState.isOpentok && isAutomaticRecording) {
                    trace.info('Keeping media session alive for automatic recording continuity');

                    return Promise.resolve();
                }

                if (isPhotoMode && isAudioActive) {
                    trace.info('Keeping media session alive for audio continuity across photo mode');

                    return Promise.resolve();
                }

                trace.info('Disconnecting from media session:', traceObj);
                this.audioService.clearAudioSubscribers();

                return this.dashboardMediaService.disconnectFromSession();
            }

            this.mediaStatsLogger.enableVideoLogging(false);
        }

        trace.info('No change in media session state required');

        return Promise.resolve();
    }

    _stopRecordingWhenNotInVideoMode() {
        const isAutomaticRecording = get(this.accountData, 'protectedSettings.recording.automatic.enabled');

        if (
            this.dashboardState.floatingToolbarState.isRecordingEnabled &&
            get(this.chatApi, 'client.mode') !== MeetingMode.video &&
            !isAutomaticRecording &&
            this.recordingStatus === RECORDING_STATUS.started
        ) {
            this.roomService.stopRecording(this.roomData._id, {
                accountId: this.accountData._id
            });

            this.recordStatusChanged(RECORDING_STATUS.ready);
        }
    }

    _stopRecordingOnClientDisconnect() {
        if (
            this.dashboardState.floatingToolbarState.isRecordingEnabled &&
            (get(this.accountData, 'protectedSettings.recording.automatic.enabled') ||
                this.recordingStatus === RECORDING_STATUS.started)
        ) {
            trace.info('Stopping recording due to client disconnect');

            if (this.dashboardMediaService.isSessionActive) {
                this.dashboardMediaService.disconnectFromSession().catch((err) => {
                    trace.error('Failed to disconnect from media session', {err});
                });
            }

            this.recordStatusChanged(RECORDING_STATUS.ready);
        }
    }

    _recordingEventsListener() {
        this._onDemandClipStartedAt = null;

        if (this.dashboardState.floatingToolbarState.isRecordingEnabled) {
            this.dashboardMediaService.onReconnectingMediaServer(() => {
                trace.info('Reconnecting to media server');

                this.syncMediaSession();
            });

            this.dashboardMediaService.onRecordStatusChange((eventArgs) => {
                trace.info(`Getting status: ${eventArgs.status} of the recordingId: ${eventArgs.recordingId}`);

                if (eventArgs.status === RECORDING_STATUS.started) {
                    this.jsApiService.sessionRecordingStarted({
                        type: MessageType.sessionRecordingStarted,
                        sessionId: this.roomData._id
                    });
                }

                this._emitOnDemandRecordingState(eventArgs.status);

                this.recordStatusChanged(eventArgs.status);
            });
        }
    }

    syncRoute() {
        if (!this.chatApi.dashboard.roomStarted && !this.chatApi.client.connected) {
            return;
        }

        if (
            (!this.wizardState.showWizard && !this.isMobile) ||
            (this.chatApi.dashboard.roomStarted && this.chatApi.client.connected) ||
            this.observe
        ) {
            this.redirectToMain();
        }
    }

    syncAgentGuidance() {
        const {
            inCameraApprovalDialog,
            isOnScreenShareCapturingPermission,
            mode,
            clientOs,
            screenShareCapturingApprovedIOS,
            isOnscreenShareTurnOffGuidanceIOS
        } = this.chatApi.client;
        const {screenShareFailed} = this.chatApi.dashboard;
        const isReviewingTOS = this.chatApi.isReviewingTOS;
        const switchingToAppShare = mode === MeetingMode.appSharing;
        const switchingToScreenShare = mode === MeetingMode.screen && !this.dashboardState.isDesktopSharingSession;
        const isIOS = clientOs && clientOs.toLowerCase().indexOf('ios') !== -1;

        runInAction(() => {
            this.dashboardState.screenShareIOS = switchingToScreenShare && isIOS;
        });

        switch (true) {
            case isOnscreenShareTurnOffGuidanceIOS && isIOS && this.isLiveModeOptionAvailable() && !screenShareFailed:
                this.dashboardGuidanceController.setGoToApplicationGuidance();
                break;
            case isReviewingTOS:
                this._setTOSGuidance(switchingToAppShare, switchingToScreenShare);
                break;
            case inCameraApprovalDialog:
                trace.info('dashboardGuidance - inCameraApprovalDialog');
                this.dashboardGuidanceController.setCameraApprovalGuidance(this.dashboardState.isDesktopSharingSession);
                break;
            case (isOnScreenShareCapturingPermission ||
                (this.dashboardState.screenShareIOS && !screenShareCapturingApprovedIOS)) &&
                !screenShareFailed:
                this.dashboardGuidanceController.setScreenShareCapturingGuidance();
                break;
            default:
                if (!this.dashboardState.rejectedTermsAndConditions) {
                    trace.info('dashboardGuidance - hide guidance');

                    if (this.dashboardGuidanceController.isCameraApprovalShown) {
                        this.eventLog.cameraApprovalGuidanceClosed({trigger: 'SYNC'});
                    }

                    this.dashboardGuidanceController.hide();
                }
                break;
        }

        return Promise.resolve();
    }

    syncDeviceDetails() {
        if (
            get(this.chatApi, 'client.deviceInfo') &&
            get(this.chatApi, 'client.clientOsObject') &&
            get(this.chatApi, 'client.clientType')
        ) {
            const {
                clientOs,
                clientOsObject,
                deviceInfo,
                clientType,
                clientBrowser,
                clientDevice,
                usingApplication,
                supportsARScanByMobile
            } = this.chatApi.client;

            this._clientDeviceDetails({
                clientOs,
                clientOsObject,
                deviceInfo,
                clientType,
                clientBrowser,
                clientDevice,
                usingApplication,
                supportsARScanByMobile
            });

            return;
        }

        return this.roomService.getClientDeviceDetails(this.roomData._id).then((room) => {
            if (!get(room, 'data.deviceInfo') || !get(room, 'data.clientOsObject') || !get(room, 'data.clientType')) {
                return;
            }

            const {
                clientOs,
                clientOsObject,
                deviceInfo,
                clientType,
                clientBrowser,
                clientDevice,
                usingApplication,
                supportsARScanByMobile
            } = room.data;

            this._clientDeviceDetails({
                clientOs,
                clientOsObject,
                deviceInfo,
                clientType,
                clientBrowser,
                clientDevice,
                usingApplication,
                supportsARScanByMobile
            });
        });
    }

    isLiveModeOptionAvailable() {
        const liveModes = [MeetingMode.video, MeetingMode.oneClick, MeetingMode.images];
        const availableModes = get(this.chatApi, 'client.availableModes');
        let isLiveAvailable = false;

        forEach(liveModes, (liveMode) => {
            isLiveAvailable = !!find(availableModes, (mode) => mode === liveMode);
        });

        return isLiveAvailable;
    }

    syncCountries() {
        if (!this.enableObservation || !isEmpty(this.countries)) {
            return Promise.resolve();
        }

        this.countries = countryCodes;
        this.countriesInfoList = this.countries.filter(
            (country) =>
                this.accountData.protectedSettings.selectedCountries.indexOf(country.code) > -1 ||
                `+${this.accountData.settings.countryCode}` === country.dial
        );
    }

    get locale() {
        return getRootStore().tsLocaleHelper.getLocale();
    }

    syncLeftBar() {
        const clientMode = get(this.chatApi, 'client.mode');
        const availableModes = get(this.chatApi, 'client.availableModes');

        if (!this.leftBarController || !clientMode || !availableModes) {
            return Promise.resolve();
        }

        const options = {
            clientType: get(this.chatApi, 'client.clientType'),
            isClientVisible: get(this.chatApi, 'client.visible') && get(this.chatApi, 'client.connected'),
            usingApplication: this.browserUtilsService.getFromSessionStorage('usingApplication'),
            isObserve: this.observe,
            patterns: {
                email: this.emailPattern,
                phone: this.mobilePhonePattern
            },
            countryList: this.countries,
            countriesInfoList: this.countriesInfoList
        };

        let meetingModes = get(this.accountData, 'protectedSettings.startWithModes.modesOptions');

        meetingModes = filter(meetingModes, (mode) => includes(availableModes, mode.mode));

        this.leftBarController.setOptions(options);

        this.leftBarController.setAvailableMeetingModes(meetingModes);
        this.leftBarController.setCurrentMeetingMode(clientMode);

        return Promise.resolve();
    }

    syncTopBar() {
        const clientMode = get(this.chatApi, 'client.mode');

        if (!this.topBarController || !clientMode) {
            return Promise.resolve();
        }

        const usingApplication =
            this.browserUtilsService.getFromSessionStorage('usingApplication') ||
            utils.isModeSupportNativeVideoSharing(clientMode);
        const nativeAppId = get(this.accountData, 'protectedSettings.liveSdk.nativeAppId');
        const options = {
            nativeAppId,
            usingApplication,
            isDesktopSharing: this.dashboardState.isDesktopSharingSession
        };

        this.topBarController.setOptions(options);

        runInAction(() => {
            this.dashboardState.sessionInfo.meetingMode = clientMode;
        });

        return Promise.resolve();
    }

    syncFeatures() {
        return Promise.all([this._handleAgentPointerAvailability(), this._handleDesktopSharingAgentControlStatus()]);
    }

    _shouldRouteToSessionEndedState() {
        const shouldRedirect = this.miniDashboard && (this.isMobile || this.isTablet);

        if (shouldRedirect) {
            this.stateHelper.navigateTo('sessionEnded');
        }

        return shouldRedirect;
    }

    _initVideoTimeoutHackForSdk() {
        if (!this.enableVideoTimeoutHackForSdk) {
            return;
        }

        const videoTimeoutHackForSdkRoomId =
            this.browserUtilsService.getFromSessionStorage('videoTimeoutHackForSdkRoomId');

        if (videoTimeoutHackForSdkRoomId !== this.roomData._id) {
            this.browserUtilsService.saveToSessionStorage('videoTimeoutHackForSdk', false);
            this.browserUtilsService.saveToSessionStorage('videoTimeoutHackForSdkRoomId', this.roomData._id);
        }
    }

    /**
     * Base UI / loader listeners — safe before socket connect (constructor).
     * v2.200+ dashboard-main: busy + localeHelper only; chat/media live in _initMeetingHandlers.
     */
    _initHandlers() {
        this.busy.on('busy', () => (this.showSpinner = true));
        this.busy.on('free', () => (this.showSpinner = false));

        this.localeHelper.on('update', (eventLogs) => (this.events = eventLogs));
        this.localeHelper.on('newEvent', (eventLog) => {
            this.handleLog(eventLog);
        });
        this.localeHelper.on('clientConnectionStatus', (status) => this.setConnectionStatus(status));
    }

    /**
     * Meeting / socket / media subscriptions — connectToMeeting (and offline branch when socket is skipped).
     */
    _initMeetingHandlers() {
        if (this._meetingHandlersInitialized) {
            return;
        }
        this._meetingHandlersInitialized = true;

        if (this.observe) {
            this._logObservationContinues();
        }

        const currentObserver = get(this.chatApi, 'dashboard.observer');

        if (!this.observe && !isEmpty(currentObserver)) {
            this._updateObserverDetails(currentObserver);
        }

        this.jsApiService.sessionStarted();

        this.dashboardMediaService.onUserVideoStateChange((eventArgs) => {
            trace.info('onUserVideoStateChange - video stream has changed', eventArgs);

            this.videoStateChanged(eventArgs.isReady);

            // When stream comes back (e.g. after client refresh), recreate subscriber if it was disposed
            if (
                eventArgs.isReady &&
                this.tsVideoSubscriberController &&
                !this.tsVideoSubscriberController.videoSubscriber &&
                this.videoModeState.videoState.enabled
            ) {
                this.tsVideoSubscriberController.applySettings();
            }
        });

        this.dashboardMediaService.onUserVideoStreamTimeout(() => {
            if (this.enableVideoTimeoutHackForSdk) {
                const clientMode = get(this.chatApi, 'client.mode');

                if (
                    utils.isModeSupportNativeVideoSharing(clientMode) &&
                    !this.dashboardState.isDesktopSharingSession &&
                    !this.browserUtilsService.getFromSessionStorage('videoTimeoutHackForSdk')
                ) {
                    this.browserUtilsService.saveToSessionStorage('videoTimeoutHackForSdk', true);

                    trace.info(`Failed to receive video - reload page, Mode: ${clientMode}`);

                    this.eventLog.videoStreamFailed({
                        mode: clientMode,
                        videoTimeoutHackForSdk: true
                    });

                    return window.location.reload();
                }
            }

            trace.info('Failed to receive video during defined timeout');

            this.chatApi.requestSwitchMode(FailureTriggerAction.dashboardNetworkIssue);
            this._initTrafficLogger(false);
            this._initVideoDurationLogger(false);
            this.eventLog.videoStreamFailed({
                reason: 'timeout'
            });
        });

        this.chatApi.on('sync', () => this.syncMeeting());

        this.bandwidthMeasurementService.on('bandwidthMeasurementSamples', (measurements) => {
            if (this.observe) {
                return;
            }
            getRootStore().generalApiService.addBandwidthMeasurement({
                roomId: this.roomData._id,
                accountId: this.accountData._id,
                measurements: measurements.data
            });
        });

        this.chatApi.on('log', (log, sender, isNew) => {
            switch (log.name) {
                case 'CUSTOMER_OPENED_THE_CAMERA':
                    this.eventLog.cameraOpened();
                    break;
                case 'CUSTOMER_ENDED_THE_MEETING':
                    this.showCustomerEndedTheMeetingModal();
                    runInAction(() => {
                        this.dashboardState.customerEndedTheMeeting = true;
                    });
                    this.jsApiService.sessionEnded({
                        type: MessageType.sessionEnded,
                        sessionId: this.roomData._id,
                        techseeSessionId: get(this.roomData, 'guids')[0],
                        customerNumber: this.customerNumber,
                        customerId: this.customerId
                    });
                    this.autoDataCollectionServices.end();
                    this._stopRecordingOnClientDisconnect();
                    break;
                case 'CLIENT_LOCATION_DENIED':
                    this._updateAddressTranslation(LOCATION_ADDRESS_STATUS.FAILURE);
                    this._topbarAddressFailure(true);
                    this.eventLog.clientLocationDenied();
                    break;
                case 'CLIENT_LOCATION_ERROR':
                    this._updateAddressTranslation(LOCATION_ADDRESS_STATUS.FAILURE);
                    this._topbarAddressFailure();
                    this.eventLog.clientLocationError();
                    break;
                case 'CLIENT_LOCATION':
                    if (this.chatApi.client.location) {
                        this.eventLog.clientLocation({coords: this.chatApi.client.location});
                        this._getAddress(this.chatApi.client.location).then(() =>
                            this.localeHelper.handleMessage(log, sender, isNew)
                        );
                    }
                    break;
                case 'DASHBOARD_NETWORK_ISSUE':
                    if (isNew) {
                        this.chatApi.requestSwitchMode(FailureTriggerAction.dashboardNetworkIssue);
                    }
                    break;
                case 'UNABLE_TO_PUBLISH':
                    if (isNew) {
                        if (this.chatApi.client.photoSupport) {
                            runInAction(() => {
                                // Cover case we missed media permission allow log
                                this.dashboardState.cameraApprovalIndicationNotRequired = true;
                            });

                            if (this.dashboardGuidanceController.isCameraApprovalShown) {
                                this.dashboardGuidanceController.hide();
                                this.eventLog.cameraApprovalGuidanceClosed({trigger: 'UNABLE_TO_PUBLISH'});
                            }
                        }
                    }
                    break;
                case 'MEDIA_PERMISSION_ALLOW':
                    runInAction(() => {
                        // Cover case we missed media permission allow log
                        this.dashboardState.cameraApprovalIndicationNotRequired = true;
                    });

                    if (!this.observe) {
                        this.roomService.setMediaPermissionAllow(this.roomData._id, {timestamp: new Date()});
                    }
                    if (this.dashboardGuidanceController.isCameraApprovalShown) {
                        this.dashboardGuidanceController.hide();
                        this.eventLog.cameraApprovalGuidanceClosed({trigger: 'MEDIA_PERMISSION_ALLOW'});
                    }
                    break;
                case 'TOS_REJECTED':
                    if (this.chatApi.accountSettings.enableNewInvite) {
                        runInAction(() => {
                            this.dashboardState.rejectedTermsAndConditions = this.chatApi.client.tosRejected;
                        });
                        this.rejectedTermsAndConditions = this.chatApi.client.tosRejected;
                    } else {
                        runInAction(() => {
                            this.dashboardState.rejectedTermsAndConditions = true;
                        });
                        this.dashboardGuidanceController.setTosRejected(this.endMeeting);
                    }

                    this._shouldRouteToSessionEndedState();

                    break;
                case 'TOS_ACCEPTED':
                    this.tosAccepted = true;
                    break;
                case 'VIDEO_PAUSED_BY_CUSTOMER':
                case 'VIDEO_PAUSED_BY_EXPERT':
                case 'SCREEN_SHARE_PAUSED_BY_EXPERT':
                case 'SCREEN_SHARE_PAUSED_BY_CUSTOMER':
                case 'APP_SHARE_PAUSED_BY_EXPERT':
                case 'APP_SHARE_PAUSED_BY_CUSTOMER':
                case 'VIDEO_RESUMED':
                case 'SCREEN_SHARE_RESUMED':
                case 'APP_SHARE_RESUMED':
                    break;
                case 'CLIENT_DISCONNECTED':
                case 'CLIENT_HIDDEN':
                    if (this.offlineRoom) {
                        log.name = 'CLIENT_LEFT_OFFLINE';
                    }
                    break;
                case 'IMAGE_UPLOAD_UNSUPPORTED': {
                    // Get device info for translation parameter
                    const deviceInfo =
                        this.eventParams?.device ||
                        this.chatApi?.client?.deviceInfo ||
                        window.navigator.userAgent ||
                        'Unknown Device';
                    const translatedMessage = this.translate('LOGS.IMAGE_UPLOAD_UNSUPPORTED', {deviceInfo});
                    this.showPhotostreamBlockedModalReact(translatedMessage);
                    break;
                }
                default:
                    break;
            }

            if (this._shouldHandleLogMessage(log.name)) {
                this.localeHelper.handleMessage(log, sender, isNew);
            }
        });

        this.chatApi.on('clientVisualScanStatus', () =>
            this.leftBarController?.setVisualScanStatus(this.chatApi.client.visualScanStatus)
        );
        this.chatApi.on('endMeetingAction', () => this.endMeeting(true, LogEvents.closedByTypes.simpleApi));
        this.chatApi.on('redirectedToStore', () => this._displayRedirectToStoreGuidance());
        this.chatApi.on('clientVersionStatus', (status) => this._displayRedirectToStoreGuidance(status));
        this.chatApi.on('clientMediaServiceType', (param, newMediaServiceType) => {
            if (
                newMediaServiceType &&
                this.dashboardState.mediaServiceType &&
                newMediaServiceType !== this.dashboardState.mediaServiceType
            ) {
                // This is currently the best way to handle media service type change during the session
                window.location.reload(true);
            }
        });
        this.chatApi.on('clientDeviceDetails', (message) => this._clientDeviceDetails(message));
        this.chatApi.on('socketVersion', (message) => onSocketVersionHandler(message));
        this.chatApi.on('clientAudioSupport', () => {
            if (get(this.chatApi, 'client.audioSupport') !== null) {
                this.syncAudioSupport();
            }
        });
        this.chatApi.on('clientConnected', () => {
            const isClientConnected = get(this.chatApi, 'client.connected');

            if (isClientConnected) {
                this.clientConnected = true;
                this.errorDialogController.hide();
                this.roomService.connect(this.roomData._id);

                this.localeHelper.mobileClientConnected();

                if (this.chatApi.client.visible) {
                    this._allowIdleNotificationSms();
                } else if (this.dashboardState.connectionStatus !== this.CONNECTION_STATUS.IDLE) {
                    this.localeHelper.mobileClientHidden();
                    this.setConnectionStatus(this.CONNECTION_STATUS.IDLE);
                }

                if (this.redirectToStore) {
                    this.redirectToMain();
                }

                return;
            }

            this.localeHelper.mobileClientDisconnected();
            this.busy.free();
        });
        this.chatApi.on('clientLocation', (param, coords) => {
            this._getAddress(coords);
        });
        this.chatApi.on('roomRejected', () => {
            this.chatApi.sendLog(new Error('Room rejected'));
        });
        this.chatApi.on('clientVisible', (param, state) => {
            if (state) {
                this._allowIdleNotificationSms();
                this.localeHelper.mobileClientVisible();
            } else {
                this.localeHelper.mobileClientHidden();
            }

            this.setConnectionStatus(state ? this.CONNECTION_STATUS.CONNECTED : this.CONNECTION_STATUS.IDLE);
        });
        this.chatApi.on('clientMode', (param, clientMode) => {
            if ([MeetingMode.images, MeetingMode.oneClick].includes(clientMode)) {
                this.roomService.getLastPhotoStreamReason(this.roomData._id).then((photoStreamReason) => {
                    const reason = photoStreamReason && photoStreamReason.data;

                    if (
                        this.fallbackModeNotification &&
                        reason &&
                        !includes(
                            [PhotoStreamReasonKeys.BUTTON_CLICK, PhotoStreamReasonKeys.ACCOUNT_VIDEO_DISABLED],
                            reason
                        ) &&
                        updateFallbackModesNotification(clientMode, this.roomData._id, this.browserUtilsService)
                    ) {
                        this.fallbackModeController.show(clientMode, photoStreamReason.data);
                    }
                });
            }
        });
        this.chatApi.on('connectionStatusChanged', (status) => {
            if (status) {
                this.errorDialogController.hide();

                return;
            }

            // Hide all open React modals when connectivity is lost
            this._hideAllReactModals();

            // Don't log connectivity issue after meeting ended
            if (
                get(this.chatApi, 'dashboard.meeting') ||
                !(this.dashboardState.endedTheMeeting || this.dashboardState.customerEndedTheMeeting)
            ) {
                this.chatApi.sendLog(STATUS_MESSAGES.CONNECTIVITY_DIFFICULTIES);
                this.eventLog.connectivityDifficulties();
            }
        });
        this.chatApi.on('connectivityIssueInNativeMode', () => {
            if (this.connectivityIssuePopupController) {
                this.connectivityIssuePopupController.show();
            }
        });
        if (this.connectivityIssuePopupController) {
            this._connectivityIssueCloseSessionListener = () => {
                this.endMeeting(false, LogEvents.closedByTypes.dashboard);
            };
            this.connectivityIssuePopupController.on(
                ConnectivityIssueEvents.CLOSE_SESSION,
                this._connectivityIssueCloseSessionListener
            );
        }
        this.chatApi.on('mobileNetworkType', (networkInfo) => {
            const mobileNetworkInfo = NetworkInfo.fromDataObject(networkInfo);

            runInAction(() => {
                this.dashboardState.clientNetworkInfo.downlinkMax = mobileNetworkInfo.downlinkMax;
                this.dashboardState.clientNetworkInfo.connectionType = mobileNetworkInfo.connectionType;
            });

            const type = mobileNetworkInfo.connectionType;

            switch (type.toLowerCase()) {
                case 'cellular':
                    this.localeHelper.mobileNetworkCell();
                    break;
                case 'unsupported': //TODO - Alex: Check if something needed to be done in old ui.
                case 'wifi':
                    this.localeHelper.mobileNetworkWifi();
                // eslint-disable-next-line no-fallthrough
                default:
                    break;
            }
        });
        this.chatApi.on('roomUpdated', (customerId) => {
            this.customerId = customerId;
            this.roomData.customerId = customerId;
        });
        this.chatApi.on('ICECredentialsChanged', ({credentials}) => {
            if (this.dashboardState.mediaServiceType === MEDIA_SERVICE.MEDIASERVER) {
                this.chatApi.accountSettings.mediaServerConfig = credentials;
            } else if (this.dashboardState.mediaServiceType === MEDIA_SERVICE.TURNSERVER) {
                this.chatApi.accountSettings.turnServerConfig = credentials;
            }
            if (this.dashboardMediaService.isSessionActive) {
                this.dashboardMediaService.updateSessionCredentials(credentials).catch((error) => {
                    trace.warn('Update credentials error', error);
                });
            }
        });

        this.chatApi.on('observer', (data) => {
            this._updateObserverDetails(data);
        });

        if (!this.observe) {
            this.chatApi.on('timeout', () => {
                this.timeoutDialogController.show();
            });
            this.chatApi.on('forceTimeout', () =>
                this.endMeeting(false, LogEvents.closedByTypes.dashboard, ReasonForClosing.forceTimeout)
            );
        } else {
            this.chatApi.on('disconnectObserver', () => {
                this.dashboardMediaService.disconnectFromSession().catch(() => undefined);
                this.chatApi.disconnect();
                this.setConnectionStatus(CONNECTION_STATUS.DISCONNECTED);
                clearTimeout(this.alertMessageTimeout);
                runInAction(() => {
                    this.dashboardState.messageAlert = null;
                });
                this.goToInvite();
            });
        }
    }

    _shouldHandleLogMessage(logName) {
        switch (logName) {
            case 'CLIENT_LOCATION':
                return false;
            case 'CUSTOMER_IN_PHOTOGALLERY_PAGE':
                return !this.observe;
            default:
                return true;
        }
    }

    _updateObserverDetails(data) {
        if (!this.enableObservation) {
            return;
        }

        if (data.connected && !this.dashboardState.isObserve) {
            this.audioService.observerConnected();
        }

        this.observerDetails = {
            connected: data.connected,
            firstName: data.firstName,
            lastName: data.lastName
        };

        if (!this.invisibleModeObservation) {
            this._manageObserverAlerts(data);
        }

        this.observerInfo = this.translate('REACT.LEFTBAR.POPOVER.SESSION_OBSERVER_CONNECTED', {
            user: `${data.firstName} ${data.lastName}`
        });

        if (this.miniDashboard) {
            return;
        }

        runInAction(() => {
            this.leftBarController.setIsObserverConnected(data.connected);
            this.leftBarController.observerDetails = {
                connected: data.connected,
                firstName: data.firstName,
                lastName: data.lastName
            };
        });
    }

    _manageObserverAlerts(data, failedMessage) {
        const observerAlertMessage = data.connected
            ? 'DASHBOARD.VIEW.OBSERVER_JOIN_THE_SESSION'
            : 'DASHBOARD.VIEW.OBSERVER_LEFT_THE_SESSION';
        const label = failedMessage
            ? this.translate(failedMessage)
            : this.translate(observerAlertMessage, {user: `${data.firstName} ${data.lastName}`});

        this.setMessageAlert(label, OBSERVER_ALERT_COLOR, OBSERVER_JOIN_ALERT_TIMEOUT);
    }

    showCustomerEndedTheMeetingModal() {
        if (this.dashboardGuidanceController.isCameraApprovalShown) {
            this.eventLog.cameraApprovalGuidanceClosed({trigger: 'Customer ended the session'});
        }

        this.dashboardGuidanceController.hide();
        this.customerEndedTheMeetingModalCtrl.show();
    }

    onSubmitObserver(value, methodType) {
        const email = value ? value : this.dashboardState.emailToInviteObserver;
        const phone = value ? value : this.countrySelector.model + this.dashboardState.phoneToInviteObserver;
        const selectedInviteType = methodType ? methodType : this.dashboardState.observationCurrentTab;

        if (email && selectedInviteType === AddressTypesEnum.EMAIL) {
            this.sendObserverEmail(email).catch(() => {
                this._manageObserverAlerts({}, 'REACT.INVITE.VIEW.SESSION_OBSERVATION.FAILED_INVITATION');
            });
        } else if (phone && selectedInviteType === AddressTypesEnum.SMS) {
            this.sendObserverSMS(phone).catch(() => {
                this._manageObserverAlerts({}, 'REACT.INVITE.VIEW.SESSION_OBSERVATION.FAILED_INVITATION');
            });
        }

        this.dashboardState.displayObserverSendingForm
            ? this.observerClick()
            : this.leftBarController.closeObserverInvite();
    }

    onSubmitAppLauncher(appLauncherType) {
        switch (appLauncherType) {
            case AppLauncherTypesEnum.DASHBOARD:
                openLinkInNewTab(this.accountData.protectedSettings.appLauncher.dashboard.customUrl);
                break;

            case AppLauncherTypesEnum.CLIENT:
                this.chatApi.requestAction(
                    'appLauncherOpenLink',
                    this.accountData.protectedSettings.appLauncher.client.customUrl
                );
                break;

            default:
                break;
        }
    }

    sendObserverSMS(phone) {
        const roomId = this.roomData._id;
        const message = this.translate('SMS.OBSERVER_MESSAGE');

        if (!phone) {
            throw new Error('Invalid phone number');
        }

        return this.smsService.sendObserverInvitation({
            roomId: roomId,
            phone: phone,
            message
        });
    }

    sendObserverEmail(email) {
        const roomId = this.roomData._id;

        if (!email) {
            throw new Error('Invalid Email');
        }

        return getRootStore().emailService.observerInvitation({
            roomId,
            to: email,
            crid: this.customerId
        });
    }

    openSelfServiceWarmTransferSummary() {
        if (this.selfServiceController) {
            this.selfServiceController.clickSummary();
        }
    }

    openModeSwitchConfirmationModal(item, currentMode) {
        const switchToSharingMode = utils.isModeSupportNativeVideoSharing(item.internalMode);
        const isCurrentModeSharingMode = utils.isModeSupportNativeVideoSharing(currentMode);

        if (switchToSharingMode !== isCurrentModeSharingMode) {
            this.modeSwitchModalController.show(item, currentMode);
        } else {
            this.leftBarController.clickToSwitchMode(item);
        }
    }

    modeSwitchHandleModalResponse(response, modes) {
        return response
            ? this.leftBarController.clickToSwitchMode(modes.newMode)
            : this.leftBarController.setCurrentMeetingMode(modes.currentMode);
    }

    setCurrentResource(resource) {
        runInAction(() => {
            this.dashboardState.currentResource = resource;
        });
    }

    displaySaveInHistoryButton() {
        return this.dashboardState.offlineMode && this.dashboardState.videoModeState.preloadedImage?.resource;
    }

    disabledSharingButton() {
        return get(this.busy, 'isBusy') || get(this.videoControlService, 'isActive');
    }

    disabledSendButton() {
        return (
            get(this.busy, 'isBusy') ||
            get(this.videoControlService, 'isActive') ||
            (this.clientDisconnected && !this.offlineRoom) ||
            (this.dashboardState.displayLoaderReconnecting && this.enableIdleModeUsability)
        );
    }

    displayImagesManagementButtons() {
        return (
            (!this.observe &&
                (this.dashboardState.connectionStatus !== get(this.CONNECTION_STATUS, 'WAITING') || this.offlineRoom) &&
                get(this.annotateService, 'canvasReady')) ||
            (this.libraryTaggingMode && get(this.dashboardState.videoModeState.preloadedImage, 'resource'))
        );
    }

    @computed
    get displaySendButton() {
        return (
            !this.observe &&
            (this.dashboardState.connectionStatus !== get(this.CONNECTION_STATUS, 'WAITING') || this.offlineRoom) &&
            this.dashboardState.canvasReady
        );
    }

    displaySharingButton() {
        return (
            (get(this.dashboardState.videoModeState.preloadedImage, 'resource') &&
                this.dashboardState.offlineMode &&
                !this.libraryTaggingMode) ||
            (!this.observe &&
                this.dashboardState.connectionStatus !== get(this.CONNECTION_STATUS, 'WAITING') &&
                this.enableShareMenu &&
                !this.quickSharingModesEnabled &&
                get(this.annotateService, 'canvasReady'))
        );
    }

    get isHandshakeSuccessForCurrentMode() {
        const {inCameraApprovalDialog, isOnPreCameraApprovalScreen} = this.chatApi.client;
        const meetingMode = stateByMode(this.chatApi.client.mode, true);
        const isReviewingTOS = this.chatApi.isReviewingTOS;
        const isHandshakeSuccess =
            get(this.chatApi, 'client.' + meetingMode.handshakeProp) &&
            !isReviewingTOS &&
            !inCameraApprovalDialog &&
            !isOnPreCameraApprovalScreen;

        if (!isHandshakeSuccess) {
            trace.info(`handshake not completed. params- handshakeProp: ${get(
                this.chatApi,
                'client.' + meetingMode.handshakeProp
            )}
             isReviewingTOS: ${isReviewingTOS}, inCameraApprovalDialog: ${inCameraApprovalDialog}, isOnPreCameraApprovalScreen: ${isOnPreCameraApprovalScreen}`);
        }

        return isHandshakeSuccess;
    }

    onIdleClient() {
        runInAction(() => {
            this.dashboardState.notificationSmsInProgress = true;
        });
        this.eventLog.idleNotification();
        this.idleClient.idleNotification = this.idleClient.waitForClientNotification;
        const {smsUseNumberLookup} = get(this.accountData, 'protectedSettings.smsSettings');
        const showSmsPreview = this.accountData.settings ? this.accountData.settings.showSmsPreview : true;

        const data = {
            phone: this.browserUtilsService.getFromLocalStorage('phoneNumber'),
            roomId: this.roomData._id.toString(),
            chromeDetection: get(this.accountData, 'protectedSettings.chromeDetection'),
            cameraModeOnly: this.cameraModeOnly,
            showSmsPreview: showSmsPreview,
            mobileClientURL: this.clientStartURL,
            gateway: get(this.roomData, 'fieldsForReports.gatewayUsedForInvite'),
            offline: false,
            useNumberLookup: smsUseNumberLookup,
            countryCode: this.browserUtilsService.getFromLocalStorage('countryCode'),
            audio: this.isSupportAudio
        };

        if (this.browserUtilsService.getFromLocalStorage('startWithAgentType')) {
            data.startWithAgentType = this.browserUtilsService.getFromLocalStorage('startWithAgentType');
        }

        this.smsService.sendNotificationSms(data);
    }

    _updateMailTrigger() {
        const shareByEmail = get(this.accountData, 'settings.shareByEmail');

        if (
            shareByEmail &&
            shareByEmail.enabled &&
            (shareByEmail.customToEnabled || shareByEmail.customSubjectEnabled)
        ) {
            const prepareMailPart = (part) => {
                const dirtyPart = replace(part, new RegExp('{{crid}}', 'gi'), this.customerId);

                return encodeURIComponent(dirtyPart);
            };

            const customTo = shareByEmail.customToEnabled ? prepareMailPart(shareByEmail.customTo) : '';
            const customSubject = shareByEmail.customSubjectEnabled
                ? `subject=${prepareMailPart(shareByEmail.customSubject)}`
                : 'subject=Techsee%20Image';

            this.mailTrigger = `mailto:${customTo}?${customSubject}`;
        } else {
            this.mailTrigger = 'mailto:?subject=Techsee%20Image';
        }
        this.mailTrigger += '&body=Techsee%20History%20Image:%20';
    }

    _displayRedirectToStoreGuidance(status) {
        if (status && status !== VersionStatus.INVALID) {
            return;
        }

        if (this.redirectToStoreController) {
            this.redirectToStoreController.updateVersion(status === VersionStatus.INVALID);

            return;
        }

        this.redirectToStore = true;
        const clientOs = get(this.chatApi, 'client.clientOs') || this.roomData.clientOs;
        const isClientIos = clientOs ? clientOs.toLowerCase().indexOf('ios') !== -1 : false;

        this.redirectToStoreController = new RedirectToStoreController(
            this.translate,
            isClientIos,
            this.domUtilsService,
            this.dir,
            this.tsInterfaceHelper.useNewInterface,
            status === VersionStatus.INVALID
        );

        this.roomService.setReportedField(this.roomData._id, {
            key: 'mirroringStatus',
            value: {
                type: 'customerRedirectedToAppStore',
                OS: this.wizardState.platform
            },
            type: 'push'
        });

        if (this.embeddedDashboard) {
            setTimeout(() => {
                const message = this.translate('DASHBOARD_MINI.USER_REDIRECTED');

                this.setMessageAlert(message, OBSERVER_ALERT_COLOR, USER_REDIRECTED_TIMEOUT);
            }, USER_REDIRECTED_TIMEOUT);

            return;
        }

        this.stateHelper.navigateTo('dashboard.store');
    }

    get customerEndedTheMeetingModalCtrl() {
        if (!this._customerEndedTheMeetingModalCtrl) {
            this._customerEndedTheMeetingModalCtrl = new SimpleModalController(
                'customer-ended-the-meeting-modal',
                this.translate('REACT.MODAL.CUSTOMER_ENDED_THE_MEETING.TITLE'),
                this.translate('REACT.MODAL.CUSTOMER_ENDED_THE_MEETING.DESCRIPTION'),
                '',
                this.translate('REACT.MODAL.CUSTOMER_ENDED_THE_MEETING.CONFIRMATION')
            );
        }
        return this._customerEndedTheMeetingModalCtrl;
    }

    get simpleModalCtrl() {
        if (!this._simpleModalCtrl) {
            this._simpleModalCtrl = new SimpleModalController(
                '', // Class will be set dynamically
                '', // No title needed
                '', // Content will be set dynamically
                '', // Button text will be set dynamically
                '', // Button text will be set dynamically
                () => {}, // Action will be set dynamically
                () => {} // Action will be set dynamically
            );
        }
        return this._simpleModalCtrl;
    }

    get notificationCtrl() {
        if (!this._notificationCtrl) {
            this._notificationCtrl = new NotificationController();
        }
        return this._notificationCtrl;
    }

    showPhotostreamBlockedModalReact(message) {
        // Configure modal for photostream blocked scenario
        this._configureSimpleModal(
            'photostream-blocked-modal blue-left-button',
            message,
            this.translate('IMAGE_UPLOAD_BLOCKED_DIALOG.RESTART_SESSION'),
            this.translate('IMAGE_UPLOAD_BLOCKED_DIALOG.END_SESSION'),
            this._onPhotostreamBlockedModalPositive.bind(this),
            this._onPhotostreamBlockedModalNegative.bind(this)
        );

        this.simpleModalCtrl.show();

        // Return a promise like the original with business logic
        return new Promise((resolve) => {
            this._photostreamBlockedModalResolve = resolve;
        }).then(({restartSession}) => {
            if (restartSession) {
                this._prepareToRedirectToInviteWithCustomerDetails();
                return this.goToInvite();
            }
            this.endMeeting(false, LogEvents.closedByTypes.dashboard);
        });
    }

    _onPhotostreamBlockedModalPositive() {
        this.simpleModalCtrl.hide();
        if (this._photostreamBlockedModalResolve) {
            this._photostreamBlockedModalResolve({restartSession: false}); // End Session
            this._photostreamBlockedModalResolve = null;
        }
    }

    _onPhotostreamBlockedModalNegative() {
        this.simpleModalCtrl.hide();
        if (this._photostreamBlockedModalResolve) {
            this._photostreamBlockedModalResolve({restartSession: true}); // Restart Session
            this._photostreamBlockedModalResolve = null;
        }
    }

    mobilePausedVideo = (isPaused) => {
        this.isPaused = isPaused;

        if (!this.isPaused && this.enableNetworkBandwidthMeasurement) {
            this.resetVideoBandwidthTest = true;
        }
    };

    // Helper method to configure the unified simple modal
    @action
    _configureSimpleModal(className, content, negativeText, positiveText, onPositive, onNegative) {
        // Batch all observable updates in single action for better performance
        const ctrl = this.simpleModalCtrl;
        ctrl.modalClassName = className;
        ctrl.updateContent(content);
        ctrl.negativeText = negativeText;
        ctrl.positiveText = positiveText;
        ctrl.onPositiveClick = onPositive;
        ctrl.onNegativeClick = onNegative;
    }

    showQuotaNotificationModalReact(message, params, isErrorMsg = true) {
        const translatedContent = this.translate(message, params);
        this.notificationCtrl.updateContent(translatedContent, isErrorMsg);
        this.notificationCtrl.show();
    }

    showSharedNotificationModalReact(message, params = null, isErrorMsg = false) {
        const translatedContent = this.translate(message, params);
        this.notificationCtrl.updateContent(translatedContent, isErrorMsg);
        this.notificationCtrl.show();
    }

    // Helper method to hide all migrated React modals on connectivity loss
    _hideAllReactModals() {
        // Hide simple modals (photostream blocked)
        if (this._simpleModalCtrl) {
            this._simpleModalCtrl.hide();
        }

        // Resolve any pending photostream blocked modal promise to prevent memory leaks
        if (this._photostreamBlockedModalResolve) {
            this._photostreamBlockedModalResolve({restartSession: false}); // Default to end session on forced closure
            this._photostreamBlockedModalResolve = null;
        }

        // Hide notification modals (quota, shared notifications)
        if (this._notificationCtrl) {
            this._notificationCtrl.hide();
        }
    }

    _initUiSettings() {
        // Init left bar config
        if (get(this.accountData, 'settings') && !this.dashboardState.offlineMode) {
            // Init left bar config
            this.showLeftBar = this.accountData.settings.showLeftBar;

            if (this.showLeftBar) {
                this.leftBarText = this.accountData.settings.leftBarText;
            }

            // Save button visibility
            this.showSaveButton = this.accountData.protectedSettings.showSaveButton;
        }

        this._disposeMobxReactions.push(
            reaction(
                () => [
                    this.displayImagesManagementButtons(),
                    this.displaySendButton,
                    this.dashboardState.floatingToolbarState.displaySaveButton,
                    this.displaySharingButton(),
                    this.disabledSendButton(),
                    this.dashboardState.floatingToolbarState.disabledSaveButton,
                    this.disabledSharingButton(),
                    this.displaySaveInHistoryButton()
                ],
                () => {
                    if (this.topBarController) {
                        runInAction(() => {
                            this.topBarController.showImagesManagement = this.displayImagesManagementButtons();
                            this.topBarController.showSharingButton = this.displaySharingButton();
                            this.topBarController.showSaveButton =
                                this.dashboardState.floatingToolbarState.displaySaveButton;
                            this.topBarController.showSendButton = this.displaySendButton;
                            this.topBarController.showSaveInHistoryButton = this.displaySaveInHistoryButton();
                            this.topBarController.disabledSaveButton =
                                this.dashboardState.floatingToolbarState.disabledSaveButton;
                            this.topBarController.disabledSendButton = this.disabledSendButton();
                            this.topBarController.disabledSharingButton = this.disabledSharingButton();
                        });
                    }
                }
            )
        );
    }

    _allowIdleNotificationSms() {
        if (this.dashboardState.notificationSmsInProgress) {
            runInAction(() => {
                this.dashboardState.notificationSmsInProgress = false;
            });
            this.idleClient.idleNotification = this.idleClient.mobileNotConnectedNotification;
        }
    }

    _setTOSGuidance(appShare, screenShare) {
        if (appShare) {
            this.dashboardGuidanceController.setAppSharingTosGuidance();
        } else if (screenShare) {
            this.dashboardGuidanceController.setScreenShareTosGuidance();
        } else {
            this.dashboardGuidanceController.setTosGuidance();
        }
    }

    _clientDeviceDetails(deviceDetails) {
        const {
            clientOs,
            clientOsObject,
            deviceInfo,
            clientType,
            clientBrowser,
            clientDevice,
            usingApplication,
            supportsARScanByMobile
        } = deviceDetails;

        runInAction(() => {
            if (clientBrowser) {
                this.dashboardState.clientMobileBrowser = clientBrowser;
            }

            if (clientDevice) {
                this.dashboardState.clientMobileType = clientDevice;
            }

            if (clientOs) {
                this.dashboardState.clientOs = clientOs;
            }

            if (clientOsObject?.name) {
                this.dashboardState.clientMobileOsName = clientOsObject.name;
            }

            if (clientOsObject?.version) {
                this.dashboardState.clientMobileOsVersion = clientOsObject.version;
            }

            this.dashboardState.deviceInfo = deviceInfo;
            this.dashboardState.clientType = clientType;
            this.dashboardState.clientOsObject = clientOsObject;
            this.dashboardState.usingApplication = usingApplication;
            this.dashboardState.supportsARScanByMobile = supportsARScanByMobile;

            this.dashboardState.sessionInfo.clientJoinedSession = true;
        });
        this.eventParams.device = deviceInfo;
        this.chatApi.client.deviceInfo = deviceInfo;
        this.chatApi.client.clientType = clientType;
        this.chatApi.client.clientOs = clientOs;
        this.chatApi.client.clientOsObject = clientOsObject;
        this.chatApi.client.usingApplication = usingApplication;
        this.chatApi.client.supportsARScanByMobile = supportsARScanByMobile;

        if (usingApplication && !this.browserUtilsService.getFromSessionStorage('usingApplication')) {
            this.browserUtilsService.saveToSessionStorage('usingApplication', usingApplication);
        }

        if (!get(this.eventParams, 'device')) {
            return;
        }

        // finally set the platform for the wizard
        if (this.eventParams.device.match(/iOS|Windows/)) {
            this.wizardState.platform = 'apple';
        } else if (this.eventParams.device.match(/Android/)) {
            this.wizardState.platform = 'android';
        }
        // Save if the browser is chrome
        this.isChrome = this.eventParams.device.match(/Chrome/);
        this.localeHelper.updateLogs();
        this.chatApi.sendLog(STATUS_MESSAGES.BROWSER_DETECTED);
        if (supportsARScanByMobile === false) {
            runInAction(() => {
                this.dashboardState.isDeviceSupportsVisualScan = false;
            });
            return;
        }
        this._checkVisualScanCapability(deviceDetails, this.wizardState.platform);
    }
    _checkVisualScanCapability(deviceDetails, platform) {
        const roomId = this.roomData._id;

        if (!roomId || !deviceDetails) {
            return;
        }
        const mobileAppId = platform === 'android' ? 'AndroidVA' : 'iOSVA';
        if (this.dashboardState.isEnableVisualScan) {
            getDashboardStores()
                .deviceService.checkDeviceSupport({
                    mobileAppId: mobileAppId,
                    deviceDetails: deviceDetails,
                    feature: BLACKLIST_FEATURES.VisualScan
                })
                .then((response) => {
                    trace.info('Visual scan capability check result:', response);
                    runInAction(() => {
                        this.dashboardState.isDeviceSupportsVisualScan = response?.isDeviceSupported ?? true;
                    });
                    this.eventLog.isDeviceSupported({
                        isDeviceSupported: response?.isDeviceSupported,
                        deviceName: deviceDetails?.clientDevice,
                        feature: BLACKLIST_FEATURES.VisualScan
                    });
                })
                .catch((error) => {
                    trace.error('Failed to check visual scan capability:', error);
                    this.eventLog.isDeviceSupportedError({
                        deviceName: deviceDetails?.clientDevice,
                        feature: BLACKLIST_FEATURES.VisualScan
                    });
                });
        }
    }

    _bandwidthEventLog(samples, eventLogType) {
        const avgBandwidth = mean(samples);

        this.eventLog[eventLogType]({
            avgBandwidth: avgBandwidth,
            samples: samples
        });
    }

    _lowVideoBandWidthDetected(bandwidthSamples) {
        this._bandwidthEventLog(bandwidthSamples, 'lowVideoBandwidthDetected');

        if (this.chatApi.dashboard.showLowBandwidthMessage && !this.miniDashboard) {
            this.chatApi.setStatus('showLowBandwidthMessage', false, true);
        }

        if (this.embeddedDashboard) {
            this.chatApi.requestSwitchMode(FailureTriggerAction.lowBandwidthConnection);
        }

        this.chatApi.sendLog(STATUS_MESSAGES.LOW_VIDEO_BANDWIDTH_DETECTED);
        this.bandwidthLastSample = BANDWIDTH_LAST_SAMPLE.LOW;
    }

    _videoBandwidthStabilized(bandwidthSamples) {
        this._bandwidthEventLog(bandwidthSamples, 'videoBandwidthStabilized');
        this.chatApi.sendLog(STATUS_MESSAGES.VIDEO_BANDWIDTH_STABILIZED);
        this.bandwidthLastSample = BANDWIDTH_LAST_SAMPLE.STABLE;
    }

    _startMeasurement() {
        if (this.resetVideoBandwidthTest !== undefined) {
            this.resetVideoBandwidthTest = true;

            return;
        }

        this.resetVideoBandwidthTest = false;

        return this._calculateVideoBandwidth();
    }

    _calculateVideoBandwidth() {
        this.bandwidthMeasurementService.bandwidthParamCleanup(true);

        const bandwidthSamplingInterval = () => {
            if (this.resetVideoBandwidthTest) {
                this.bandwidthMeasurementService.bandwidthParamCleanup();
                this.bandwidthMeasurementService.flushBandwidthSampleBuffer();
                this.resetVideoBandwidthTest = false;

                return setTimeout(bandwidthSamplingInterval, this.timeToWaitToStartBandwidthMeasurement);
            }

            const clientMode = get(this.chatApi, 'client.mode');

            if (clientMode === MeetingMode.video && get(this.chatApi, 'client.visible') && !this.isPaused) {
                this.dashboardMediaService.getUserVideoStats(true).then((userVideoStats) => {
                    const bandwidthResult = this.bandwidthMeasurementService.calculateVideoBandwidth(userVideoStats);

                    if (bandwidthResult) {
                        switch (bandwidthResult.status) {
                            case BandwidthLevel.LOW_BANDWIDTH:
                                this.bandwidthMeasurementService.bandwidthSamplesCleanup();
                                this._lowVideoBandWidthDetected(bandwidthResult.bandwidthSamples);
                                break;

                            case BandwidthLevel.HIGH_BANDWIDTH:
                                this.bandwidthMeasurementService.bandwidthSamplesCleanup();
                                this._videoBandwidthStabilized(bandwidthResult.bandwidthSamples);
                                break;

                            default:
                                break;
                        }
                    }
                });
            }

            setTimeout(bandwidthSamplingInterval, this.videoBandwidthSamplingInterval);
        };

        setTimeout(bandwidthSamplingInterval, this.timeToWaitToStartBandwidthMeasurement);
    }

    _logObservationContinues() {
        const logInterval = () => {
            if (
                this.observe &&
                this.observerDetails &&
                this.dashboardState.connectionStatus === this.CONNECTION_STATUS.CONNECTED
            ) {
                getRootStore().observationsService.addObservation({
                    roomId: this.roomData._id,
                    userName: this.currentUser.userName,
                    firstName: this.observerDetails.firstName,
                    lastName: this.observerDetails.lastName,
                    addNewSegment: false
                });
            }

            this.observeTimeout = setTimeout(logInterval, OBSERVATION_LOG_INTERVAL);
        };

        this.observableTimeout = setTimeout(logInterval, OBSERVATION_LOG_INTERVAL);
    }

    displayWizardView() {
        const tosDisplayedOrAlreadyRejected =
            get(this.chatApi, 'isReviewingTOS') || get(this.chatApi, 'client.tosRejected');

        return (
            tosDisplayedOrAlreadyRejected &&
            !get(this.chatApi, 'client.isOnPreCameraApprovalScreen') &&
            (this.dashboardState.rejectedTermsAndConditions ||
                !this.idleMode ||
                (!this.dashboardState.displayLoaderReconnecting && !this.dashboardState.endedTheMeeting))
        );
    }

    _getAddress(coords) {
        return getRootStore()
            .generalApiService.getLocationAddress({
                lon: coords.lon,
                lat: coords.lat,
                lang: 'en_US',
                roomId: this.roomData._id
            })
            .then((res) => {
                const formattedAddress = res.address || res[0]?.formattedAddress || '';

                this.eventParams.address = formattedAddress;
                this._updateAddressTranslation(LOCATION_ADDRESS_STATUS.AVAILABLE);
                this._updateTopbarAddress(coords, formattedAddress);
                this.localeHelper.updateLogs();
                this.eventLog.clientLocationAddress({formattedAddress});
            })
            .catch(() => {
                // if retrieval fails, just show the coordinates
                this.eventParams.address = `${coords.lon}, ${coords.lat}`;
                this._updateAddressTranslation(LOCATION_ADDRESS_STATUS.FAILURE);
                this._updateTopbarAddress(coords);
                this.localeHelper.updateLogs();
                this.eventLog.clientLocationAddressError();
            })
            .finally(() => {
                if (this.embeddedDashboard) {
                    const data = {
                        x: coords.lon,
                        y: coords.lat,
                        address: this.eventParams.address || ''
                    };

                    if (coords.altitude) {
                        data.z = coords.altitude;
                    }

                    if (coords.accuracy) {
                        data.accuracy = coords.accuracy;
                    }

                    this.roomService.customerGeolocation(this.roomData._id, data);
                }
            });
    }

    _updateAddressTranslation(status) {
        switch (status) {
            case LOCATION_ADDRESS_STATUS.AVAILABLE:
                if (this.addressLocation.status === LOCATION_ADDRESS_STATUS.AVAILABLE) {
                    break;
                }

                this.addressLocation.status = LOCATION_ADDRESS_STATUS.AVAILABLE;
                this.addressLocation.icon = this.LOCATION_ICONS.AVAILABLE;

                if (this.isMobile || this.miniDashboard) {
                    runInAction(() => {
                        this.dashboardState.mobilePopoverLocation = this.translate(
                            'DASHBOARD.VIEW.LOCATION_AVAILABLE',
                            {
                                location: this.eventParams.address
                            }
                        );
                    });
                    this.miniPopoverLocation = this.dashboardState.mobilePopoverLocation;
                    this.addressLocation.popoverEnabled = true;
                    break;
                } else {
                    this.addressLocation.translation = 'DASHBOARD.VIEW.LOCATION_AVAILABLE';
                    break;
                }
            case LOCATION_ADDRESS_STATUS.FAILURE:
                if (this.addressLocation.status === LOCATION_ADDRESS_STATUS.FAILURE) {
                    break;
                }

                if (this.isMobile) {
                    this.addressLocation.popoverEnabled = false;
                }

                this.addressLocation.status = LOCATION_ADDRESS_STATUS.FAILURE;
                this.addressLocation.translation = 'DASHBOARD.VIEW.LOCATION_UNAVAILABLE';
                this.addressLocation.icon = this.LOCATION_ICONS.UNAVAILABLE;
                break;
            default:
                break;
        }
    }

    get isCopilotEnabled() {
        return get(this.accountData, 'protectedSettings.copilot.enabled');
    }

    async initCopilot(copilotElement) {
        if (!this.isCopilotEnabled) {
            return;
        }

        try {
            await this._copilotService?.init(copilotElement);

            this._copilotElement = copilotElement;

            this._copilotService.cameraPermissionSet(true);
            this._copilotService.startMeeting(this.roomData._id);
        } catch (err) {
            this.eventLog.failedToInitSophieSdk({err});
        }
    }

    _updateTopbarAddress(coords, formattedAddress = '') {
        const {lat, lon, altitude, accuracy} = coords;
        const googleMapsQuery = formattedAddress ? encodeURIComponent(formattedAddress) : `${lat},${lon}`;
        const googleMapsLink = `https://www.google.com/maps/search/?api=1&query=${googleMapsQuery}`;

        runInAction(() => {
            this.dashboardState.clientLocationInfo = {
                lat,
                lon,
                altitude,
                accuracy,
                formattedAddress,
                googleMapsLink,
                isDenied: false,
                isFailed: false
            };
        });
    }

    _topbarAddressFailure(isDenied) {
        runInAction(() => {
            if (isDenied) {
                this.dashboardState.clientLocationInfo.isDenied = true;
            } else {
                this.dashboardState.clientLocationInfo.isFailed = true;
            }
        });
    }

    videoStateChanged(isReady) {
        this._initTrafficLogger(isReady);
        this._initVideoDurationLogger(isReady);
        if (ENABLE_QOS) {
            this._initAgentQOS(isReady);
        }

        if (!isReady) {
            return;
        }

        this.chatApi.sendLog(STATUS_MESSAGES.VIDEO_READY);

        this.eventLog.videoReady();

        this.roomService.setVideoReceived(this.roomData._id, new Date());

        const clientMode = get(this.chatApi, 'client.mode');

        this.roomService.changeAgent(this.roomData._id, clientMode ? clientMode.toUpperCase() : MeetingMode.video);

        if (!this.isIE || !this.dashboardState.isOpentok) {
            this._startMeasurement();
        }

        if (this.dashboardGuidanceController.isCameraApprovalShown) {
            this.dashboardGuidanceController.hide();
            this.eventLog.cameraApprovalGuidanceClosed({trigger: 'VIDEO_READY'});
        }

        runInAction(() => {
            // Cover case we missed media permission allow log
            this.dashboardState.cameraApprovalIndicationNotRequired = true;
        });
    }

    _initTrafficLogger(enabled) {
        if (enabled && !this._trafficLogger) {
            this._trafficLogger = setInterval(() => this._logTraffic(), VIDEO_TRAFFIC_LOG_INTERVAL * 1000);
        }

        if (!enabled && this._trafficLogger) {
            clearInterval(this._trafficLogger);
            this._trafficLogger = null;

            this._logTraffic();
        }
    }

    _initVideoDurationLogger(enabled) {
        if (enabled && !this._videoDurationLogger) {
            this._videoDurationLogger = setInterval(() => this._logVideoDuration(), VIDEO_DURATION_LOG_INTERVAL * 1000);
        }

        if (!enabled && this._videoDurationLogger) {
            clearInterval(this._videoDurationLogger);
            this._videoDurationLogger = null;

            this._logVideoDuration();
        }
    }

    _initAgentQOS(enabled) {
        if (enabled && !this._agentQOSLogger) {
            this._agentQOSLogger = setInterval(() => this._logAgentQOS(), AGENT_QOS_LOG_INTERVAL * 1000);
        }

        if (!enabled && this._agentQOSLogger) {
            clearInterval(this._agentQOSLogger);
            this._agentQOSLogger = null;

            this._logAgentQOS();
        }
    }

    _logAgentQOS() {
        if (this.isIE || this.dashboardState.isOpentok) {
            return Promise.resolve();
        }

        return this.dashboardMediaService
            .getUserVideoStats()
            .then((statReports) => {
                if (statReports.trackStats) {
                    return this.qos.sendQOS(statReports.trackStats);
                }
            })
            .catch((error) => {
                this.handleMediaLog(error, true);
            });
    }

    _logTraffic() {
        if (this.isIE && this.dashboardState.isOpentok) {
            return Promise.resolve();
        }

        return this.mediaStatsLogger.getTrafficDelta().then((delta) => {
            if (delta) {
                this.roomService
                    .setReportedField(this.roomData._id, {
                        key: 'videoTraffic',
                        value: delta,
                        type: 'inc'
                    })
                    .catch(() => {
                        this.mediaStatsLogger.restoreTrafficDelta(delta);
                    });
            }
        });
    }

    _logVideoDuration() {
        return this.mediaStatsLogger.getVideoDurationDelta().then((delta) => {
            if (delta) {
                this.roomService
                    .setReportedField(this.roomData._id, {
                        key: 'videoDuration',
                        value: delta,
                        type: 'inc'
                    })
                    .catch(() => {
                        this.mediaStatsLogger.restoreVideoDurationDelta(delta);
                    });
            }
        });
    }

    handleLog(eventLog) {
        const text = this.translate(eventLog.text, {
            device: get(this.eventParams, 'device'),
            address: get(this.eventParams, 'address')
        });

        if (!text) {
            return;
        }

        const order = eventLog.order;
        const lastEvent = this.dashboardState.lastEvent;
        if (order != null && lastEvent?.order != null && order <= lastEvent.order) {
            return;
        }

        const timestamp = new Date().getTime();
        if (lastEvent?.text === text && lastEvent?.timestamp && timestamp - lastEvent.timestamp < 150) {
            return;
        }

        runInAction(() => {
            this.dashboardState.lastEvent = {
                text,
                timestamp,
                order: order ?? timestamp
            };
        });
    }

    async displayEndMeetingDialog() {
        try {
            const confirmed = await this.endMeetingModalController.open();

            if (confirmed) {
                this.endMeeting(false, LogEvents.closedByTypes.dashboard);
            }
        } finally {
            this.endMeetingModalController.dispose();
        }
    }

    redirectToMain() {
        if (this.embeddedDashboard || window.location.pathname.endsWith('/dashboard/main')) {
            return;
        }

        this.stateHelper.navigateTo('/dashboard/main' + window.location.search, undefined, {replace: true});
    }

    @action
    mainFinishLoaded() {
        this.dashboardState.mainLoaded = true;
    }

    summaryEndSession() {
        this.timedOperation.lockAttempt(ENDING_TIMEOUT);
        this.completeEndMeeting(this.preventRedirection);
    }

    completeEndMeeting(preventRedirection, options) {
        if (
            !this.offlineRoom &&
            !this.dashboardState.offlineMode &&
            get(this.accountData, 'protectedSettings.feedbackSurveys') &&
            get(this.accountData, 'settings.enableSurveys')
        ) {
            this._surveyPreventRedirection = preventRedirection;
            return this.surveyModalController.show();
        }

        if (this.returnQuery) {
            return this._goToLastSearch();
        }

        this._redirectOrCloseWindow(options);
    }

    _redirectOrCloseWindow(stateParams) {
        if (this.isIE && get(this.accountData, 'protectedSettings.closeWindowWhenSessionEnds')) {
            try {
                window.open('', '_self').close();
            } catch (e) {
                this.goToInvite(stateParams);
            }
        } else {
            this.goToInvite(stateParams);
        }
    }

    endMeeting(preventRedirection, closedBy, reason, options) {
        if (!this.timedOperation.lockAttempt(ENDING_TIMEOUT) || this.surveySubmitted) {
            return;
        }

        this.preventRedirection = preventRedirection;
        runInAction(() => {
            this.dashboardState.showLoader = false;
            this.dashboardState.endedTheMeeting = true;
        });
        this.autoDataCollectionServices.end();

        if (!this.dashboardState.customerEndedTheMeeting) {
            this.jsApiService.sessionEnded({
                type: MessageType.sessionEnded,
                sessionId: this.roomData._id,
                techseeSessionId: get(this.roomData, 'guids')[0],
                customerNumber: this.customerNumber,
                customerId: this.customerId
            });
        }

        this._copilotService?.endMeeting(this.roomData._id);

        if (this.enableNetworkBandwidthMeasurement) {
            this.bandwidthMeasurementService.flushBandwidthSampleBuffer();
        }

        this._logTraffic()
            .then(() => this._logVideoDuration())
            .then(() => this.dashboardMediaService.clearService())
            .then(() => this.mediaStatsLogger.clearVideoLogging())
            .then(() => {
                const meeting = this.chatApi.dashboard.meeting;

                //TODO - CHECK: Need to verify that status arrives to server before socket is disconnected
                this.chatApi.setStatus('meeting', false);
                this.chatApi.disconnect();

                this.wizardHelper.removeState(this.wizardState);

                this.setConnectionStatus(CONNECTION_STATUS.DISCONNECTED);

                if (this.dashboardState.rejectedTermsAndConditions) {
                    this._prepareToRedirectToInviteWithCustomerDetails();
                }

                if (meeting && reason !== ReasonForClosing.forceTimeout) {
                    return this.roomService
                        .endRoom(this.roomData._id, {closedBy, reasonForClosing: reason})
                        .catch((err) => console.error(err));
                }
            })
            .then(() => {
                if (this._shouldRouteToSessionEndedState()) {
                    return;
                }

                if (this.dashboardState.allowSessionSummary) {
                    this.eventLog.sessionSummary({
                        description: `Session summary is enabled. ${
                            this.dashboardState.hasScreenshots ? 'there are images' : 'skipping - no images'
                        }`
                    });
                    this._resetUnloadConfirmation();
                    this.timedOperation.release();

                    if (this.dashboardState.hasScreenshots) {
                        this.eventLog.sessionSummary({description: 'Showing session summary'});

                        return this.sessionSummaryController?.showSessionSummary();
                    }
                }

                return this.completeEndMeeting(preventRedirection, options);
            })
            .catch(() => {
                this.timedOperation.release();
            });
    }

    onAbort(preventRedirection, closedBy) {
        if (this.dashboardState.offlineMode) {
            this.exitOfflineMode();

            return;
        }
        this.endMeeting(preventRedirection, closedBy);
    }

    _resetUnloadConfirmation() {
        window.onbeforeunload = () => undefined;
    }

    _prepareToRedirectToInviteWithCustomerDetails() {
        this.browserUtilsService.saveToLocalStorage(
            'lastUsedTOSNumberWithoutCountryCode',
            this.roomData.customerNumber.replace(this.roomData.customerCountryCode, '')
        );
        this.browserUtilsService.saveToLocalStorage('lastUsedTOSCountryCode', this.roomData.customerCountryCode);
        this.browserUtilsService.saveToLocalStorage('lastDeclineTOSCustomerId', this.roomData.customerId);
    }

    leaveOfflineRoom() {
        this.dashboardMediaService.clearService().catch(() => undefined);

        if (this.mediaStatsLogger) {
            this.mediaStatsLogger.clearVideoLogging().catch(() => undefined);
        }

        this.chatApi.disconnect();

        if (this.returnQuery) {
            return this._goToLastSearch();
        }

        this.goToInvite();
    }

    leaveMeeting() {
        this.dashboardMediaService.clearService().catch(() => undefined);
        this.mediaStatsLogger.clearVideoLogging().catch(() => undefined);
        this.chatApi.disconnect();
        this.setConnectionStatus(CONNECTION_STATUS.DISCONNECTED);

        clearTimeout(this.alertMessageTimeout);
        runInAction(() => {
            this.dashboardState.messageAlert = null;
        });

        this.goToInvite();
    }

    _goToLastSearch() {
        const params = (this.returnQuery || '').split(',');
        // first parameter is the db query (customer Id or Number)
        const encodedPrimaryParam = params[0] || '';
        const primaryParam = decodeURIComponent(encodedPrimaryParam);

        const separatorIndex = primaryParam.indexOf(':');
        const key = separatorIndex > -1 ? primaryParam.slice(0, separatorIndex) : '';
        const rawValue = separatorIndex > -1 ? primaryParam.slice(separatorIndex + 1) : '';
        let value = rawValue;
        // the rest are used for the client side filter
        const filter = params.slice(1).join(',');
        const stateParams = {};

        if (key === 'customerId') {
            value = decodeURIComponent(rawValue);
        }

        if (key && value) {
            stateParams[key] = value;
        }

        if (filter) {
            this.urlUtils.setParamValue('filter', filter);
            stateParams.filter = filter;
        }

        if (this.returnQuery === 'searchByTags') {
            stateParams.isSearchByTags = true;
        }

        this.stateHelper.navigateTo('history', stateParams);
    }

    exitOfflineMode() {
        // The knowledge expert has no access to the rest of the
        // application so exiting the editor means logging-out
        if (this.libraryTaggingMode) {
            return this.logout();
        }

        if (this.returnQuery) {
            this._goToLastSearch();
        } else if (this.dashboardState.videoModeState.preloadedImage.resource) {
            getRootStore()
                .historyApiService.getRecordByResource(
                    this.dashboardState.videoModeState.preloadedImage.resource._id,
                    'IMAGE'
                )
                .then((response) => {
                    const customerId = response && response.customerId,
                        customerNumber = response && response.customerNumber;

                    if (customerId && customerId !== 'none') {
                        this.stateHelper.navigateTo('history', {customerId: customerId});
                    } else if (customerNumber) {
                        this.stateHelper.navigateTo('history', {customerNumber: customerNumber});
                    } else {
                        // shouldn't happen, but in any case...
                        this.goToInvite();
                    }
                })
                .catch(() => {
                    this.goToInvite();
                });
        } else {
            this.goToInvite();
        }
    }

    logout() {
        const accountId = this.accountData._id,
            userId = this.currentUser._id,
            returnURL = window.location.origin + BASE_PATH + get(this.accountData, 'protectedSettings.alias');

        return this.auth.logout(accountId, userId, returnURL).then((res) => {
            if (!res.data) {
                window.location.href = '/';

                return;
            }

            window.location.href = res.data;
        });
    }

    toggleTopBar(val) {
        this.topBarOpen = val;
    }

    closeLeftBar(val) {
        this.leftBarClosed = val;
        runInAction(() => {
            this.dashboardState.isLeftBarClosed = val;
        });
    }

    toggleMeetingLink(val) {
        this.showMeetingLink = val;
    }

    timeoutPromise = (time) => {
        return new Promise((resolve) => {
            setTimeout(resolve, time);
        });
    };

    sendImage(callback = () => {}) {
        if (this._sendingTimeout !== null) {
            return callback();
        }

        this.busy.busy();

        if (this.dashboardState.connectionStatus === CONNECTION_STATUS.DISCONNECTED && !this.offlineRoom) {
            this._sendingTimeout = this.timeoutPromise(SENDING_TIMEOUT_INTERVAL);

            this._sendingTimeout.then(() => {
                this._sendingTimeout = null;

                if (this.dashboardState.connectionStatus === CONNECTION_STATUS.DISCONNECTED) {
                    this.clientTimeoutDialogCtrl.show();

                    this.busy.free();
                    callback();

                    return;
                }

                this.sendImage();
                callback();
            });

            callback();

            return;
        }

        const img = this.annotateService.getObjectURL({
            useOriginalCanvas: true
        });

        if (!img) {
            callback();

            return this.busy.free();
        }

        this.sharingService.generateImageFileName(img).then(({blob, imgFileName}) => {
            this.dashboardState.currentResource?._fromLibrary
                ? this.eventLog.dashboardSendingImage({library: true, mediaFileName: imgFileName})
                : this.eventLog.dashboardSendingImage({mediaFileName: imgFileName});

            const options = {fileName: imgFileName};

            this.sharingService.uploadRoomImage(
                blob,
                options,
                (url) => {
                    if (this.dashboardState.isAnnotated) {
                        this.chatApi.imageAnnotated();
                    }

                    const tags = this.annotateService.getTags();
                    const formattedTags = tags ? tags.map((tag) => (typeof tag === 'string' ? {text: tag} : tag)) : [];

                    this.chatApi
                        .sendImage(url, {
                            tags: formattedTags,
                            sharedBy: senderTypes.DASHBOARD,
                            mediaFileName: imgFileName
                        })
                        .then(() => {
                            if (
                                this.dashboardState.currentResource?._id &&
                                !this.dashboardState.currentResource?._fromLibrary
                            ) {
                                const tagStrings = formattedTags.map((tag) => tag.text);

                                getRootStore().historyApiService.updateResource(
                                    this.dashboardState.currentResource._id,
                                    'IMAGE',
                                    tagStrings
                                );
                            }
                            this.busy.free();
                            callback();
                        })
                        .catch(() => {
                            this.handleImageUploadFail();
                            callback();
                        });
                },
                () => {
                    this.handleImageUploadFail();
                    callback();
                }
            );
        });
    }

    saveResource() {
        if (!this.videoControlService.isActive) {
            const img = this.annotateService.getObjectURL();

            this.busy.busy();

            this.eventLog.savingResource();

            this.sharingService.uploadRoomImage(
                img,
                {isTemp: false},
                (url) => {
                    if (this.dashboardState.isAnnotated) {
                        this.chatApi.imageAnnotated();
                    }

                    this.chatApi.imageSaved();

                    const tags = this.annotateService.getTags();
                    const formattedTags = tags ? tags.map((tag) => (typeof tag === 'string' ? {text: tag} : tag)) : [];

                    this.chatApi.saveImage(url, {tags: formattedTags});

                    this.busy.free();
                },
                () => this.handleImageUploadFail()
            );
        } else {
            this.busy.busy();

            const videoUrl = this.videoControlService.videoUrl;
            const tags = this.videoControlService.getTags();
            const formattedTags = tags ? tags.map((tag) => (typeof tag === 'string' ? {text: tag} : tag)) : [];

            this.chatApi.saveVideo(videoUrl, {tags: formattedTags});

            this.busy.free();
        }
    }

    sendImageEmail() {
        window.open(this.mailTrigger);
    }

    saveImageCloud() {
        if (!this.dashboardState.videoModeState.preloadedImage.resource) {
            return;
        }

        // if only the tags are changed, don't save a new revision
        if (this.annotateService.history.isEmpty()) {
            return this._saveHistoryImageTags();
        }

        this.eventLog.savingHistoryImage();

        this._uploadAndSaveImage(
            (resourceId, {data}) =>
                getRootStore().s3Service.signHistory(
                    'image',
                    this.dashboardState.videoModeState.preloadedImage.resource._id,
                    {
                        accountId: this.accountData._id,
                        fileName: data.fileName,
                        fileType: data.fileType,
                        fileSize: data.fileSize
                    }
                ),
            (resourceId, {data}) =>
                getRootStore().historyApiService.addResourceRevision(resourceId, 'IMAGE', {
                    url: data.url,
                    tags: data.tags
                })
        );
    }

    _saveHistoryImageTags() {
        const tags = this.annotateService.getTags();

        this.busy.busy();

        getRootStore()
            .historyApiService.updateResource(
                this.dashboardState.videoModeState.preloadedImage.resource._id,
                'IMAGE',
                tags
            )
            .finally(() => {
                this.busy.free();
            });
    }

    handleImageUploadFail() {
        this.busy.free();
        if (this.miniDashboard) {
            runInAction(() => {
                this.dashboardState.lastEvent = {text: this.miniDashboardImageUploadFailed};
            });
        } else {
            this.errorDialogController.show('ERROR_DIALOG.VIEW.IMAGE_UPLOAD_FAILED');
        }
    }

    _uploadAndSaveImage(signCallback, updateCallback) {
        this.busy.busy();

        const fileName = this._newRevisionFileName(),
            img = this.annotateService.getObjectURL(),
            tags = this.annotateService.getTags();

        if (img === null) {
            return;
        }

        const cbEnd = () => this.handleImageUploadFail(),
            cbSuccess = (url) =>
                updateCallback(this.dashboardState.videoModeState.preloadedImage.resource._id, {
                    data: {url, tags}
                })
                    .then((res) => {
                        if (this.dashboardState.videoModeState.preloadedImage.resource) {
                            this.dashboardState.videoModeState.preloadedImage.resource.url = res.url;
                            this.dashboardState.videoModeState.preloadedImage.resource.security = res.security;
                        }

                        return cbEnd();
                    })
                    .catch(cbEnd);

        this.sharingService.uploadImageS3(img, fileName, true, signCallback, cbSuccess, cbEnd);
    }

    saveImageLibrary() {
        const resourceId = get(this.dashboardState.videoModeState.preloadedImage, 'resource._id');

        if (!resourceId) {
            return;
        }

        if (this.annotateService.history.isEmpty()) {
            return this._saveLibraryImageTags(resourceId);
        }

        this.eventLog.savingLibraryImage();

        this._uploadAndSaveImage(
            (resourceId, {data}) => {
                const url = this.dashboardState.videoModeState.preloadedImage.resource.url;
                const folder = this._getDirName(url);

                return getRootStore().s3Service.sign(data.fileName, {
                    accountId: this.accountData._id,
                    fileType: data.fileType,
                    fileSize: data.fileSize,
                    folder: folder,
                    trimFolder: true
                });
            },
            (resourceId, {data}) => getRootStore().resourcesService.revision(resourceId, data)
        );
    }

    _saveLibraryImageTags(resourceId) {
        const tags = this.annotateService.getTags();

        this.busy.busy();

        getRootStore()
            .resourcesService.update(resourceId, {tags})
            .then(() => {
                this.busy.free();
            })
            .catch(() => this.busy.free());
    }

    /*
     * Takes the url of the file
     * Returns directory name of the file
     * @param url - String url of the file
     *
     * @return directory - String
     */
    _getDirName(url) {
        const path = url.substring(0, url.lastIndexOf('/'));
        // search for a single slash (/) (the match begins from the previous character
        // to make sure it's not a slash also, so the index we want is slashIndex + 2)
        const slashIndex = path.search(/[^\/]\/[^\/]/);
        const folder = slashIndex > 0 ? path.substring(slashIndex + 2) : null;

        if (!folder) {
            return null;
        }

        try {
            return decodeURIComponent(folder);
        } catch (e) {
            // URIError ("malformed URI sequence")
            return folder;
        }
    }

    _newRevisionFileName() {
        const url = urlParse(this.dashboardState.videoModeState.preloadedImage.resource.url, true),
            fileName = last(url.pathname.split('/')),
            extIndex = fileName.lastIndexOf('.'),
            baseName = fileName.substr(0, extIndex),
            extension = fileName.substr(extIndex),
            match = baseName.match(/(.*)(-rev)(\d+)$/),
            revName = match && match.length === 4 ? match[1] + match[2] + (Number(match[3]) + 1) : `${baseName}-rev1`;

        return revName + extension;
    }

    saveImageLocally(event) {
        const dataUrl = this.annotateService.getDataURL({useOriginalImage: this.isHighImageSharingQuality});

        if (this.isIE) {
            const blob = this.annotateService.dataUrlToBlob(dataUrl);

            // IE11 does not support data urls
            window.navigator.msSaveBlob(blob, 'img.jpg');
        } else {
            event.currentTarget.href = this.isHighImageSharingQuality
                ? this.annotateService.dataUrlToObjectUrl(dataUrl)
                : dataUrl;
        }
    }

    getFullName() {
        return `${this.currentUser.firstName} ${this.currentUser.lastName}`;
    }

    getPreloadedTitle() {
        if (this.dashboardState.offlineMode) {
            if (
                this.dashboardState.videoModeState.preloadedImage &&
                this.dashboardState.videoModeState.preloadedImage.resource
            ) {
                return this.dashboardState.videoModeState.preloadedImage.resource.title;
            }

            if (this.preloadedVideo && this.preloadedVideo.resource) {
                return this.preloadedVideo.resource.title;
            }
        }
    }

    isQuickShareEnabled() {
        return this.tsInterfaceHelper.useNewInterface && this.enableShareMenu && this.quickSharingModesEnabled;
    }

    onDownloadClicked(data) {
        // Ensure the resource has a type property for the sharing service
        const params = {
            ...data,
            type: data.type || 'url' // Default to 'url' if not specified
        };

        this.sharingService.download(params);
    }

    downloadResources(resourceType, allResources, downloadAndEmailNotification) {
        const data = this.selectedResources(resourceType),
            downloadNotification =
                Array.isArray(data) && data.length > 1
                    ? 'DASHBOARD.VIEW.RESOURCES_DOWNLOAD_SUCCESSFULLY'
                    : 'DASHBOARD.VIEW.DOWNLOAD_SUCCESSFULLY',
            text = downloadAndEmailNotification ? downloadAndEmailNotification : downloadNotification;

        forEach(data, (selectedResource) => {
            this.sharingService.download(selectedResource).catch((err) => console.error('Error downloading: ' + err));
        });

        this._showResourcesSharedNotification(data, text);
    }

    selectedResources(resourceType) {
        const resources = this.sharingState.selectedResources;

        return resources[resourceType];
    }

    downloadResourcesAndOpenEmail(resourceType, allResources) {
        const data = this.selectedResources(resourceType),
            downloadAndEmailNotification =
                Array.isArray(data) && data.length > 1
                    ? 'DASHBOARD.VIEW.RESOURCES_DOWNLOAD_AND_EMAIL'
                    : 'DASHBOARD.VIEW.DOWNLOAD_AND_EMAIL';

        this.downloadResources(resourceType, allResources, downloadAndEmailNotification);
        window.open(this.mailTrigger);
    }

    copyResourcesToClipboard(resourceType) {
        if (this._assertResourcesQuota(resourceType)) {
            this.onCopyToClipboardClicked([...this.selectedResources(resourceType)]);
        }
    }

    sendResourcesByEmail(resourceType) {
        if (this._assertResourcesQuota(resourceType)) {
            this.onSendByEmailClicked([...this.selectedResources(resourceType)]);
        }
    }

    sendResourcesToClient() {
        if (this._assertResourcesQuota('images')) {
            this.busy.busy();

            return this.sharingService
                .sendImagesToClient([...this.selectedResources('images')])
                .then(() => this.busy.free())
                .catch(() => this.handleImageUploadFail());
        }
    }

    _assertResourcesQuota(resourceType) {
        const selectedResources = this.selectedResources(resourceType);

        if (selectedResources.length <= this.multipleImagesSharingQuota) {
            return true;
        }

        if (this.tsInterfaceHelper.useNewInterface) {
            this.showQuotaNotificationModalReact('DASHBOARD.VIEW.EXCEED_SHARE_RESOURCES', {
                imageCount: selectedResources.length,
                maxImageCount: this.multipleImagesSharingQuota
            });
        }
    }

    newTopbarHeaderDownload() {
        if ((this.topBarController || this.enableFloatingToolbar) && this.dashboardState.currentResource) {
            this.onDownloadClicked(this.dashboardState.currentResource);
        }
    }

    newTopbarHeaderCopyToClipboard() {
        if ((this.topBarController || this.enableFloatingToolbar) && this.dashboardState.currentResource) {
            this.sharingService.getSignedDataForImageSharing(this.dashboardState.currentResource).then((signedData) => {
                runInAction(() => {
                    this.dashboardState.currentResource = assign(this.dashboardState.currentResource, {
                        signedData: signedData
                    });
                });
                this.onCopyToClipboardClicked([this.dashboardState.currentResource]);
            });
        }
    }

    newTopbarHeaderEmail() {
        if ((this.topBarController || this.enableFloatingToolbar) && this.dashboardState.currentResource) {
            this.sharingService.getSignedDataForImageSharing(this.dashboardState.currentResource).then((signedData) => {
                runInAction(() => {
                    this.dashboardState.currentResource = assign(this.dashboardState.currentResource, {
                        signedData: signedData
                    });
                });
                this.onSendByEmailClicked([this.dashboardState.currentResource]);
            });
        }
    }

    onCopyToClipboardClicked(data) {
        this.sharingService.copyToClipboard(data).then(() => {
            const text =
                Array.isArray(data) && data.length > 1
                    ? 'DASHBOARD.VIEW.RESOURCES_COPY_SUCCESSFULLY'
                    : 'DASHBOARD.VIEW.COPY_SUCCESSFULLY';

            this._showResourcesSharedNotification(data, text);
        });
    }

    onSendByEmailClicked(data) {
        this.sharingService.sendByEmail(this.mailTrigger, data).then(() => {
            this._showResourcesSharedNotification(data, 'DASHBOARD.VIEW.IMAGE_COPYING_EMAIL');
        });
    }

    enableCopyToClipboard() {
        return this.accountData.protectedSettings.enableCopyToClipboard;
    }

    enableEmailImageSharing() {
        return this.accountData.protectedSettings.emailImageSharing;
    }

    enableLocalImageSaving() {
        return this.accountData.protectedSettings.localImageSaving;
    }

    enableFloatingToolbar() {
        return get(this.accountData, 'protectedSettings.enableSessionToolbar');
    }

    _showResourcesSharedNotification(data, notificationText) {
        if (this.tsInterfaceHelper.useNewInterface) {
            // Use React modal for shared notification
            this.showSharedNotificationModalReact(notificationText);
        }
    }

    _findSelectedResource(selectedResources, resource) {
        return find(selectedResources, (selectedResource) => selectedResource.url === resource.url);
    }

    @action
    toggleResourceSelection = (resource, resourceType) => {
        const selectedResources = this.selectedResources(resourceType);

        const selectedResource = this._findSelectedResource(selectedResources, resource);

        if (selectedResource) {
            selectedResources.splice(selectedResources.indexOf(selectedResource), 1);
            this.resourcesReadyToBeShared(resourceType);
        } else {
            const newResource = {inProgress: true, _id: resource._id, url: resource.url, type: 'url'};

            selectedResources.push(newResource);

            Promise.resolve().then(() =>
                this.sharingService
                    .getSignedDataForImageSharing(newResource)
                    .then((signedData) => {
                        this.updateExistingResource(resourceType, newResource, {
                            inProgress: false,
                            signedData
                        });
                        this.resourcesReadyToBeShared(resourceType);
                    })
                    .catch((err) => {
                        runInAction(() => {
                            selectedResources.splice(selectedResources.indexOf(newResource), 1);
                        });
                    })
            );
        }
    };

    @action
    updateExistingResource(resourceType, resource, patch) {
        const selectedResources = this.selectedResources(resourceType);
        const item = selectedResources.find((r) => r && r.url === resource.url);
        Object.assign(item, patch);
    }

    @action
    resourcesReadyToBeShared(resourceType) {
        const resources = this.selectedResources(resourceType);
        this.sharingState.isResourcesReadyToBeShared = resources.length > 0 && !some(resources, (r) => r.inProgress);
    }

    selectUnselectAllResources(resourceType, allResources, unselectAll) {
        if (this.togglingInProgress) {
            return;
        }

        runInAction(() => {
            this.togglingInProgress = true;
        });

        return Promise.resolve()
            .then(() => {
                const checkboxes = document.querySelectorAll(`.input-checkbox-${resourceType}`);
                const isAnyCheckboxUnselected = some(checkboxes, (checkbox) => !checkbox.checked);

                forEach(checkboxes, (checkbox) => {
                    checkbox.checked = isAnyCheckboxUnselected;
                });

                const allResourcesByType = allResources[resourceType];
                const selectedResources = this.selectedResources(resourceType);
                const isAnyResourceUnselected = some(
                    allResourcesByType,
                    (resource) => !find(selectedResources, (selectedResource) => selectedResource.url === resource.url)
                );

                forEach(allResourcesByType, (resource) => {
                    const isSelected = find(
                        selectedResources,
                        (selectedResource) => selectedResource.url === resource.url
                    );

                    if (unselectAll) {
                        if (isSelected) {
                            // Unselect - call toggleResourceSelection directly
                            this.toggleResourceSelection(resource, resourceType);
                        }
                    } else {
                        // Select/unselect toggle
                        if ((!isSelected && isAnyResourceUnselected) || (isSelected && !isAnyResourceUnselected)) {
                            this.toggleResourceSelection(resource, resourceType);
                        }
                    }
                });
            })
            .finally(() => {
                runInAction(() => {
                    this.togglingInProgress = false;
                });
            });
    }
    @action
    unselectAllSelectedResourcesToggle(isSelected, resource, resourceType) {
        if (isSelected) {
            // Unselect all
            this.toggleResourceSelection(resource, resourceType);
        }
    }
    @action
    selectUnselectToggle(isSelected, isAnyResourceUnselected, resource, resourceType) {
        // Flip selection if not checked and we're selecting all OR
        //                if     checked and we're unselecting all
        if ((!isSelected && isAnyResourceUnselected) || (isSelected && !isAnyResourceUnselected)) {
            this.toggleResourceSelection(resource, resourceType);
        }
    }

    areAllResourcesSelected(resourceType, allResources) {
        if (isEmpty(allResources[resourceType]) || isEmpty(this.selectedResources(resourceType))) {
            return false;
        }

        return allResources[resourceType].length === this.selectedResources(resourceType).length;
    }

    isResourceSelected = (resource, resourceType) => {
        const foundResource = findIndex(
            this.selectedResources(resourceType),
            (selectedResource) => selectedResource.url === resource.url
        );

        return foundResource !== -1;
    };

    handleMediaLog(details, isError) {
        if (isError) {
            if (this.dashboardState.isOpentok) {
                this.eventLog.opentokError(details);
            } else {
                this.eventLog.turnError(details);
            }

            return;
        }

        if (this.dashboardState.isOpentok) {
            this.eventLog.opentok(details);
        } else {
            this.eventLog.turn(details);
        }
    }

    goToInvite(stateParams) {
        if (this.embeddedDashboard) {
            if (this.observe) {
                return this.stateHelper.navigateTo('invitationEnded');
            }

            if (this.isMobile || this.isTablet) {
                return this.stateHelper.navigateTo('sessionEnded');
            }

            return;
        }

        this.stateHelper.navigateTo('invite', stateParams);
    }

    _hidePointerAlert() {
        this.saveOnLocalStorage
            ? this.browserUtilsService.getFromLocalStorage(`hidePointerUnavailableAlert_${this.roomData._id}`)
            : this.browserUtilsService.getFromSessionStorage('hidePointerUnavailableAlert');
    }

    _dontShowPointerAlertAgain() {
        this.saveOnLocalStorage
            ? this.browserUtilsService.saveToLocalStorage(`hidePointerUnavailableAlert_${this.roomData._id}`, true)
            : this.browserUtilsService.saveToSessionStorage('hidePointerUnavailableAlert', true);
    }

    _handleAgentPointerAvailability() {
        const availabilityStatus = this.chatApi.client.livePointerUnavailable;

        if (availabilityStatus !== null && availabilityStatus !== this.isClientPointerUnavailable) {
            this.isClientPointerUnavailable = availabilityStatus;
        }

        if (this.isClientPointerUnavailable && !this._hidePointerAlert()) {
            this._dontShowPointerAlertAgain(true);
            const message = this.translate('DASHBOARD.VIEW.POINTER_UNAVAILABLE');

            this.setMessageAlert(
                message,
                POINTER_UNAVAILABLE_MESSAGE_ALERT_COLOR,
                POINTER_UNAVAILABLE_MESSAGE_ALERT_TIMEOUT
            );
        }

        return Promise.resolve();
    }

    _handleDesktopSharingAgentControlStatus() {
        const agentHasRemoteControl = get(this.chatApi, 'client.agentHasRemoteControl');

        this.isLivePointerRunning = get(this.chatApi, 'livePointer.connected');

        if (agentHasRemoteControl === this.agentHasRemoteControl) {
            return;
        }

        if (!agentHasRemoteControl) {
            this.chatApi.setStatus('agentRequestRemoteControl', false);
        }

        this.agentHasRemoteControl = agentHasRemoteControl;

        const toastMessageText = agentHasRemoteControl
            ? this.translate('DASHBOARD.DESKTOP_SHARING_REQUEST_APPROVED')
            : this.translate('DASHBOARD.DESKTOP_SHARING_REQUEST_STOPPED');

        const toastMessageColor = agentHasRemoteControl ? DS_CONTROL_REQUEST_APPROVED_COLOR : DS_CONTROL_STOPPED_COLOR;

        const toastMessageTimeout = agentHasRemoteControl
            ? DS_CONTROL_REQUEST_APPROVED_TIMEOUT
            : DS_CONTROL_STOPPED_TIMEOUT;

        this.setMessageAlert(toastMessageText, toastMessageColor, toastMessageTimeout);

        if (this.agentHasRemoteControl) {
            this.eventLog.desktopShareClientApprovedRemoteControl();
        } else {
            this.eventLog.desktopShareClientStoppedRemoteControl();
        }

        return Promise.resolve();
    }

    setInteractionSummarySessionSource(sessionSource) {
        if (sessionSource === SESSION_SOURCE.AI || sessionSource === SESSION_SOURCE.VJ) {
            return this.translate('REACT.INTERACTION.SUMMARY.INTERACTION.SUMMARY');
        }

        return sessionSource;
    }

    @action
    setActionMode() {
        this.sharingState.sharingModeActions = this.sharingService.getShareModeActions();
    }

    get shareActionsMode() {
        return [...this.sharingState.sharingModeActions];
    }

    @action
    selectImageToShare = (e, resource) => {
        e.stopPropagation();

        if (this.sharingState.shareSelectedImage) {
            this.sharingState.shareSelectedImage = null;

            return;
        }
        // Create the sharing params object that matches ISharingParams interface
        const sharingParams = {
            _id: resource._id,
            url: resource.url,
            type: 'url'
        };

        // Create a separate object for internal state tracking
        const newResource = {
            inProgress: true,
            ...sharingParams
        };
        Promise.resolve().then(() => {
            const servicePromise = this.sharingService.getSignedDataForImageSharing(sharingParams);

            return servicePromise
                .then((signedData) => {
                    const patch = {
                        inProgress: false,
                        signedData: signedData
                    };

                    this.sharingState.shareSelectedImage = {...newResource, ...patch};
                })
                .catch(() => {
                    this.sharingState.shareSelectedImage = null;
                });
        });
    };

    shareModeActionClick = (e, type, data) => {
        e.stopPropagation();
        this.onShareActionClick({type, data, resource: this.sharingState.shareSelectedImage});
    };

    isSelectResourceReady = () => {
        return !!(this.sharingState.shareSelectedImage && this.sharingState.shareSelectedImage.inProgress === false);
    };

    historyResourceActionClick = (e, type, data) => {
        e.stopPropagation();

        const resource = this.historyResourcesController.findSelectedResource(data);

        this.onShareActionClick({type, data, resource});
    };

    onShareActionClick = (resource) => {
        switch (resource.type) {
            case ActionTypes.download:
                this.onDownloadClicked(resource.data);
                break;
            case ActionTypes.copyToClipboard:
                this.onCopyToClipboardClicked(resource.resource);
                break;
            case ActionTypes.sendByEmail:
                this.onSendByEmailClicked(resource.resource);
                break;
        }
    };

    setConnectionStatus(status) {
        runInAction(() => {
            this.dashboardState.connectionStatus = status;
        });
    }

    // ========== Main Controller Methods (renamed conflicts) ==========

    TsVideoSubscriberControllerEvents() {
        // Canvas/video interaction events
        this.tsVideoSubscriberController.on(VideoSubscriberEventType.on_init_canvas_click, (event) => {
            this.initCanvasClick(event);
        });

        this.tsVideoSubscriberController.on(VideoSubscriberEventType.on_magic_marker, (triggeredByAgent) => {
            this.magicMarkerCreated(triggeredByAgent);
        });

        this.tsVideoSubscriberController.on(VideoSubscriberEventType.on_pre_video_click, (event) => {
            this.preVideoClick(event);
        });

        this.tsVideoSubscriberController.on(VideoSubscriberEventType.on_video_resolution_changed, (data) => {
            this.videoResolutionChanged(data.resolutionFormat);
        });

        this.tsVideoSubscriberController.on(VideoSubscriberEventType.on_video_subscriber_changed, (subscriber) => {
            this.onVideoSubscriberChanged(subscriber);
        });

        this.tsVideoSubscriberController.on(VideoSubscriberEventType.on_restore_from_focus_loss, () => {
            this.restoreFromFocusLoss();
        });

        this.tsVideoSubscriberController.on(VideoSubscriberEventType.on_video_clicked, (event) => {
            this.videoClicked(event, true);
        });

        // Video control events
        this.tsVideoSubscriberController.on(VideoSubscriberEventType.on_pause_video, (data) => {
            // data contains {event, value}
            this.pauseVideo(data?.event, data?.value);
        });

        this.tsVideoSubscriberController.on(VideoSubscriberEventType.on_handle_dashboard_title_action, (event) => {
            this.handleDashboardTitleAction(event);
        });

        this.tsVideoSubscriberController.on(VideoSubscriberEventType.on_toggle_mute, () => {
            this.videoModeController.toggleMute();
        });
    }

    setupToolbarEventListeners() {
        const toolbarOptionsController = this.tsFloatingToolbarController?.toolbarOptionsController;

        if (!toolbarOptionsController) {
            return;
        }

        const dashboard = this;

        // Scan - handles both scan and snapAndScan based on embeddedDashboard
        toolbarOptionsController.on(ToolbarEventType.scan, () => {
            if (this.embeddedDashboard) {
                this.snapAndScan();
            } else {
                this.scan();
            }
        });

        // Send image
        toolbarOptionsController.on(ToolbarEventType.send_image, (callback) => {
            dashboard.sendImage(callback);
        });

        // Continue for all other events...
        toolbarOptionsController.on(ToolbarEventType.save_resource, () => {
            dashboard.saveResource();
        });

        toolbarOptionsController.on(ToolbarEventType.desktop_sharing_toggle_control, () => {
            this.desktopSharingToggleControl();
        });

        toolbarOptionsController.on(ToolbarEventType.send_flashlight_guidance, () => {
            this.sendFlashfightGuidance();
        });

        toolbarOptionsController.on(ToolbarEventType.set_flashlight_states, ({activateItem, deactivateItem}) => {
            this.setFlashlightStates(activateItem, deactivateItem);
        });

        toolbarOptionsController.on(ToolbarEventType.set_toolbar_scan_states, ({activateItem, deactivateItem}) => {
            this.setToolbarScanStates(activateItem, deactivateItem);
        });

        toolbarOptionsController.on(ToolbarEventType.copy_to_clipboard, () => {
            dashboard.newTopbarHeaderCopyToClipboard();
        });

        toolbarOptionsController.on(ToolbarEventType.download, () => {
            dashboard.newTopbarHeaderDownload();
        });

        toolbarOptionsController.on(ToolbarEventType.email, () => {
            dashboard.newTopbarHeaderEmail();
        });

        toolbarOptionsController.on(ToolbarEventType.run_speedtest, () => {
            this.runSpeedTestOnClient();
        });

        toolbarOptionsController.on(ToolbarEventType.record_button, () => {
            dashboard.onRecordButton();
        });

        toolbarOptionsController.on(ToolbarEventType.run_wifi_scan, () => {
            this.runWifiScanOnClient();
        });

        toolbarOptionsController.on(ToolbarEventType.start_wifi_visual_scan, () => {
            this.startWifiVisualScan();
        });
    }

    cleanupToolbarEventListeners() {
        const toolbarOptionsController = this.tsFloatingToolbarController?.toolbarOptionsController;

        if (toolbarOptionsController) {
            // Dispose the toolbar options controller (resets handlers and removes listeners)
            if (typeof toolbarOptionsController.dispose === 'function') {
                toolbarOptionsController.dispose();
            }
        }

        // Nullify stored handlers to prevent React state updates on unmounted components
        this.floatingToolbarScanHandlers = null;
        this.floatingToolbarFlashlightHandlers = null;
    }

    _getSnapshotFromKnownStream(options) {
        return this.dashboardMediaService
            .getSnapshotFromKnownStream(KnownMediaStream.USER_VIDEO_STREAM, options)
            .catch((err) => {
                // Silently fail on failures due to lack of stream
                if (err && err.message === NO_REQUESTED_STREAM) {
                    return null;
                }

                throw err;
            });
    }

    toggleInteractionSummaryWidget(params) {
        InteractionSummaryEventService.toggleWidget(params);
    }

    syncMeetingState() {
        trace.info('Sync Meeting state start');

        this.syncAudioSubscriber();
        this.syncPauseState();

        this.clientDisconnected = !this.chatApi.client.connected && this.chatApi.client.connected !== undefined;

        if (
            (this.chatApi.client.mode === MeetingMode.images && !this.dashboardState.displayTermsInPhotoStream) ||
            includes([MeetingMode.oneClick, MeetingMode.coBrowsing], this.chatApi.client.mode)
        ) {
            this.finishWizard();
        } else if (!this.wizardState.finished && this.platform && this.rightBarController.meetingHistoryLength === 0) {
            this.showWizard = true;
            runInAction(() => {
                this.dashboardState.showWizard = true;
            });
            this.wizardState.platform = this.platform;
            this.wizardState.showWizard = true;

            if (this.platform === 'apple' && this.wizardState.step !== 1) {
                this.goToWizardStep(0);
            }
        }

        const clientMode = this.chatApi.client.mode;

        if (
            !this.chatApi.client.preparing ||
            includes([MeetingMode.images, MeetingMode.oneClick, MeetingMode.coBrowsing], clientMode)
        ) {
            this.busy.free();

            switch (this.chatApi.client.mode) {
                case MeetingMode.video:
                case MeetingMode.screen:
                case MeetingMode.appSharing:
                case MeetingMode.videoApplication: {
                    const shouldInitVideoState = !this.videoModeState.videoState.enabled;
                    runInAction(() => {
                        this.dashboardState.videoModeState.wasInVideoMode = true;

                        if (shouldInitVideoState) {
                            this.videoModeState.videoState.enabled = true;
                            this.videoModeState.videoState.focus = true;
                            this.videoModeState.videoState.mode = VIDEO_MODES.CURSOR_SHARING;
                            this.videoModeState.videoState.sizeTarget = '.dashboard-main-image-container';
                            this.videoModeState.videoState.accountId = this.accountData._id;
                            this.videoModeState.videoState.roomId = this.roomData._id;
                            this.videoModeState.videoState.isLivePointerOnMobileDashboardEnabled = get(
                                this.accountData,
                                'protectedSettings.enableLivePointerOnMobileDashboard'
                            );
                            this.videoModeState.videoState.remoteControl =
                                this.dashboardState.isDesktopSharingSession &&
                                get(this.accountData, 'protectedSettings.desktopSharing.enableRemoteControl');
                        }

                        this.videoModeState.videoState.enableDashboardMagicMarker = this.isMagicMarkerEnabled;
                        this.videoModeState.videoState.enableCustomerMagicMarker = this.isCustomerMagicMarkerEnabled;
                        this.videoModeState.videoState.magicMarker = this.magicMarkerSettings;
                    });

                    if (shouldInitVideoState) {
                        this.finishWizard();
                    }

                    break;
                }

                case MeetingMode.coBrowsing:
                case MeetingMode.oneClick:
                case MeetingMode.images:
                    runInAction(() => {
                        this.videoModeState.videoState.enabled = false;
                    });

                    // if (get(this.chatApi, 'client.mode') === MeetingMode.coBrowsing) {
                    //     runInAction(() => {
                    //         this.dashboardState.hideWidgets = true;
                    //     });
                    //     this.tsCobrowsing.start(
                    //         this.accountData._id.toString(),
                    //         this.roomData._id.toString(),
                    //         get(this.accountData, 'protectedSettings.coBrowsing.surflyWidgetKey')
                    //     );
                    // }

                    break;

                default:
            }
        }

        this._checkModesAvailability();
    }

    @computed
    get displayAudioButton() {
        return (
            isAudioAvailableInMode(this.dashboardState.clientRoomStorage.mode) &&
            this.dashboardState.dashboardRoomStorage.audioSupport &&
            this.dashboardState.clientRoomStorage.audioSupport &&
            this.dashboardState.dashboardRoomStorage.audioHandshakeSuccess !== false &&
            this.dashboardState.clientRoomStorage.audioHandshakeSuccess !== false
        );
    }

    syncAudioSubscriber() {
        const clientStream = this.audioService.clientStream();
        const isVoipEnabled = this.dashboardMediaService.isVoipEnabled;
        const isAudioSupported = this.audioService.isAudioSupportedByDashboard;

        if (clientStream || !isVoipEnabled || !isAudioSupported) {
            return;
        }

        if (!this.syncAudio) {
            this.syncAudio = true;
            this.audioService.initAudioAlert();
        }

        this.audioService.createSubscriber();
    }

    @action
    syncPauseState() {
        if (this.chatApi.client.pausedBy === UserType.dashboard) {
            this.videoPausedByDashboard = true;
            this.isPaused = true;
        } else if (this.chatApi.client.pausedBy === UserType.client) {
            this.videoPausedByDashboard = false;
            this.isPaused = true;
        } else {
            this.videoPausedByDashboard = false;
            this.isPaused = false;
        }

        if (this.videoModeState && this.videoModeState.videoState) {
            this.videoModeState.videoState.isPaused = this.isPaused;
            this.videoModeState.videoState.videoPausedByDashboard = this.videoPausedByDashboard;
        }
        this._pagePlacementPause(this.isPaused);
    }

    onVideoSubscriberChanged(videoSubscriber) {
        this.videoSubscriber = videoSubscriber;
    }

    _setScreenshots(value) {
        this.saveScreenshotsOnLocalStorage
            ? this.browserUtilsService.saveToLocalStorage(`screenshots_${this.roomData._id}`, value)
            : this.browserUtilsService.saveToSessionStorage('screenshots', value);
    }

    _getScreenshots() {
        return this.saveScreenshotsOnLocalStorage
            ? this.browserUtilsService.getFromLocalStorage(`screenshots_${this.roomData._id}`)
            : this.browserUtilsService.getFromSessionStorage('screenshots');
    }

    _setScreenshotsRoomId(value) {
        return this.saveScreenshotsOnLocalStorage
            ? this.browserUtilsService.saveToLocalStorage(`screenshotsRoomId_${value}`, value)
            : this.browserUtilsService.saveToSessionStorage('screenshotsRoomId', value);
    }

    _getScreenshotsRoomId() {
        return this.saveScreenshotsOnLocalStorage
            ? this.browserUtilsService.getFromLocalStorage(`screenshotsRoomId_${this.roomData._id}`)
            : this.browserUtilsService.getFromSessionStorage('screenshotsRoomId');
    }

    initScreenshots() {
        if (!this._getScreenshots() || this._getScreenshotsRoomId() !== this.roomData._id) {
            this._setScreenshots([]);
            this._setScreenshotsRoomId(this.roomData._id);
        }
        runInAction(() => {
            this.dashboardState.screenshots = [...this._getScreenshots()];
        });

        forEach(this.dashboardState.screenshots, (screenshot) => {
            if (screenshot.dataUrl) {
                screenshot.url = this._snapshotToImg(screenshot.dataUrl).img;
            }
        });
    }

    get isMagicMarkerEnabled() {
        // TODO: Instead of !this.mode should consider the starting mode

        return this.allowMagicMarker && (!this.mode || this.mode === MeetingMode.video) && !this.observe;
    }

    get isCustomerMagicMarkerEnabled() {
        return (
            this.allowCustomerMagicMarker &&
            !(
                this.dashboardState.isDesktopSharingSession ||
                this.dashboardState.isApplicationSharing ||
                this.dashboardState.isScreenSharing
            )
        );
    }

    get mode() {
        return get(this.chatApi, 'client.mode');
    }

    get currentResource() {
        return this.dashboardState?.currentResource || {};
    }

    get isSupportTextAnnotation() {
        return get(this.accountData, 'protectedSettings.isSupportTextAnnotation');
    }

    get isVideoScan() {
        return this.videoModeState.videoState.mode === VIDEO_MODES.SCANNING && !this.isImageScan;
    }

    get isImageScan() {
        return this.dashboardState.imageMode === this.IMAGE_MODES.SCANNING && !this.isVideoScan;
    }

    get isVideoApplicationMode() {
        return this.mode === MeetingMode.videoApplication;
    }

    get isDesktopSharingRemoteControlSession() {
        return (
            this.dashboardState.isDesktopSharingSession &&
            get(this.accountData, 'protectedSettings.desktopSharing.enableRemoteControl')
        );
    }

    @computed
    get isRunWifiButtonDisabled() {
        const visualScanStatus = this.chatApi?.client?.visualScanStatus;
        const isVisualScanActive = [VisualScanStatusType.Processing, VisualScanStatusType.InProgress].includes(
            visualScanStatus
        );

        return this.dashboardState.floatingToolbarState._isRunWifiButtonDisabled || isVisualScanActive;
    }

    @computed
    get isRunWifiVisualScanButtonDisabled() {
        const isCapable = get(this.dashboardState, 'isDeviceSupportsVisualScan', true);
        if (this.dashboardState.floatingToolbarState.isStopVisualWifiScan) {
            return false;
        }

        const isWifiScanInProgress = get(this.dashboardState, 'isMobileWifiScanInProgress', '');
        const isVisualScanProcessing = get(this.dashboardState, 'isMobileVisualScanProcessing', '');
        const isOCRProcessing = this.dashboardState.isScanMode;

        return (
            !get(this.chatApi, 'client.connected') ||
            isWifiScanInProgress ||
            isVisualScanProcessing ||
            isOCRProcessing ||
            !isCapable
        );
    }

    get isTitleActionHidden() {
        const screenSharePause =
            (!this.allowScreenPause && includes([MeetingMode.appSharing], this.mode)) ||
            this.dashboardState.isScreenSharing;
        // Video paused by customer - isPaused === true and not paused by dashboard
        // Also prevent hiding action button when video paused but we are in canvas
        const videoPausedByCustomer = this.isPaused && !this.videoPausedByDashboard && !this.dashboardState.isCanvas;
        // Canvas mode - isCanvas === true and alos we are in ONE_CLICK or PHOTO modes
        const isCanvas =
            this.dashboardState.isCanvas && (this.mode === MeetingMode.oneClick || this.mode === MeetingMode.images);

        // X button should be HIDDEN (action blue button) when:
        // Current mode is sharing, video, video paused by customer or canvas

        return this.dashboardState.isDesktopSharing || screenSharePause || videoPausedByCustomer || isCanvas;
    }

    get isVideoApplicationPaused() {
        return this.isVideoApplicationMode && this.isPaused && this.videoModeState.videoState.focus;
    }

    desktopSharingToggleControl() {
        const dashboardScope = this;

        this.chatApi.setStatus('agentRequestRemoteControl', !dashboardScope.agentHasRemoteControl);

        this.displayToastMessage(
            'DASHBOARD.DESKTOP_SHARING_REQUEST_SENT_TO_CUSTOMER',
            DS_CONTROL_REQUEST_SENT_TO_CUSTOMER_COLOR,
            DS_CONTROL_REQUEST_SENT_TO_CUSTOMER_TIMEOUT
        );

        if (dashboardScope.agentHasRemoteControl) {
            this.eventLog.desktopShareAgentStoppedRemoteControl();
        } else {
            this.eventLog.desktopShareAgentRequestRemoteControl();
        }
    }

    displayToastMessage(labelTextKey, toastColor, toastTimeout) {
        const dashboardScope = this;

        if (dashboardScope) {
            dashboardScope.setMessageAlert(this.translate(labelTextKey), toastColor, toastTimeout);
        }
    }

    showDrawingCanvas() {
        return (
            this.videoModeState.videoState.enableDashboardMagicMarker &&
            this.videoModeState.videoState.focus &&
            !this.isPaused
        );
    }

    isToggleEnabled_SquareFloatingVideo() {
        return this.dashboardState.minimizedVideoMode === VIDEO_MINIMIZED_MODES.SQUARE;
    }

    isToggleEnabled_NewLivePointerDesign() {
        return get(this.accountData, 'protectedSettings.enableNewLivePointerDesign');
    }

    isToggleEnabled_SessionToolbar() {
        return get(this.accountData, 'protectedSettings.enableSessionToolbar');
    }

    isToggleEnabled_flashLight() {
        return get(this.accountData, 'protectedSettings.enableFlashlight');
    }

    runSpeedTestOnClient() {
        this.chatApi.requestAction('runSpeedTest', true);
    }

    @action
    runWifiScanOnClient() {
        const options = {
            reliability: ReliabilityStrategy.ClientTimeout,
            secondsToTimeout: 5
        };

        if (this.chatApi.wifiScanStatus === WifiScanStatusType.Requested) {
            return;
        }

        if (!this.rightBarController.enableAgentWifiScanHistory) {
            this.wifiAnalyzerController.show();
        } else {
            this.displayToastMessage(
                'CONNECTIVITY_GURU.WIFI_SCAN.WIFI_SCAN_IN_PROGRESS',
                CG_INFORMATIVE_COLOR,
                CG_WIFI_SCAN_TIMEOUT
            );
        }

        this.chatApi.requestAction('runWifiScan', true, options);
        this.chatApi.setStatus('wifiScanStatus', WifiScanStatusType.Requested, true);
        this.dashboardState.floatingToolbarState._isRunWifiButtonDisabled = true;

        if (this.wifiScanTimeoutId) {
            clearTimeout(this.wifiScanTimeoutId);
        }

        this.wifiScanTimeoutId = setTimeout(() => {
            if (this.dashboardState.floatingToolbarState._isRunWifiButtonDisabled) {
                runInAction(() => {
                    this.dashboardState.floatingToolbarState._isRunWifiButtonDisabled = false;
                });
                this.chatApi.setStatus('wifiScanStatus', WifiScanStatusType.Idle, true);
                this.wifiScanTimeoutId = null;
            }
        }, 10000);
    }

    onCloseGuidanceSpeedtest() {
        this.displaySpeedtestGuidance = false;
    }

    sendFlashfightGuidance() {
        this.eventLog.sendFlashfightGuidance({turnOnGuidance: !this.isTorchActive});
        this.chatApi.requestAction('runTurnOnFlashlightGuide', true);
    }

    preVideoClick(e) {
        const currentTime = Date.now();
        if (!this._lastClickTime) {
            this._lastClickTime = 0;
        }

        if (currentTime - this._lastClickTime < 300) {
            return;
        }
        this._lastClickTime = currentTime;

        if (!this.dashboardState.hideWifiScan) {
            if (!this._isDragging) {
                runInAction(() => {
                    this.dashboardState.isSquareFloatingVideo = false;
                    this.dashboardState.hideWifiScan = true;
                });
                this.wifiAnalyzerScanController.hide();
            }
        }

        if (!this.videoModeState.videoState.focus) {
            runInAction(() => {
                this.videoModeState.videoState.focus = true;
            });
            return;
        }

        if (this.dashboardState.floatingToolbarState.isDesktopSharingRemoteControlSession) {
            return;
        }

        return this.videoClicked(e);
    }

    setVideoMinimized() {
        console.log('videoFocus: false');
        runInAction(() => {
            this.videoModeState.videoState.focus = false;
        });
    }

    initCanvasClick(e) {
        this.videoClickPosition = {
            x: e.clientX,
            y: e.clientY
        };

        this.clickCanvasTime = Date.now();

        this._isDragging = false;

        const startX = e.touches ? e.touches[0].clientX : e.clientX;
        const startY = e.touches ? e.touches[0].clientY : e.clientY;

        const moveHandler = (moveEvent) => {
            const currentX = moveEvent.touches ? moveEvent.touches[0].clientX : moveEvent.clientX;
            const currentY = moveEvent.touches ? moveEvent.touches[0].clientY : moveEvent.clientY;

            const deltaX = Math.abs(currentX - startX);
            const deltaY = Math.abs(currentY - startY);

            if (deltaX > 5 || deltaY > 5) {
                this._isDragging = true;
            }
        };

        const endHandler = () => {
            if (this._isDragging) {
                setTimeout(() => {
                    this._isDragging = false;
                }, 100);
            }

            document.removeEventListener('mousemove', moveHandler);
            document.removeEventListener('mouseup', endHandler);
            document.removeEventListener('touchmove', moveHandler);
            document.removeEventListener('touchend', endHandler);
        };

        document.addEventListener('mousemove', moveHandler);
        document.addEventListener('mouseup', endHandler);
        document.addEventListener('touchmove', moveHandler);
        document.addEventListener('touchend', endHandler);
    }

    videoClicked = (e, forceTreatAsClick = false) => {
        const {x, y} = this.videoClickPosition;
        const differenceFromMouseDown = Date.now() - this.clickCanvasTime;
        const isMobileDashboard = this.environmentDetect.isMobile();

        let strokeLength = 0;

        if (this.isMagicMarkerEnabled && x && y && e && e.clientX && e.clientY) {
            strokeLength = Math.sqrt((x - e.clientX) * (x - e.clientX) + (y - e.clientY) * (y - e.clientY));
        }

        if (
            forceTreatAsClick ||
            !this.isMagicMarkerEnabled ||
            isMobileDashboard ||
            (strokeLength < MIN_ALLOWED_STROKE_LENGTH && differenceFromMouseDown < MIN_INTERVAL_TO_DRAW_MAGIC_MARKER)
        ) {
            const videoMode = this.videoModeState.videoState.mode;
            const snapshotAllowedModes = [VIDEO_MODES.SNAP, VIDEO_MODES.CURSOR_SHARING];

            this._syncLabelMode(false);

            if (includes(snapshotAllowedModes, videoMode)) {
                this._makeSnapshot(this.CLASSIFY_EVENT_SOURCES.VIDEO_CLICKED);
            }
        }
    };

    handleDashboardTitleAction(event) {
        if (event && event.stopPropagation) {
            event.stopPropagation();
        }

        if (
            this.dashboardState.isLiveVideo ||
            this.dashboardState.isScreenVideo ||
            this.dashboardState.isDesktopSharing ||
            (!this.dashboardState.isCanvas && this.dashboardState.isVideoApplication)
        ) {
            if (this.videoModeState.videoState.isPaused && !this.videoModeState.videoState.videoPausedByDashboard) {
                return;
            }

            this.pauseVideo(event);
        } else if (this.dashboardState.isScanMode) {
            this.cancelScanning();
        } else if (this.dashboardState.isCanvas) {
            this.videoClicked(null, true);
        }
    }

    isMeetingModesReady(cameraApproval) {
        return this.displayMeetingModes() && cameraApproval;
    }

    _makeSnapshot(eventSource) {
        this.streamAction(eventSource, false).then((snapshot) => {
            if (snapshot) {
                if (eventSource === this.CLASSIFY_EVENT_SOURCES.VIDEO_CLICKED) {
                    this.tsSnapshotReminderService.snapshotTaken();
                }
            }
        });
    }

    _setupWifiAnalyzerScanListeners() {
        // Event constants matching WifiAnalyzerScanEvents in controller.ts
        const PUSH_WIFI_SCAN = 'PUSH_WIFI_SCAN';
        const PUSH_VISUAL_SCAN = 'PUSH_VISUAL_SCAN';
        const CHECK_MISSING_SCANS = 'CHECK_MISSING_SCANS';

        // Listen for wifi scan push events - delegate to RightBarController
        this.wifiAnalyzerScanController.on(PUSH_WIFI_SCAN, (scan) => {
            this.rightBarController.handlePushWifiScan(scan);
        });

        // Listen for visual scan push events - delegate to RightBarController
        this.wifiAnalyzerScanController.on(PUSH_VISUAL_SCAN, (scan) => {
            this.rightBarController.handlePushVisualScan(scan);
        });

        // Listen for check missing scans events - handle API logic here
        this.wifiAnalyzerScanController.on(CHECK_MISSING_SCANS, async ({roomId, customerId}) => {
            try {
                const existingScanIds = this.rightBarController.getExistingScanIds();

                // Fetch missing scans from API
                const response = await getRootStore().wifiAnalyzerApiService.getMissingWifiScanByExistingScanIds(
                    existingScanIds,
                    customerId,
                    roomId
                );

                const {missingScans} = response;

                // Delegate to controller to process missing scans
                if (missingScans && missingScans.length > 0) {
                    this.wifiAnalyzerScanController.processMissingScans(missingScans);
                }
            } catch (error) {
                console.error('Failed to check for missing scans:', error);
            }
        });
    }

    @action
    resetWifiScanStatus = () => {
        if (this.wifiScanTimeoutId) {
            clearTimeout(this.wifiScanTimeoutId);
            this.wifiScanTimeoutId = null;
        }
        this.dashboardState.floatingToolbarState._isRunWifiButtonDisabled = false;
    };

    checkIfTextMessage(msg) {
        if (msg.data.type === 'text') {
            this.receiveMessage(msg);
        }
    }

    updateWifiScanScreen() {
        runInAction(() => {
            this.dashboardState.isSquareFloatingVideo = true;
            this.dashboardState.hideWifiScan = false;
        });
        this.setVideoMinimized();
    }

    sendImageViaPostMessage(image, fileName) {
        if (!this.isPostImageEnabledOnAccount) {
            return;
        }

        const dashboardScope = this;

        dashboardScope.jsApiService.Image({
            type: MessageType.image,
            techseeSessionId: this.roomData._id,
            fileName,
            base64encodedImage: image
        });
    }

    _applyWifiScanResults(results, shouldShow = false) {
        if (!results) {
            return;
        }

        if (this.wifiAnalyzerScanController) {
            this.wifiAnalyzerScanController.setResults(results);
            if (shouldShow && this.rightBarController.enableAgentWifiScanHistory && results.wifiConnectionInfo) {
                this.updateWifiScanScreen();
                this.wifiAnalyzerScanController.show();

                if (this.dashboardState) {
                    runInAction(() => {
                        // Check scan type and update the appropriate property
                        if (results.scanDetails?.scanType === SCAN_TYPE.ar) {
                            this.dashboardState.wifiState.visualScanResults = results;
                        } else {
                            this.dashboardState.wifiState.wifiScanResults = results;
                        }
                    });
                }
            }
        }
    }

    resourcesListener() {
        this.messageReceive();

        this._autorunDisposer = reaction(
            () => ({
                messages: this.messagesService.resources.length
            }),
            () => {
                this.messageReceive();
            }
        );
    }

    messageReceive() {
        if (!this._processedMessageUrls) {
            this._processedMessageUrls = new Set();
        }

        const resourcesToHandle = filter(
            this.messagesService.resources,
            (msg) =>
                !this._processedMessageUrls.has(msg.data.message) &&
                !some(this.dashboardState.screenshots, (screenshot) => screenshot.url === msg.data.message)
        );

        forEach(resourcesToHandle, (msg) => {
            this._processedMessageUrls.add(msg.data.message);
            this.receiveMessage(msg);
        });
    }

    _pagePlacementPause(paused) {
        const dashboardScope = this;

        if (paused) {
            if (this.dashboardState.isDesktopSharingSession) {
                this.domUtilsService.setPagePlacement('dashboard-desktop-sharing-paused');
            } else if (this.videoModeState.videoState.videoPausedByDashboard) {
                this.domUtilsService.setPagePlacement('dashboard-paused');
            } else if (!this.videoModeState.videoState.videoPausedByDashboard) {
                this.domUtilsService.setPagePlacement('dashboard-mobile-paused');
            }
        } else if (dashboardScope && dashboardScope.connected === CONNECTION_STATUS.IDLE) {
            this.domUtilsService.setPagePlacement('dashboard-idle-client');
        } else {
            this.domUtilsService.setPagePlacement('dashboard-live-session');
        }
    }

    _resetSessionStorage() {
        this._setScreenshots([]);
    }

    // This is a hack that forces IE11 to redraw right sidebar to fix css issues when adding new images
    _ieRedrawRightSidebar() {
        if (!this.hideRightSidebar) {
            this.hideRightSidebar = true;
            setTimeout(() => {
                this.hideRightSidebar = false;
            }, 10);
        }
    }

    _addToScreenShots(newImage) {
        runInAction(() => {
            this.dashboardState.screenshots.push(newImage);
        });
        this._setScreenshots([...this.dashboardState.screenshots]);
        // No need to sync - RightBarController accesses dashboardState directly
    }

    _removeLastScreenShot() {
        runInAction(() => {
            this.dashboardState.screenshots.pop();
        });
        this._setScreenshots(this.dashboardState.screenshots);
    }

    _updateResources(resources) {
        forEach(resources, (resource) => {
            const storageIndex = resource.storageIndex;
            const msg = this.rightBarController.findMessageByStorageIndex(storageIndex);

            const imgResource =
                !msg || msg.type === 'image' ? find(this.dashboardState.screenshots, {storageIndex}) : null;
            const videoResource =
                !imgResource && (!msg || msg.type === 'video') ? find(this.videos, {storageIndex}) : null;

            const updatedResource = imgResource || videoResource;

            if (msg) {
                runInAction(() => {
                    msg.message = resource.url;
                });
            }

            if (imgResource) {
                this._updateResourceUrl(storageIndex, resource.url, resource.extraUrl);
            } else if (videoResource) {
                runInAction(() => {
                    if (videoResource.video) {
                        videoResource.url = resource.extraUrl;
                        videoResource.video = resource.url;
                    } else {
                        videoResource.url = resource.url;
                    }
                });
            }
        });
    }

    _updateResourceUrl(storageIndex, url, extraUrl) {
        runInAction(() => {
            const resource = this.dashboardState.screenshots.find((s) => s.storageIndex === storageIndex);
            if (resource) {
                if (resource.video && extraUrl) {
                    resource.url = extraUrl;
                    resource.video = url;
                } else {
                    resource.url = url;
                }
            }
        });
    }

    displayLiveVideo() {
        return this.isVideoOrScreensharingMode(this.mode) && this.dashboardState.areBothSidesConnected;
    }

    shouldDisplayVideoTools() {
        if (
            (this.dashboardState.showScanners && this.tsInterfaceHelper.useNewInterface) ||
            this.isScreensharingMode(this.mode)
        ) {
            return false;
        }

        return (
            ((get(this.video, 'focus') && this.videoModeState.videoState.enabled) ||
                get(this.dashboardState?.currentResource, 'isVideo')) &&
            !this.observe
        );
    }

    handleImageDownloadFail() {
        const errModal = this.errorDialogController.show('ERROR_DIALOG.VIEW.IMAGE_FAILED_TO_LOAD', true);

        const failedResource = this.dashboardState?.currentResource;

        this.resetResource();

        errModal.then(({retryDownload}) => {
            if (retryDownload) {
                this.eventLog.retryingImageDownload({
                    url: failedResource.url
                });

                this.setResource(failedResource);
            }
        });
    }

    _checkModesAvailability() {
        const clientMode = this.chatApi.client.mode;
        const isClientPreparing =
            this.chatApi.client.preparing &&
            !includes([MeetingMode.images, MeetingMode.oneClick, MeetingMode.coBrowsing], clientMode);

        const checkObserve = !this.observe;
        const checkConnected = this.chatApi.client.connected;
        const checkPaused = !this.isPaused;
        const checkVisible = this.chatApi.client.visible;
        const checkPreparing =
            !isClientPreparing || (this.allowSwitchModeDuringInitiation && this.dashboardState.isInInitiationPhase);

        runInAction(() => {
            this.dashboardState.modesEnabled =
                checkObserve && checkConnected && checkPaused && checkVisible && checkPreparing;
        });

        this.videoSupport = this.chatApi.client.videoSupport !== false && this.chatApi.dashboard.videoSupport;

        this.photoSupport = this.chatApi.client.photoSupport;

        if (!this.photoSupport && !(this.dashboardState.allowOneClickPhotoMode && this.videoSupport)) {
            this.chatApi.dashboard.showLowBandwidthMessage = false;
        }
    }

    _getLocation(href) {
        const match = href.match(/^(https?:)\/\/(([^:\/?#]*)(?::([0-9]+))?)(\/[^?#]*)(\?[^#]*|)(#.*|)$/);

        return (
            match && {
                protocol: match[1],
                host: match[2],
                hostname: match[3],
                port: match[4],
                pathname: match[5],
                search: match[6],
                hash: match[7]
            }
        );
    }

    /**
     * Takes a flat list of urls that is provided by the backend, and parses it
     * into a tree, that can be displayed in the tree directive and also that
     * facilitates browsing the library
     *
     * @param rootName - String, name of root node
     * @param resources - list of Resources
     */

    /*
     * Takes the pathname part of a parsed url and converts it
     * to an array of directory names, suitable for the library
     *
     * @param pathname - String, path of the url (e.g. '/techsee.me/api/images/blob1.png')
     *
     * @return String[] - the individual components of the path, in an Array
     */
    _splitPath(pathname, depth) {
        return (
            pathname
                // remove leading slash and filename from path
                .slice(1, pathname.lastIndexOf('/'))
                // separate path to components
                .split('/')
                // remove topLevel directory
                .slice(depth)
                // fix encoded characters the url may contain
                .map((component) => {
                    // decodeURIComponent can throw a URIError
                    try {
                        return decodeURIComponent(component);
                    } catch (e) {
                        return component;
                    }
                })
        );
    }

    /*
     * Same as _listToTree , only creates a single directory (tree node)
     * with all the files under it
     *
     * @param rootName - String, name of root node
     * @param resources - list of Resources
     */
    _createNodeList(rootName, resources) {
        const root = {
            title: rootName,
            parents: [],
            children: [],
            type: 'dir'
        };

        const libraryResources = filter(
            resources,
            (resource) =>
                (resource.type === this.resourceTypes.image || resource.type === this.resourceTypes.pdf) &&
                resource.storageType !== STORAGE_TYPES.ext
        );

        forEach(libraryResources, (resource) => {
            const type = resource.type === this.resourceTypes.image ? 'img' : 'file';

            root.children.push({
                title: resource.title,
                parents: [rootName],
                url: resource.url,
                type: type,
                resource: resource
            });
        });

        return root;
    }

    /**
     * Makes an array with the nodes that need to be open
     * when the tree widget is first rendered.
     *
     * @param tree - tree data structure
     *
     * @return Array - an array with the nodes to be expanded
     */
    _autoExpandEmptyTopLevel(tree) {
        const expanded = [];
        let currentNode = tree;

        // depending on the url, we may have some toplevel dirs that have no files
        // and only contain the next dir, so we want them to be initially open
        while (currentNode.children.length === 1 && currentNode.children[0].type === 'dir') {
            expanded.push(currentNode);
            currentNode = currentNode.children[0];
        }

        // After we open the directories of the path that hold only one subdir each,
        // we also open the first one that has files in it, for quicker access by the user
        if (currentNode.children.length > 1) {
            expanded.push(currentNode);
        }

        return expanded;
    }

    /**
     * Creates an array of the parent node objects of a single node,
     * to allow expanding them and make the child node visible
     *
     * @param tree - tree data structure
     * @param parents - string array that is used to find the parents
     *
     * @return Array - an array with the nodes to be expanded
     */
    _expandParents(tree, parents) {
        const expanded = [];
        let currentNode = tree;

        forEach(parents, (title) => {
            const nextNode = find(currentNode.children, {title: title});

            if (nextNode) {
                expanded.push(nextNode);
                currentNode = nextNode;
            }
        });

        return expanded;
    }

    @action
    async receiveMessage(message) {
        if (!this.chatApi.synced) {
            this.syncMeetingState();
        }

        if (get(message, 'data.extra.eveAnalysis') && this.enableSelfServiceInLeftBar) {
            return;
        }

        const isNewClientMessage = message.sender === UserType.client && message.isNew,
            isNewDashboardMessage = message.sender === UserType.dashboard && message.isNew;

        if (isNewClientMessage) {
            this.eventLog.receivedMessage(assign({side: PlatformType.dashboard}, message.data));
        }

        if (message.data.type === 'image') {
            const newImg = {
                url: message.data.message,
                tags: message.data.meta && message.data.meta.tags,
                storageIndex: message.storageIndex,
                extra: message.data.extra,
                sharedBy: message.data.meta && message.data.meta.sharedBy
            };

            if (!message.data.private) {
                newImg.index = this.messagesService.imageCounter;
                newImg.resourceIndex = this.messagesService.videoCounter + this.messagesService.imageCounter;
            }

            const imageAsBase64 = await this.tsSharingService.imageAsBase64(newImg.url);
            const imageObj = this._snapshotToImg(imageAsBase64);

            if (this._copilotService) {
                this._copilotService.imageCaptured(newImg.url, imageAsBase64, message.sender);
            }

            if (isNewClientMessage) {
                this.sendImageViaPostMessage(imageAsBase64, this._getResourceName(imageObj.img.toString()));
            }

            if (this.autoDataCollection.enabled && isNewClientMessage) {
                await this.tsSharingService.uploadAutoCollectedImage(imageObj.img);
            }

            if (!this.isToggleEnabled_SessionToolbar()) {
                this.selectTool('arrow', true);
            }

            if (isNewDashboardMessage || isNewClientMessage) {
                this._addToScreenShots(newImg);
            } else if (
                (this.offlineRoom || this.observe) &&
                !find(this.dashboardState.screenshots, (img) => newImg.storageIndex === img.storageIndex)
            ) {
                this._addToScreenShots(newImg);
            }

            // Update RightBarState
            runInAction(() => {
                this.dashboardState.rightBarState.imageSectionOpen = true;
                this.dashboardState.returnToOneClickGuidance = false;
            });
            this.scrollToImagesTop();

            const shouldShowOnCanvas =
                this.snappedImageAppearOnCanvas &&
                (isNewDashboardMessage ||
                    (!this.dashboardState?.currentResource?.url && isNewClientMessage) ||
                    (this.offlineRoom && this.clientDisconnected));

            if (shouldShowOnCanvas) {
                this.setResource(newImg, !isNewClientMessage);
                this.selectTool('arrow', true);
            }

            if (this.isIE11) {
                this._ieRedrawRightSidebar();
            }

            if (isNewClientMessage) {
                this.chatApi.imageReceived(message);
            }
        } else if (message.data.type === 'video') {
            const newVideo = {
                isVideo: true,
                url: message.data.extra,
                tags: message.data.meta && message.data.meta.tags,
                video: message.data.message,
                storageIndex: message.storageIndex,
                sharedBy: message.data.meta && message.data.meta.sharedBy
            };

            if (!message.data.private) {
                newVideo.index = this.messagesService.videoCounter;
                newVideo.resourceIndex = this.messagesService.videoCounter + this.messagesService.imageCounter;
            }

            this.selectTool('arrow', true);
            this.videos.push(newVideo);
            // Update RightBarState
            runInAction(() => {
                this.dashboardState.rightBarState.videoSectionOpen = true;
            });
            this.scrollToVideosTop();

            if (isNewDashboardMessage || (!this.dashboardState?.currentResource?.url && isNewClientMessage)) {
                this.setResource(newVideo, !isNewClientMessage);
            }

            if (this.isIE11) {
                this._ieRedrawRightSidebar();
            }

            if (isNewClientMessage) {
                this.chatApi.videoReceived(message);
            }
        } else if (message.data.type === 'text' && message.sender === UserType.client && message.isNew) {
            this.msgSectionOpen = true;
            this.openRightBar();
        }

        // we store the index on the image, since the dashboard displays
        // filtered views of images-only, text-only but it needs to know
        // the real number in order to communicate effectively with the
        // customer. We also store anything else the view is going to need
        message.data.index = this.rightBarController.getMessageCountByType(message.data.type);
        message.data.sender = message.sender;
        message.data.isNew = message.isNew;
        message.data.storageIndex = message.storageIndex;

        this.rightBarController.pushMessage(message.data);

        if (this.showWizard) {
            this.finishWizard();
        }
    }

    saveImage(message) {
        const newImg = {
            url: message.data.message,
            tags: message.data.meta && message.data.meta.tags,
            storageIndex: message.storageIndex
        };

        this._addToScreenShots(newImg);

        if (this.snappedImageAppearOnCanvas && !this.dashboardState?.currentResource?.isVideo) {
            this.setResource(newImg, true);
            this.scrollToImagesTop();
        }

        // Update RightBarState
        runInAction(() => {
            this.dashboardState.rightBarState.imageSectionOpen = true;
        });

        if (this.isIE11) {
            this._ieRedrawRightSidebar();
        }
    }

    setVideoMode(mode) {
        this._syncLabelMode(true);

        setTimeout(() => this._syncLabelMode(false), 2000);

        runInAction(() => {
            this.videoModeState.videoState.mode = mode;
        });

        if (mode !== VIDEO_MODES.SCANNING) {
            this.tsScsan.removeAllListeners('areaSelected');
            this.tsScanArea.removeAllListeners('areaSelected');
        }

        if (mode === VIDEO_MODES.CURSOR_SHARING) {
            this.eventLog.mouseShareActivated();
        }
    }

    selectedScanMode() {
        this._syncLabelMode(false);
        this.scan(this.textScanner);
    }

    @action
    _syncLabelMode(value) {
        this.showModeLabel = value;
        this.dashboardState.imageEditorState.labelMode = value;
    }

    setImageMode(mode) {
        runInAction(() => {
            this.dashboardState.imageMode = mode;
        });

        const {ANALYZING, SCANNING} = this.IMAGE_MODES;

        if (mode !== SCANNING && this.dashboardState.isCanvas) {
            this.tsScsan.removeAllListeners('areaSelected');
            this.tsScanArea.removeAllListeners('areaSelected');
        }

        if (mode === ANALYZING || mode === SCANNING) {
            this._syncLabelMode(true);

            if (!this.dashboardState.isToggleEnabled_ScanCaptureDesign) {
                this.annotateService.setTool('select');
            } else {
                this.annotateService.clearObjects();
                this.annotateService.setTool(null);
            }
        } else if (!mode) {
            if (!this.observe) {
                this.annotateService.setTool(this.activeTool);
            }
        }
    }

    @action
    uploadLocalImage(img) {
        this.busy.busy();

        // Store the previous resource to restore if upload fails
        const oldResource = this.dashboardState?.currentResource;

        // Don't set resource with blob - wait for S3 URL to avoid canvas blinking
        // The RightBar will show the blob immediately, but canvas won't update until S3 URL is ready
        // Ensure image section is open and synced
        runInAction(() => {
            this.dashboardState.rightBarState.imageSectionOpen = true;
        });
        this.dashboardState.canvasReadOnly = true;
        try {
            this.setResource({url: img});
            this._addToScreenShots({url: img});
        } catch (error) {
            if (oldResource) {
                this.setResource(oldResource);
            }
            this._removeLastScreenShot();
            runInAction(() => {
                this.dashboardState.canvasReadOnly = false;
            });
            this._handleImageUploadFail();
            this.busy.free();
            return;
        }

        this.eventLog.uploadingLocalImage();

        this.tsSharingService.uploadRoomImage(
            img,
            {isTemp: true},
            (url) => {
                // replace the blob with the persistent image
                this.setResource({url});
                this._removeLastScreenShot();
                this._addToScreenShots({url});

                runInAction(() => {
                    this.dashboardState.canvasReadOnly = false;
                });

                if (this.isIE11) {
                    this._ieRedrawRightSidebar();
                }
                this.busy.free();
            },
            (err) => {
                if (oldResource) {
                    this.setResource(oldResource);
                }
                this._removeLastScreenShot();

                runInAction(() => {
                    this.dashboardState.canvasReadOnly = false;
                });

                const maxSizeError = get(err, 'data.details.fileSizeExceeded');

                maxSizeError
                    ? this.errorDialogController.show('ERROR_DIALOG.VIEW.IMAGE_TOO_LARGE')
                    : this._handleImageUploadFail();

                this.busy.free();
            }
        );
    }

    failedLocalLoad(err) {
        if (err && err.fileTypeError) {
            this.errorDialogController.show('ERROR_DIALOG.VIEW.SELECT_CORRECT_FILETYPE');
        }
    }

    setWifiScanDataForWifiAnalyzer = (data) => {
        this.wifiAnalyzerController.setResults(data);
        this.wifiAnalyzerController.show();
    };

    setResource(resource, keepFocus) {
        console.trace();
        this.prevResource = cloneDeep(this.dashboardState?.currentResource);

        const isVideo = !!resource.isVideo;
        this.videoControlService.isActive = isVideo;
        runInAction(() => {
            this.dashboardState.currentResource = resource;
            this.videoModeState.isActive = isVideo;
        });

        runInAction(() => {
            this.dashboardState.returnToOneClickGuidance = false;
        });

        if (!isVideo) {
            // For image resources, always set focus to false and isActive to false
            // This ensures the image widget can display when images are selected/taken
            runInAction(() => {
                this.videoModeState.videoState.mode = VIDEO_MODES.CURSOR_SHARING;
                this.dashboardState.imageMode = null;
                console.log('videoFocus: false');
                this.videoModeState.videoState.focus = false;
            });
            // Also ensure videoControlService.isActive is false for images
            this.videoControlService.isActive = false;
            runInAction(() => {
                this.videoModeState.isActive = false;
            });
        } else if (!keepFocus) {
            // For video resources, only unfocus if keepFocus is false
            runInAction(() => {
                this.videoModeState.videoState.mode = VIDEO_MODES.CURSOR_SHARING;
                this.dashboardState.imageMode = null;
                console.log('videoFocus: false');
                this.videoModeState.videoState.focus = false;
            });
        }

        if (this.showWizard) {
            this.finishWizard();
        }

        setTimeout(() => this.selectTool('arrow', true), 0);
    }

    resetResource() {
        runInAction(() => {
            this.dashboardState.currentResource = this.prevResource;
        });
    }

    selectClickedResource(resource, room, updated) {
        let resourceToUpdate = {...resource};

        runInAction(() => {
            this.dashboardState.hideWidgets = false;
        });

        if (this.wifiAnalyzerScanController) {
            runInAction(() => {
                this.dashboardState.isSquareFloatingVideo = false;
                this.dashboardState.hideWifiScan = true;
            });
            this.wifiAnalyzerScanController.hide();
        }

        if (this.dashboardState.imageMode === IMAGE_MODES.SCANNING) {
            this._syncLabelMode(false);
        }

        if (get(resourceToUpdate, 'security.enabled') && !updated) {
            const isVideo = resourceToUpdate.type === this.resourceTypes.video;

            const resourceType = isVideo ? 'VIDEO' : 'IMAGE';
            const historyApiService = getRootStore().historyApiService;

            return historyApiService
                .resignResource(resourceToUpdate._id, resourceType)
                .then(() => historyApiService.getResourceById(resourceToUpdate._id, resourceType))
                .then((resp) => {
                    resourceToUpdate.security = resp.security;

                    if (isVideo) {
                        resourceToUpdate.video = resp.url;
                    } else {
                        resourceToUpdate.url = resp.url;
                    }

                    if (resp.tags?.length) {
                        resourceToUpdate.tags = (resp.tags || []).map((t) => (typeof t === 'string' ? {text: t} : t));
                    }

                    this.selectClickedResource(resourceToUpdate, room, true);
                });
        }

        this.selectedLibraryNode = {};
        this.setResource(resourceToUpdate);
        this.rightBarController.ensureImageSectionOpenForResource(resourceToUpdate);

        this.selectTool('arrow', true);

        if (this.dashboardState.offlineMode) {
            this._setPreloadedResource(resourceToUpdate, room);
        }
    }

    isActiveResource(resource) {
        return resource && this.dashboardState?.currentResource?.url === resource.url;
    }

    _streamActionOnce(eventSource, shouldScan) {
        return new Promise((resolve) => {
            if (!this.videoModeState.videoState.enabled) {
                return resolve();
            }

            if (!this.videoModeState.videoState.focus) {
                runInAction(() => {
                    this.videoModeState.videoState.focus = true;
                });

                return resolve();
            }

            if (this.isPaused) {
                return resolve();
            }

            if (this.observe) {
                return resolve();
            }

            // TODO This is a hack since using a jpeg on IE11+Opetok caused an error. This should be fixed and then
            // remove this override
            const options = {format: 'image/jpeg'};

            if (this.dashboardState.isDesktopSharingSession) {
                options.quality = 1;
            }
            trace.info('Getting snapshot for USER_VIDEO_STREAM');
            this.dashboardMediaService
                .getSnapshotFromKnownStream(KnownMediaStream.USER_VIDEO_STREAM, options)
                .then((snapshotResult) => {
                    trace.info('Snapshot ready. Length:', get(snapshotResult, 'base64img.length'));
                    // Update RightBarState
                    runInAction(() => {
                        this.dashboardState.rightBarState.imageSectionOpen = true;
                    });

                    if (this._copilotService) {
                        this._copilotService.imageCaptured(
                            snapshotResult.objectUrl,
                            snapshotResult.base64img,
                            UserType.dashboard,
                            true
                        );
                    }

                    const handleSnapshotPromise = this._handleSnapshot(snapshotResult.base64img).then(
                        (snapshotData) => {
                            this.chatApi.imageSnapped();

                            if (this.snappedImageAppearOnCanvas && !snapshotData.uploadRoomImageFailed) {
                                URL.revokeObjectURL(snapshotData.objectUrl);
                                snapshotResult.objectUrl = snapshotData.imgData;
                                trace.info('Snapshot handled. length:', get(snapshotResult, 'imgData.length'));

                                this.selectClickedResource({url: snapshotResult.objectUrl});
                            }

                            if ((this.embeddedDashboard || this.miniDashboard) && shouldScan) {
                                this.snapAndScan(snapshotResult.objectUrl);
                            }

                            if (eventSource === this.CLASSIFY_EVENT_SOURCES.VIDEO_CLICKED && !shouldScan) {
                                this.handleTriggeredAgentImageSnapped(snapshotResult.base64img);
                            }

                            this.sendImageViaPostMessage(
                                snapshotResult.base64img,
                                this._getResourceName(snapshotResult.objectUrl.toString())
                            );

                            resolve(snapshotData);
                        }
                    );

                    return handleSnapshotPromise.finally(() => {
                        this.scrollToImagesTop();
                        this.selectTool('arrow', true);
                        if (this.isIE11) {
                            this._ieRedrawRightSidebar();
                        }
                    });
                })
                .catch((err) => {
                    trace.warn('Error getting snapshot for USER_VIDEO_STREAM', err);
                    this.eventLog.agentScreenshotFailed(err);
                    this.errorDialogController.show('ERROR_DIALOG.VIEW.SCREENSHOT_FAILED');

                    return resolve({err: 'Error while getting snapshot'});
                });
        });
    }

    triggerLocationPopover() {
        runInAction(() => {
            this.dashboardState.showLocationPopover = !this.dashboardState.showLocationPopover;
        });
    }

    restoreFromFocusLoss() {
        runInAction(() => {
            this.videoModeState.videoState.mode = VIDEO_MODES.CURSOR_SHARING;
            this.dashboardState.imageMode = null;
        });
    }

    _handleImageUploadFail() {
        this.handleImageUploadFail();
        this.handleDashboardTitleAction();
    }

    _handleSnapshot(snapshot) {
        return new Promise((resolve, reject) => {
            try {
                const snappedImg = this._snapshotToImg(snapshot).img;

                if (!this.saveSnapshots) {
                    this._addToScreenShots({url: snappedImg, dataUrl: snapshot});

                    return resolve({imgData: snapshot, imgBlob: snappedImg});
                }

                this.busy.busy();
                this.eventLog.savingSnapshot();

                return this.tsSharingService.uploadRoomImage(
                    snappedImg,
                    {isTemp: false},
                    (url) => {
                        this.busy.free();
                        this.chatApi.saveImage(url);
                        resolve({imgData: url});
                    },
                    () => {
                        this.busy.free();
                        this._handleImageUploadFail();

                        resolve({imgData: snapshot, uploadRoomImageFailed: true});
                    }
                );
            } catch (e) {
                reject(e);
            }
        });
    }

    _snapshotToImg(dataUrl) {
        const URL = window.URL,
            blob = this.annotateService.dataUrlToBlob(dataUrl);

        return {
            size: blob.size,
            img: URL.createObjectURL(blob)
        };
    }

    isAndroid() {
        return this.dashboardState.isAndroidOrIphone === IOS_DEVICES.ANDROID;
    }

    displayCobrowsingIframe() {
        // if (this.isCoBrowsingModeSurfly) {
        return get(this.chatApi.dashboard, 'coBrowsingSettings.followerLink') && !this.clientDisconnected;
        // }
        //
        // return !this.clientDisconnected;
    }

    inCobrowsingMode() {
        return this.mode === MeetingMode.coBrowsing;
    }

    selectedImageMode(meetingMode) {
        const imgName = meetingMode.toLowerCase();

        if (!this.tsInterfaceHelper.useNewInterface) {
            return `icon-customer-mode-${imgName}.png`;
        }

        return this.mode === meetingMode ? `icon-customer-mode-${imgName}.png` : `unselected-icon-mode-${imgName}.png`;
    }

    showModeButton(meetingMode) {
        if (!this.chatApi.connected || !this.chatApi.synced || !this.chatApi.client) {
            return false;
        }

        if (meetingMode === MeetingMode.images) {
            return (
                !this.isModeAvailable(MeetingMode.oneClick) &&
                !this.isModeAvailable(MeetingMode.screen) &&
                !this.isModeAvailable(MeetingMode.appSharing) &&
                !this.isModeAvailable(MeetingMode.videoApplication)
            );
        }

        return this.isModeAvailable(meetingMode);
    }

    isModeAvailable(meetingMode) {
        const availableModes = get(this.chatApi, 'client.availableModes');
        const clientMode = get(this.chatApi, 'client.mode');
        const sharingModes = [MeetingMode.screen, MeetingMode.appSharing, MeetingMode.videoApplication];

        const isSharingMode = includes(sharingModes, meetingMode);
        const isCurrentModeSharing = includes(sharingModes, clientMode);

        return availableModes && availableModes.indexOf(meetingMode) > -1 && isSharingMode === isCurrentModeSharing;
    }

    requestModeDuringInitiation(mode) {
        this.chatApi.setStatus('allowAgentToSwitchModes', false, true);

        const modeToSwitchTo = mode !== MeetingMode.oneClick || this.isModeAvailable(mode) ? mode : MeetingMode.images;

        this.requestMode(modeToSwitchTo);
    }

    getImageSharingType() {
        const availableModes = get(this.chatApi, 'client.availableModes');
        const nextMode = includes(availableModes, MeetingMode.oneClick) ? MeetingMode.oneClick : MeetingMode.images;

        return this.requestMode(nextMode);
    }

    requestMode(mode) {
        this._checkModesAvailability();

        if (!this.dashboardState.modesEnabled || this.mode === mode) {
            return;
        }

        if (this.dashboardState.imageMode === IMAGE_MODES.SCANNING) {
            this.showModeLabel = false;

            this.setImageMode(null);
        }

        // Don't clear currentResource here - it prevents images from displaying in edit mode
        // The guidance will show automatically if there are no screenshots and no currentResource

        switch (mode) {
            case MeetingMode.images:
                this.eventLog.agentSwitchedToImageUpload();
                break;
            case MeetingMode.video:
                this.eventLog.agentSwitchedToVideoStream();
                break;
            case MeetingMode.oneClick:
                this.eventLog.agentSwitchedToPhoto();
                break;
            case MeetingMode.screen:
            case MeetingMode.appSharing:
            case MeetingMode.videoApplication:
                this.eventLog.agentSwitchedToScreenShare();
                break;
            case MeetingMode.coBrowsing:
                this.eventLog.agentSwitchedToCoBrowsing();
                break;
            default:
        }

        this.busy.busy();

        if (this._clientVisibleListener) {
            this.chatApi.removeListener('clientVisible', this._clientVisibleListener);

            this._clientVisibleListener = null;
        }

        this.hideWifiScan = true;

        runInAction(() => {
            this.videoModeState.videoState.mode = VIDEO_MODES.CURSOR_SHARING;
            this.dashboardState.imageMode = null;
            // Set focus to false when switching to photo/one-click mode to allow image widget to show
            const shouldUnfocusVideo = mode === MeetingMode.images || mode === MeetingMode.oneClick;
            console.log('videoFocus: ', !shouldUnfocusVideo);
            this.videoModeState.videoState.focus = shouldUnfocusVideo ? false : true;

            // Set isActive to false when switching to photo/one-click mode to allow image editor to display
            if (shouldUnfocusVideo) {
                this.videoControlService.isActive = false;
                this.videoModeState.isActive = false;
            }
            this.dashboardState.isSquareFloatingVideo = false;
        });
        this?.wifiAnalyzerScanController.hide();

        if (this.chatApi.client.visible) {
            this.chatApi.requestSwitchMode(UserInteractionTriggerAction.buttonClickDuringSession, mode);
        } else {
            this._clientVisibleListener = () => {
                this.chatApi.requestSwitchMode(UserInteractionTriggerAction.buttonClickDuringSession, mode);
            };

            this.chatApi.once('clientVisible', this._clientVisibleListener);
        }
    }

    displayMeetingModes() {
        return (
            get(this.chatApi, 'dashboard.allowAgentToSwitchModes') &&
            !this.observe &&
            !this.dashboardState.offlineMode &&
            !this.showWizard &&
            !this.chatApi.isReviewingTOS
        );
    }

    setupColors() {
        this.colors = ANNOTATION_COLORS;
    }

    selectTool(tool, ignoreUnselect) {
        if (this.observe) return;
        if (this.activeTool === tool && !ignoreUnselect) {
            // deselect
            this.activeTool = 'hand';
        } else {
            this.activeTool = tool;
        }
        this.annotateService.setTool(this.activeTool);
        runInAction(() => {
            this.dashboardState.miniDashboardActiveTool = this.activeTool;
        });
    }

    isActiveTool(tool) {
        const activeTool = this.dashboardState.miniDashboardActiveTool;
        if (tool === 'hand') {
            return activeTool === 'hand' || activeTool === 'drag';
        }
        return activeTool === tool;
    }

    setColor(color) {
        this.annotateService.setColor(color);
        runInAction(() => {
            this.dashboardState.miniDashboardActiveColor = color;
        });
    }

    hasAnnotations() {
        return this.dashboardState.isAnnotated;
    }

    undo() {
        this.annotateService.undo();
    }

    cancel() {
        this.annotateService.clearObjects();
    }

    _scannerTypeSelected(translateName, option) {
        return find(SCANNERS, (type) => type.name === translateName)[option];
    }

    displayNewScanMode() {
        return (
            this.dashboardState.showScanners &&
            get(this.tsInterfaceHelper, 'useNewInterface') &&
            get(this.chatApi, 'client.mode') === MeetingMode.video
        );
    }

    displayButtonsInVideo() {
        return (
            !this.isPaused &&
            !this.videoModeState.videoState.videoPausedByDashboard &&
            !this.observe &&
            this.videoModeState.videoState.focus &&
            this.videoModeState.videoState.enabled &&
            (this.videoModeState.videoState.mode === VIDEO_MODES.SNAP ||
                this.videoModeState.videoState.mode === VIDEO_MODES.CURSOR_SHARING)
        );
    }

    _handleScannerFields(scanner, result) {
        const typeResult = this._scannerTypeSelected(scanner.type, 'reportName');
        const type = this._scannerTypeSelected(scanner.type, 'type');

        if (!result || isEmpty(result[type])) {
            this.roomService.setReportedField(this.roomData._id, {
                key: `${typeResult}.failed`,
                value: 1,
                type: 'inc'
            });
        } else if (!isEmpty(result[type])) {
            this.roomService.setReportedField(this.roomData._id, {
                key: `${typeResult}.success`,
                value: 1,
                type: 'inc'
            });
        }
    }

    setToolbarScanStates(activate, deactivate) {
        this.floatingToolbarScanHandlers = {activate, deactivate};
    }

    setFlashlightStates(activate, deactivate) {
        this.floatingToolbarFlashlightHandlers = {activate, deactivate};
    }

    _setImageAsScanned(storageIndex) {
        map(this.dashboardState.screenshots, (screenshot) => {
            if (screenshot.storageIndex === storageIndex) {
                screenshot.scanned = true;
            }
        });

        this._setScreenshots(this.dashboardState.screenshots);
    }

    _getResourceName(resourceUrl) {
        const splitImageUrl = resourceUrl.split('?');
        const getFileName = splitImageUrl[0] && splitImageUrl[0].split('/');

        return getFileName[getFileName.length - 1];
    }

    openScanResultModal(type, result, searchTags) {
        return this.scanResultModalController.show(type, result, this.dir, searchTags);
    }

    snapAndScan(url) {
        const imageUrl = url || this.dashboardState?.currentResource?.url;
        let text = '';
        let scanResult = null;

        if (this.videoModeState.videoState.focus && !url) {
            return this.streamAction(this.CLASSIFY_EVENT_SOURCES.SCAN, true);
        }

        return this.tsSharingService
            .imageAsBase64(imageUrl)
            .then((base64Img) =>
                this.tsSharingService.imageAsBase64(imageUrl, {width: 48, height: 48}).then((thumbnail) =>
                    this.textScanner
                        .scan(base64Img, SCANNER_SRC_TYPES.EDITOR, this.embeddedDashboard, imageUrl, thumbnail)
                        .then((result) => {
                            if (result.text === null) {
                                return Promise.reject();
                            }
                            text = result.text;
                            scanResult = result;
                        })
                        .finally(() => {
                            const imageName = this._getResourceName(
                                this.dashboardState?.currentResource?.url.toString()
                            );

                            const msg = {
                                techseeSessionId: this.roomData._id,
                                text: text.raw,
                                fileName: imageName
                            };
                            const dashboardScope = this;

                            dashboardScope.jsApiService.OCRSent(msg);
                            this._setImageAsScanned(this.dashboardState?.currentResource?.storageIndex);

                            if (scanResult) {
                                this._handleScannerFields(this.textScanner, scanResult);
                            }
                        })
                )
            )
            .catch(() => {
                if (this.miniDashboard) {
                    runInAction(() => {
                        this.dashboardState.lastEvent = {text: this.miniDashboardScanError};
                    });
                } else {
                    this.openScanResultModal('text', null, false);
                }
            });
    }

    scan(scanner = this.textScanner) {
        const isVideo =
                this.videoModeState.videoState.focus && this.videoModeState.videoState.enabled && this.videoSubscriber,
            takenFrom = isVideo ? SCANNER_SRC_TYPES.VIDEO : SCANNER_SRC_TYPES.EDITOR;

        if (this.floatingToolbarScanHandlers) {
            this.dashboardState.isScanMode
                ? this.floatingToolbarScanHandlers.deactivate()
                : this.floatingToolbarScanHandlers.activate();
        }

        const scanNow = (options) => {
            let nextOptions = options;

            Promise.resolve()
                .then(() => {
                    if (isVideo) {
                        let width = this.videoSubscriber.renderWidth;
                        let height = this.videoSubscriber.renderHeight;
                        const {videoWidth, videoHeight} = this.videoSubscriber;

                        // Correct the dimensions orientation
                        if (width > height && videoWidth < videoHeight) {
                            [width, height] = [height, width];
                        }

                        // Check if there is a resolution decrease or if IE
                        //TODO - Alex: I really don't understand what should happen here....and how it is decided
                        //almost always render width and video will be different, so we ask for image from mobile?
                        const isRegularSnapShot = !this.isIE11; // && videoWidth === width && videoHeight === height;

                        if (
                            this.dashboardState.isDesktopSharingSession ||
                            this.roomData.clientType !== 'MOBILE_WEB' ||
                            isRegularSnapShot
                        ) {
                            return this.dashboardMediaService.getSnapshotFromKnownStream(
                                KnownMediaStream.USER_VIDEO_STREAM,
                                options
                            );
                        }

                        if (nextOptions) {
                            const widthRatio = width / videoWidth;
                            const heightRatio = height / videoHeight;
                            const {format, quality} = nextOptions;
                            let {x, y, w, h} = nextOptions;

                            x = x && x * widthRatio;
                            y = y && y * heightRatio;
                            w = w && w * widthRatio;
                            h = h && h * heightRatio;

                            nextOptions = {format, quality, x, y, w, h};
                        }

                        this.chatApi.requestAction('takeSnapshot', nextOptions);

                        return new Promise((resolve, reject) => {
                            this.chatApi.once('handleSnapshotAction', resolve);
                            this.chatApi.once('handleSnapshotFailureAction', reject);
                        });
                    }

                    if (nextOptions) {
                        return this.annotateService.getCleanDataURL(nextOptions);
                    }

                    return this.dashboardState?.currentResource?.url;
                })
                .then((image) =>
                    scanner
                        .scan(image.base64img || image, takenFrom)
                        .then((result) => {
                            const newHeaderClass = 'new-header';

                            this.openScanResultModal(scanner.type, result, this.searchScannedTags).then((res) => {
                                if (res && res.search) {
                                    this.submitSearchTagForm(res.searchTerm);
                                }
                            });

                            return result;
                        })
                        .catch(() => {
                            this.openScanResultModal(scanner.type, null, false).catch(() => false);
                        })
                )
                .then((result) => {
                    this._handleScannerFields(scanner, result);
                })
                .finally(() => {
                    this._syncLabelMode(false);

                    if (isVideo) {
                        runInAction(() => {
                            this.videoModeState.videoState.mode = VIDEO_MODES.CURSOR_SHARING;
                        });
                        this.tsScsan.removeAllListeners('areaSelected');
                        this.tsScanArea.removeAllListeners('areaSelected');
                    } else if (this.dashboardState.isToggleEnabled_ScanCaptureDesign) {
                        this.cancelScanning();
                    }
                });
        };

        if (scanner.settings.select) {
            if (isVideo) {
                if (this.videoModeState.videoState.mode === VIDEO_MODES.SCANNING) {
                    runInAction(() => {
                        this.videoModeState.videoState.mode = VIDEO_MODES.CURSOR_SHARING;
                    });
                    this._syncLabelMode(false);
                    this.tsScsan.removeAllListeners('areaSelected');
                    this.tsScanArea.removeAllListeners('areaSelected');

                    return;
                }

                this.setVideoMode(VIDEO_MODES.SCANNING);
            } else {
                if (this.dashboardState.imageMode === IMAGE_MODES.SCANNING) {
                    this._syncLabelMode(false);
                    this.tsScanArea.destroy();
                    this.tsScanArea.removeAllListeners('areaSelected');

                    return this.setImageMode(null);
                }

                this.setImageMode(IMAGE_MODES.SCANNING);
            }

            this.tsScsan.removeAllListeners('areaSelected');
            this.tsScanArea.removeAllListeners('areaSelected');

            const onAreaSelected = ({rect}) => {
                const {x, y, width: w, height: h} = rect,
                    options = {quality: 1, x, y, w, h};

                scanNow(options);

                if (this.dashboardState.isToggleEnabled_ScanCaptureDesign) {
                    setTimeout(() => this.cancelScanning());
                }
            };

            if (this.dashboardState.isToggleEnabled_ScanCaptureDesign) {
                // Use annotateService canvas for both video and image modes
                const upperCanvas = this.annotateService?.canvas?.upperCanvasEl;
                if (upperCanvas) {
                    this.tsScanArea.init(upperCanvas);
                }

                this.tsScanArea.on('areaSelected', onAreaSelected);
            } else {
                this.tsScsan.on('areaSelected', onAreaSelected);
            }
        } else {
            scanNow();
        }
    }

    cancelScanning() {
        const isVideo = this.videoModeState.videoState.focus && this.videoModeState.videoState.enabled;

        if (isVideo) {
            runInAction(() => {
                this.videoModeState.videoState.mode = VIDEO_MODES.CURSOR_SHARING;
            });
            this.tsScsan.removeAllListeners('areaSelected');
            this.tsScanArea.removeAllListeners('areaSelected');
        } else {
            this.setImageMode(null);
        }

        if (this.floatingToolbarScanHandlers) {
            this.floatingToolbarScanHandlers.deactivate();
        }

        this.tsScanArea.destroy();
    }

    _setupLibraryTreeEventListeners() {
        this.rightBarController.setupLibraryEventListeners(
            (tool, ignoreUnselect) => this.selectTool(tool, ignoreUnselect),
            (resource, keepFocus) => this.setResource({...resource, _fromLibrary: true}, keepFocus),
            (resource) => {
                this._setPreloadedResource(resource);
            },
            (message) => {
                this.msgText = message;
            },
            (isOpen) => {
                this.msgSectionOpen = isOpen;
            },
            (hide) => {
                runInAction(() => {
                    this.dashboardState.hideWidgets = hide;
                });
            },
            (hide) => {
                runInAction(() => {
                    this.dashboardState.hideWifiScan = hide;
                });
            },
            () => this.hideWifiAnalyzerScan()
        );
    }

    hideWifiAnalyzerScan() {
        if (
            this.wifiAnalyzerScanController &&
            typeof this.wifiAnalyzerScanController.hideWifiAnalyzerScanController === 'function'
        ) {
            this.wifiAnalyzerScanController.hideWifiAnalyzerScanController();
        }
    }

    _setupPredefinedLibraryTreeEventListeners() {
        this.rightBarController.setupPredefinedEventListeners((message) => {
            this.rightBarController.openTextDialog(message);
        });
    }

    openLibraryDialog(selectedNode) {
        const selection = selectedNode
            ? {type: selectedNode.type, title: selectedNode.title, url: selectedNode.url}
            : {};

        this.eventLog.openingLibraryDialog({selectedNode: selection});

        // Convert observable tree to plain object for AngularJS dialog
        const plainTree = this._convertObservableTreeToPlain(this.rightBarController.getLibraryTreeData());
        const plainSelectedNode = selectedNode ? this._convertObservableTreeToPlain(selectedNode) : null;

        this._openImageDialog(plainTree, plainSelectedNode, this.libraryDialogRoot, true);
    }

    _convertObservableTreeToPlain(node) {
        if (!node) return null;

        return {
            parents: Array.isArray(node.parents) ? [...node.parents] : node.parents?.slice ? node.parents.slice() : [],
            children: node.children?.map ? node.children.map((child) => this._convertObservableTreeToPlain(child)) : [],
            state: node.state ? {...node.state} : {expanded: false, selected: false, disabled: false},
            data: node.data ? {...node.data} : {}
        };
    }

    _loadCustomerHistory(refresh) {
        if (refresh || !this.customerHistoryLoaded) {
            this.customerHistoryLoaded = true;
            if (this.currentUser.accountId) {
                const now = tsDate.utc();
                const customerHistory = this.dashboardState.rightBarState.customerHistory;
                const historyRecords = get(customerHistory, 'records') || [];
                const expiredImages = some(historyRecords, (record) =>
                    some(
                        record.images,
                        (resource) => get(resource, 'security.enabled') && now.isAfter(resource.security.expires)
                    )
                );

                const expiredVideos = some(historyRecords, (record) =>
                    some(
                        record.videos,
                        (resource) => get(resource, 'security.enabled') && now.isAfter(resource.security.expires)
                    )
                );

                // we don't need to reload the history if was loaded and there are no images/videos to resign
                if (refresh && customerHistory && !expiredImages && !expiredVideos) {
                    return new Promise.when(customerHistory);
                }

                const customerId = this.roomData.customerId ?? 'none';
                const customerNumber = this.roomData.customerNumber ?? 'none';

                // Skip API call if both customer identifiers are missing
                if (customerId === 'none' && customerNumber === 'none') {
                    return Promise.resolve({});
                }

                const excludeRoomId = !this.dashboardState.offlineMode && !this.observe && this.roomData._id.toString();

                return getRootStore()
                    .dbHistoryService.byCustomerIdOrNumber({
                        params: {
                            customerId: customerId,
                            customerNumber: customerNumber,
                            accountId: this.currentUser.accountId,
                            excludeRoomId: excludeRoomId
                        }
                    })
                    .then((result) => {
                        this.loadInteractionSummary();
                        return result.data;
                    })
                    .catch(() => {
                        this.customerHistoryLoaded = false;

                        return {};
                    });
            }
        }

        return Promise.resolve({});
    }

    loadInteractionSummary = async () => {
        this.openWidgetOnStartUp = !!get(this.roomData, 'pendingRoomId');
        this.loadWidgetDataOnStartUp =
            !!get(this.roomData, 'pendingRoomId') &&
            ((get(this.accountData, 'protectedSettings.interactionSummary.enabled') &&
                get(this.roomData, 'sessionSource') === SESSION_SOURCE.AI) ||
                (get(this.accountData, 'protectedSettings.interactionSummary.enableVJInteractionSummarySearch') &&
                    get(this.roomData, 'sessionSource') === SESSION_SOURCE.VJ));

        if (this.loadWidgetDataOnStartUp) {
            runInAction(() => {
                this.dashboardState.isInteractionSummaryReady = true;
            });
        }

        if (
            get(this.accountData, 'protectedSettings.interactionSummary.enabled') ||
            get(this.accountData, 'protectedSettings.interactionSummary.enableVJInteractionSummarySearch')
        ) {
            const previews = await this.getInteractionSummaryPreviews(
                get(this.accountData, 'protectedSettings.interactionSummary.enabled'),
                get(this.accountData, 'protectedSettings.interactionSummary.enableVJInteractionSummarySearch')
            );
            runInAction(() => {
                this.dashboardState.interactionSummaryPreviews = previews;
            });

            if (this.dashboardState.interactionSummaryPreviews.length > 0) {
                runInAction(() => {
                    this.dashboardState.isInteractionSummaryReady = true;
                });
            }
        }
    };

    async updateWifiScanHistory(refresh) {
        try {
            if (this.dashboardState.scanId) {
                const res = await getRootStore().wifiAnalyzerService.getWifiAnalyzerHistory(
                    this.accountData._id,
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    this.dashboardState.scanId
                );
                if (res && res.previews && res.previews.length > 0) {
                    this._applyWifiScanResults(res.previews[0], true);
                }
            } else {
                const customerId = this.roomData.customerId;
                const ivrSessionId = this.roomData.extraInfo?.ivrSessionId;

                if (!customerId && !ivrSessionId) {
                    return;
                }

                const data = await getRootStore().wifiAnalyzerService.getWifiScanResultsForDashboard(
                    this.accountData._id,
                    {customerId, ivrSessionId}
                );

                if (data && data.previews && data.previews.length > 0) {
                    const wifiScans = data.previews.filter((scan) => scan.scanDetails?.scanType !== SCAN_TYPE.ar);
                    const visualScans = data.previews.filter((scan) => scan.scanDetails?.scanType === SCAN_TYPE.ar);

                    if (wifiScans.length > 0) {
                        await this.rightBarController.updateWifiScanHistory(
                            refresh,
                            this.accountData._id,
                            this.currentUser._id,
                            wifiScans
                        );
                        const wifiScansNewestFirst = [...wifiScans].sort(
                            (a, b) =>
                                new Date(b.updatedAt || b.createdOn).getTime() -
                                new Date(a.updatedAt || a.createdOn).getTime()
                        );
                        this._applyWifiScanResults(wifiScansNewestFirst[0]);
                    }

                    if (visualScans.length > 0) {
                        await this.rightBarController.updateVisualScanHistory(
                            refresh,
                            this.accountData._id,
                            this.currentUser._id,
                            visualScans
                        );
                    }
                }
            }
        } catch (error) {
            this.eventLog.visualScanFailed();
        }
    }

    openWifiScanHistoryPage(id) {
        // This is now handled by the controller's onClickWifiScanHistoryButton
    }

    async openCustomerHistoryDialog() {
        const history = await this._loadCustomerHistory(true);

        if (!history || history.records.length === 0) {
            return;
        }

        // Open React modal
        const result = await this.customerHistoryModalController.open(history, this.dir);

        if (!result) return;

        const {resource, room} = result;

        this.selectTool('arrow', true);
        this.setResource(resource);

        if (this.dashboardState.offlineMode && room?._id) {
            this._setPreloadedResource(resource, room);
        }
    }

    /**
     * Opens the library dialog, which can be either the account library
     *
     * @param tree - The tree that is displayed in the dialog
     * @param selectedNode - the selected Node
     * @param topLevel - Name of the top level dir of the dialog
     * @param footer - show or hide the footer of the dialog (carousel, actions)
     */

    changeZoom() {
        this.annotateService.setZoom(Number(this.zoomFactor));
        this.selectTool('hand');
    }

    // In place of Math.sign() which is not supported in IE
    numberSign(num) {
        if (num < 0) {
            return -1;
        }

        return 1;
    }

    wheelChangeZoom(event, delta) {
        this.zoomFactor = Number((Number(this.zoomFactor) + this.numberSign(delta) * 0.1).toFixed(1));

        if (this.zoomFactor < 1) {
            this.zoomFactor = 1;
        } else if (this.zoomFactor > 5) {
            this.zoomFactor = 5;
        }

        this.annotateService.setZoom(this.zoomFactor);
        this.selectTool('hand');
    }

    isColorSelected(color) {
        return this.dashboardState.miniDashboardActiveColor === color;
    }

    async startWifiVisualScan() {
        if (!this.dashboardState.isScreenMirroring) {
            const confirmed = await this.switchModeModalController.open();

            if (confirmed) {
                this.requestMode(MeetingMode.screen);
            }

            return;
        }
        if (this.dashboardState.floatingToolbarState.isStopVisualWifiScan) {
            this.eventLog.visualScanStopped();
            this.chatApi.setStatus('visualScanStatus', VisualScanStatusType.RequestStop);
        } else {
            this.eventLog.visualScanInit();
            this.chatApi.setStatus('visualScanStatus', VisualScanStatusType.Init);
        }
    }

    getActiveColorName() {
        const index = findIndex(this.colors, {
            hexCode: this.dashboardState.miniDashboardActiveColor
        });

        return index >= 0 ? this.colors[index].name : 'unknown';
    }

    openRightBar = (isInputTextFocus) => {
        this._changeInputTextFocus(isInputTextFocus);

        if (this.rightBarController) {
            this.rightBarController.setExpandRightBar(true);
        } else {
            runInAction(() => {
                this.dashboardState.rightBarState.expandRightBar = true;
            });
        }
    };

    closeRightBar = (isInputTextFocus) => {
        this._changeInputTextFocus(isInputTextFocus);

        runInAction(() => {
            this.dashboardState.rightBarState.expandRightBar = false;
        });
    };

    get libSectionOpen() {
        return this.dashboardState.rightBarState.libSectionOpen;
    }

    get msgSectionOpen() {
        return this.rightBarController.msgSectionOpen;
    }

    set msgSectionOpen(value) {
        runInAction(() => {
            this.dashboardState.rightBarState.msgSectionOpen = value;
        });
    }

    _changeInputTextFocus(isInputTextFocus) {
        if (isInputTextFocus !== undefined) {
            this.isInputTextFocus = isInputTextFocus;
        }
    }

    closeRightBarIfNotFocused() {
        if (!this.isInputTextFocus) {
            this.closeRightBar();
        }
    }

    // Scrolls to top of images section
    scrollToImagesTop() {
        document.getElementById('top')?.scrollIntoView();

        this.scrollToSideBarTop();
    }

    scrollToSideBarTop() {
        document.getElementById('sd-top')?.scrollIntoView();
    }

    // Scrolls to top of chat section
    scrollToVideosTop() {
        document.getElementById('videosTop')?.scrollIntoView();

        this.scrollToSideBarTop();
    }

    goToWizardStep(step) {
        this.wizardState.step = step;
    }

    goBackToEntry() {
        this.stateHelper.navigateTo('dashboard.entry');
    }

    finishWizard() {
        this.showWizard = false;
        runInAction(() => {
            this.dashboardState.showWizard = false;
            this.dashboardState.hideWidgets = false;
        });
        this.wizardState.finished = true;
    }

    @action
    toggleMobileDrawer(toggle) {
        if (toggle === undefined) {
            this.dashboardState.drawerOpen = !this.dashboardState.drawerOpen;
        } else {
            this.dashboardState.drawerOpen = toggle;
        }
    }

    swipeMobileDrawer(event) {
        const direction =
            event.direction === Hammer.DIRECTION_LEFT
                ? 'left'
                : event.direction === Hammer.DIRECTION_RIGHT
                  ? 'right'
                  : '';

        if (!direction) {
            return;
        }

        const orientation = this.responsiveUtils.getOrientation();

        if (
            (orientation === 'portrait' && direction === 'right') ||
            (orientation === 'landscape' && direction === 'left')
        ) {
            this.toggleMobileDrawer(false);
        } else if (
            (orientation === 'portrait' && direction === 'left') ||
            (orientation === 'landscape' && direction === 'right')
        ) {
            this.toggleMobileDrawer(true);
        }
    }

    getTypeGlyphicon(type) {
        return find(RESOURCE_TYPES, {type: type.type}).icon;
    }

    openTextDialog(placeholder) {
        this.rightBarController.openTextDialog(placeholder);
    }

    checkIfTagsExist(searchTerm) {
        return !!this.searchForTags({searchTerm: searchTerm}, true);
    }

    searchForTags(form, onlyCheck) {
        if (!form.searchTerm) {
            this.emptySearchTermSubmitted = true;
            return;
        }

        this.emptySearchTermSubmitted = false;
        this._currentSearchOnlyCheck = onlyCheck;
        this._currentSearchTerm = form.searchTerm;

        // Use searchTagsController for history search
        if (this.searchHistoryTags) {
            const customerHistory = this.dashboardState.rightBarState.customerHistory;
            this.rightBarController.searchInHistory(customerHistory, form.searchTerm);
        } else {
            // If not searching history, handle library search directly
            this._handleSearchResults([]);
        }
    }

    _handleSearchResults(historyResults) {
        const tagSearchResults = {
            history: [],
            library: []
        };

        // Process history results from controller
        if (this.searchHistoryTags && historyResults && historyResults.length > 0) {
            const historyPartials = {
                length: 0,
                keys: []
            };

            forEach(historyResults, (result) => {
                if (result.roomId && result.resources && result.resources.length > 0) {
                    historyPartials.length += result.resources.length;
                    historyPartials.keys.push(result.roomId);
                    historyPartials[result.roomId] = result.resources;
                }
            });

            tagSearchResults.history = historyPartials;
        }

        // Search library using controller
        if (this.searchLibraryTags) {
            tagSearchResults.library = this.rightBarController.findTaggedResources(
                [this.library],
                this._currentSearchTerm
            );
        }

        this.tagSearchResults = tagSearchResults;

        if (this.tagSearchHasResults()) {
            if (this._currentSearchOnlyCheck) {
                return true;
            }

            if (this.searchResultsModal) {
                this.searchResultsModal.dismiss();
            }

            const searchSettings = {
                searchTerm: this._currentSearchTerm,
                searchHistoryTags: this.searchHistoryTags,
                searchLibraryTags: this.searchLibraryTags
            };

            this.searchResultsDialogController.open(searchSettings, this.tagSearchResults).then((result) => {
                if (!result) return;

                const {resource, room} = result;

                this.selectTool('arrow', true);
                this.setResource(resource);

                if (this.dashboardState.offlineMode && room._id) {
                    this._setPreloadedResource(resource, room);
                }
            });
        }
    }

    tagSearchHasResults() {
        return (
            this.tagSearchResults &&
            (this.tagSearchResults.library.length > 0 || this.tagSearchResults.history.length > 0)
        );
    }

    @action
    _restoreOfflineHistory() {
        this._loadCustomerHistory(false).then((history) => {
            if (this.rightBarController) {
                runInAction(() => {
                    this.rightBarController.setCustomerHistory(history);
                });
            } else {
                const rightBarState = this.dashboardState.rightBarState;
                runInAction(() => {
                    rightBarState.customerHistory = history ? {...history} : null;
                });
            }

            const roomHistory = find(history?.records || [], ({roomId}) => roomId && roomId._id === this.roomData._id);

            if (roomHistory) {
                runInAction(() => {
                    this.dashboardState.screenshots = roomHistory.images;
                });
                this.videos = roomHistory.videos;

                this.rightBarController.setMeetingHistory(
                    concat(
                        map(roomHistory.messages, (message) => ({
                            type: 'text',
                            message
                        })),
                        map(roomHistory.files, (message) => ({
                            type: 'text',
                            message
                        }))
                    )
                );
            }
        });
    }

    _setPreloadedResource(resource, room) {
        // FIXME this function sets the parameters, so after a page
        // refresh, the user will be getting the same selected room/resource.
        // this causes the controllers to re-run and the current
        // state is reloaded. when using signed urls the reload
        // can trigger the cached request CORS problem, so for now, the smallest
        // bug is chosen, which is that when refreshing the page in offline
        // history mode, the selected image is the one originally selected
        // in the search results page
        if (get(resource, 'security.enabled')) {
            if (!resource.isVideo) {
                runInAction(() => {
                    this.dashboardState.videoModeState.preloadedImage = {resource};
                });
            } else {
                this.preloadedVideo.resource = resource;
            }

            return;
        }

        if (room && this.roomData._id !== room._id) {
            runInAction(() => {
                this.dashboardState.currentResource = {};
                this.dashboardState.videoModeState.preloadedImage = this.preloadedVideo = {};
            });

            return this.urlUtils.setParamValues({
                offline: this.dashboardState.offlineMode,
                room: room._id,
                loadImage: resource.isVideo ? null : resource._id,
                loadVideo: resource.isVideo ? resource._id : null
            });
        }

        this.stateHelper.navigateTo(
            '.',
            {
                loadImage: resource.isVideo ? null : resource._id,
                loadVideo: resource.isVideo ? resource._id : null
            },
            {
                notify: false
            }
        );
        runInAction(() => {
            this.dashboardState.videoModeState.preloadedImage.resource = resource;
        });
    }

    _isCaptureAvailable() {
        return (
            !this.isPaused &&
            this.videoModeState.videoState.enabled &&
            this.dashboardState.displayLiveVideo &&
            !this.dashboardState.isDesktopSharingSession
        );
    }

    pauseVideo(e, value) {
        trace.info('Pause video clicked by dashboard');

        if (e) {
            e.stopPropagation();
        }

        this.cancelScanning();

        this.tsSnapshotReminderService.videoReady(!this.isPaused);
        const newState = isUndefined(value) ? !this.isPaused : value;

        if (this.isPaused === newState) {
            return;
        }

        this.chatApi.requestAction('toggleVideo', !this.isPaused);
        this.mobilePausedVideo(this.isPaused);
    }

    // bind VIDEO_MODES to the video property
    get video() {
        return this.videoModeState.videoState;
    }

    onViewReady() {
        this.mainFinishLoaded();

        if (!this.dashboardState.offlineMode || this.loadedFromHistory) {
            // make the code execute on the next cycle
            setTimeout(() => {
                const meta = this.loadedFromHistory ? {loadedFromHistory: true} : undefined;

                this.eventLog.dashboardMainViewLoaded(meta);
            }, 0);
        }
    }

    dispose() {
        // Cleanup from main handlers section
        this.tsSnapshotReminderService?.cleanup();
        this._autorunDisposer?.();
        this._enableHistoryDisposer?.();
        if (this._enableHistoryListener) {
            this.chatApi.removeListener('client:enableHistory', this._enableHistoryListener);
        }
        this.imageEditToolsController?.dispose();
        this.rightBarController?.libraryTreeController?.dispose();
        this.rightBarController?.predefinedTreeController?.dispose();
        this.rightBarController?.searchTagsController?.dispose();

        this.cleanupToolbarEventListeners();

        // Remove chatApi listeners
        this.chatApi.removeListener('log', this._clientLogListener);
        this.chatApi.removeListener('imageSave', this._imageSavedListener);
        this.chatApi.removeListener('clientConnected', this._clientConnectionListener);
        this.chatApi.removeListener('clientPhotoSelectionDialogState', this._clientPhotoSelectionDialogStateListener);
        this.chatApi.removeListener('clientVisible', this._clientVisibleListener);
        this.chatApi.removeListener('isTorchOn', this._isTorchOnListener);
        this.chatApi.removeListener('isTorchAvailable', this._isTorchAvailableListener);
        this.chatApi.removeListener('clientSpeedtestResults', this._speedtestResultsListener);
        this.chatApi.removeListener('resourcesUpdated', this._resourceUpdateListener);
        this.chatApi.removeListener('message', this._messageReceivedListener);

        // Remove annotateService listeners
        this.annotateService.removeListener('tool:deselect', this._toolDeselectListener);
        this.annotateService.removeListener('zoom:change', this._zoomChangeListener);
        this.annotateService.removeListener('canvas:failedtoloadurl', this._failedImageFromUrlListener);
        this.annotateService.removeListener('canvas:fresh:change', this._onCanvasFreshChange);
        this.annotateService.removeListener('canvas:imageReady', this._onCanvasImageReady);

        // Remove videoControlService listeners
        this.videoControlService.removeListener('video:isActive', this._onVideoIsActive);
        this.videoControlService.removeListener('video:ready', this._onVideoReady);
        this.videoControlService.removeListener('video:failedtoloadurl', this._failedVideoFromUrlListener);

        // Remove busy listeners
        this.busy.removeListener('busy', this._busyListener);
        this.busy.removeListener('free', this._freeListener);

        // Remove jsApiService listener
        this.jsApiService.removeListener('postResource', this._postResourceListener);
        this.browserUtilsService.saveToSessionStorage('runSpeedTestOnClient', false);
        this._resetSessionStorage();

        if (this.tsVideoSubscriberController) {
            this.tsVideoSubscriberController.destroy();
            this.tsVideoSubscriberController = null;
        }

        // Cleanup from connectToMeeting
        if (this._initialSyncHandler) {
            this.chatApi.off('sync', this._initialSyncHandler);
        }

        if (this.connectivityIssuePopupController && this._connectivityIssueCloseSessionListener) {
            this.connectivityIssuePopupController.off(
                ConnectivityIssueEvents.CLOSE_SESSION,
                this._connectivityIssueCloseSessionListener
            );
        }

        // Cleanup from _initHandlers / _initMeetingHandlers
        clearTimeout(this.observableTimeout);
        clearTimeout(this.observeTimeout);
        clearTimeout(this.alertMessageTimeout);
        this.jsApiService.reset();
        this._resetUnloadConfirmation();
        this.timeoutDialogController?.dispose();
        this.surveyModalController?.dispose();

        // Dispose MobX reactions
        if (this._disposeMobxReactions) {
            this._disposeMobxReactions.forEach((disposer) => disposer());
        }

        // Stop recording if needed
        if (this.dashboardState?.floatingToolbarState?.isRecordingEnabled) {
            if (this.isRecording) {
                this.stopRecording();
            }
        }
    }

    get showVideoWidget() {
        return (
            (!this.videoModeState.videoState.focus || !this.videoModeState.videoState.enabled) &&
            !(this.libraryTaggingMode && !this.preloadedVideo.resource) &&
            this.videoControlService.isActive
        );
    }

    // get showImageWidget() {)} move to dashboardState.showImageWidget

    get showWifiScanWidget() {
        return (
            (!this.videoModeState.videoState.focus || !this.videoModeState.videoState.enabled) &&
            !this.videoControlService.isActive
        );
    }

    imageLoaded(event) {
        const url = get(event, 'target.src');

        if (url) {
            this.chatApi.imageLoaded(url);
        }
    }

    // flattenedHistoryRecords moved to rightBarState as @computed

    getSnapshotReminderLocation() {
        const captureButton = document.getElementById('#ts-capture-image');

        if (!captureButton) {
            return {};
        }

        return captureButton.position();
    }

    getPreCameraApprovalImage = () => {
        const osName = get(this.chatApi, 'client.clientOsObject.name');
        const isIOS = !!osName.match(/ios/i);

        return `wizard/${isIOS ? 'iphone' : 'android'}/pre-camera-approval.png`;
    };

    shouldDisplayPause() {
        return (
            this.allowPauseByAgent &&
            (!this.isPaused || this.videoModeState.videoState.videoPausedByDashboard) &&
            !this.observe &&
            this.videoModeState.videoState.focus &&
            this.videoModeState.videoState.enabled &&
            this.mode !== MeetingMode.screen &&
            !(
                this.dashboardState.isToggleEnabled_ScanCaptureDesign &&
                this.videoModeState.videoState.mode === VIDEO_MODES.SCANNING
            )
        );
    }

    isScreenMeetingMode(mode) {
        return includes([MeetingMode.screen], mode);
    }

    isScreensharingMode(mode) {
        return utils.isModeSupportNativeVideoSharing(mode);
    }

    isVideoOrScreensharingMode(mode) {
        return utils.isVideoAvailableInMode(mode) || utils.isModeSupportNativeVideoSharing(mode);
    }

    showOneClickGuidance() {
        runInAction(() => {
            this.dashboardState.returnToOneClickGuidance = true;
        });
    }

    // Wrapper methods for dashboard functions to maintain proper binding when passed to React
    get isLoaderReconnecting() {
        const dashboard = this;
        return dashboard ? dashboard.dashboardState.displayLoaderReconnecting : false;
    }

    get enableIdleModeUsability() {
        return get(this.accountData, 'protectedSettings.enableIdleModeUsability');
    }

    getNetworkStatus() {
        const connectionType = get(this, 'dashboardState.clientNetworkInfo.connectionType');

        switch (connectionType.toUpperCase()) {
            case ConnectionTypesEnum.CELLULAR:
            case ConnectionTypesEnum.MOBILE_DATA:
                return ConnectionTypesEnum.MOBILE_DATA;
            case ConnectionTypesEnum.WIFI:
                return ConnectionTypesEnum.WIFI;
            default:
                return ConnectionTypesEnum.NETWORK;
        }
    }

    submitSearchTagForm(searchTerm) {
        this.searchForTags({searchTerm: searchTerm, $submitted: true});
    }

    videoResolutionChanged(resolutionFormat) {
        if (this.chatApi.dashboard.allowHD) {
            runInAction(() => {
                this.dashboardState.videoModeState.videoState.videoFormatResolution = resolutionFormat;
            });
        }
    }

    async magicMarkerCreated(triggeredByAgent) {
        if (!this.isMagicMarkerEnabled) {
            return;
        }

        if (triggeredByAgent && !this.triggeredDataCollectionOnAgentMagicMarkerEnabled) {
            return;
        }

        if (!triggeredByAgent && !this.triggeredDataCollectionOnCustomerMagicMarkerEnabled) {
            return;
        }

        const snapshot = await this._getSnapshotFromKnownStream({format: 'image/jpeg'});

        if (!snapshot) {
            return;
        }

        const snappedImg = this._snapshotToImg(snapshot.base64img);

        if (!snappedImg.size) {
            return;
        }

        const triggerSource = triggeredByAgent
            ? TriggeredDataCollectionSource.Agent
            : TriggeredDataCollectionSource.Customer;

        this.tsSharingService.uploadTriggeredCollectedImage(snappedImg.img, triggerSource);
    }

    handleTriggeredAgentImageSnapped(base64img) {
        if (!this.triggeredDataCollectionOnAgentImageSnappedEnabled) {
            return;
        }

        const snappedImg = this._snapshotToImg(base64img);

        if (!snappedImg.size) {
            return;
        }

        this.tsSharingService.uploadTriggeredCollectedImage(
            snappedImg.img,
            TriggeredDataCollectionSource.AgentImageSnapped
        );
    }

    @action
    openMobileMenuDropdownOpen = () => {
        this.dashboardState.mobileMenuDropdownOpen = !this.dashboardState.mobileMenuDropdownOpen;
    };

    @action
    openMiniMenuDropdownOpen = () => {
        this.dashboardState.miniMenuDropdownOpen = !this.dashboardState.miniMenuDropdownOpen;
    };

    @action
    closeMiniMenuDropdown = () => {
        this.dashboardState.miniMenuDropdownOpen = false;
    };

    @action
    closeCloseMenuDropdown = () => {
        this.dashboardState.miniMenuDropdownOpen = false;
    };

    @action
    closeMobileMenuDropdownOpen = () => {
        this.dashboardState.mobileMenuDropdownOpen = false;
    };
}
